/* eslint-disable */
var $t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gt(h) {
  return h && h.__esModule && Object.prototype.hasOwnProperty.call(h, "default") ? h.default : h;
}
function cn(h) {
  if (Object.prototype.hasOwnProperty.call(h, "__esModule")) return h;
  var n = h.default;
  if (typeof n == "function") {
    var s = function a() {
      var x = !1;
      try {
        x = this instanceof a;
      } catch {
      }
      return x ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    s.prototype = n.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(h).forEach(function(a) {
    var x = Object.getOwnPropertyDescriptor(h, a);
    Object.defineProperty(s, a, x.get ? x : {
      enumerable: !0,
      get: function() {
        return h[a];
      }
    });
  }), s;
}
var nt = { exports: {} }, un = nt.exports, wr;
function fn() {
  return wr || (wr = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a();
    })(un, (function() {
      var s = 1e3, a = 6e4, x = 36e5, u = "millisecond", g = "second", f = "minute", v = "hour", r = "day", i = "week", c = "month", l = "quarter", y = "year", C = "date", B = "Invalid Date", _ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(K) {
        var P = ["th", "st", "nd", "rd"], G = K % 100;
        return "[" + K + (P[(G - 20) % 10] || P[G] || P[0]) + "]";
      } }, D = function(K, P, G) {
        var V = String(K);
        return !V || V.length >= P ? K : "" + Array(P + 1 - V.length).join(G) + K;
      }, E = { s: D, z: function(K) {
        var P = -K.utcOffset(), G = Math.abs(P), V = Math.floor(G / 60), X = G % 60;
        return (P <= 0 ? "+" : "-") + D(V, 2, "0") + ":" + D(X, 2, "0");
      }, m: function K(P, G) {
        if (P.date() < G.date()) return -K(G, P);
        var V = 12 * (G.year() - P.year()) + (G.month() - P.month()), X = P.clone().add(V, c), Z = G - X < 0, j = P.clone().add(V + (Z ? -1 : 1), c);
        return +(-(V + (G - X) / (Z ? X - j : j - X)) || 0);
      }, a: function(K) {
        return K < 0 ? Math.ceil(K) || 0 : Math.floor(K);
      }, p: function(K) {
        return { M: c, y, w: i, d: r, D: C, h: v, m: f, s: g, ms: u, Q: l }[K] || String(K || "").toLowerCase().replace(/s$/, "");
      }, u: function(K) {
        return K === void 0;
      } }, w = "en", b = {};
      b[w] = A;
      var O = "$isDayjsObject", M = function(K) {
        return K instanceof N || !(!K || !K[O]);
      }, k = function K(P, G, V) {
        var X;
        if (!P) return w;
        if (typeof P == "string") {
          var Z = P.toLowerCase();
          b[Z] && (X = Z), G && (b[Z] = G, X = Z);
          var j = P.split("-");
          if (!X && j.length > 1) return K(j[0]);
        } else {
          var U = P.name;
          b[U] = P, X = U;
        }
        return !V && X && (w = X), X || !V && w;
      }, S = function(K, P) {
        if (M(K)) return K.clone();
        var G = typeof P == "object" ? P : {};
        return G.date = K, G.args = arguments, new N(G);
      }, T = E;
      T.l = k, T.i = M, T.w = function(K, P) {
        return S(K, { locale: P.$L, utc: P.$u, x: P.$x, $offset: P.$offset });
      };
      var N = (function() {
        function K(G) {
          this.$L = k(G.locale, null, !0), this.parse(G), this.$x = this.$x || G.x || {}, this[O] = !0;
        }
        var P = K.prototype;
        return P.parse = function(G) {
          this.$d = (function(V) {
            var X = V.date, Z = V.utc;
            if (X === null) return /* @__PURE__ */ new Date(NaN);
            if (T.u(X)) return /* @__PURE__ */ new Date();
            if (X instanceof Date) return new Date(X);
            if (typeof X == "string" && !/Z$/i.test(X)) {
              var j = X.match(_);
              if (j) {
                var U = j[2] - 1 || 0, q = (j[7] || "0").substring(0, 3);
                return Z ? new Date(Date.UTC(j[1], U, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, q)) : new Date(j[1], U, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, q);
              }
            }
            return new Date(X);
          })(G), this.init();
        }, P.init = function() {
          var G = this.$d;
          this.$y = G.getFullYear(), this.$M = G.getMonth(), this.$D = G.getDate(), this.$W = G.getDay(), this.$H = G.getHours(), this.$m = G.getMinutes(), this.$s = G.getSeconds(), this.$ms = G.getMilliseconds();
        }, P.$utils = function() {
          return T;
        }, P.isValid = function() {
          return this.$d.toString() !== B;
        }, P.isSame = function(G, V) {
          var X = S(G);
          return this.startOf(V) <= X && X <= this.endOf(V);
        }, P.isAfter = function(G, V) {
          return S(G) < this.startOf(V);
        }, P.isBefore = function(G, V) {
          return this.endOf(V) < S(G);
        }, P.$g = function(G, V, X) {
          return T.u(G) ? this[V] : this.set(X, G);
        }, P.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, P.valueOf = function() {
          return this.$d.getTime();
        }, P.startOf = function(G, V) {
          var X = this, Z = !!T.u(V) || V, j = T.p(G), U = function(xe, ce) {
            var ye = T.w(X.$u ? Date.UTC(X.$y, ce, xe) : new Date(X.$y, ce, xe), X);
            return Z ? ye : ye.endOf(r);
          }, q = function(xe, ce) {
            return T.w(X.toDate()[xe].apply(X.toDate("s"), (Z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ce)), X);
          }, W = this.$W, $ = this.$M, ie = this.$D, oe = "set" + (this.$u ? "UTC" : "");
          switch (j) {
            case y:
              return Z ? U(1, 0) : U(31, 11);
            case c:
              return Z ? U(1, $) : U(0, $ + 1);
            case i:
              var ae = this.$locale().weekStart || 0, re = (W < ae ? W + 7 : W) - ae;
              return U(Z ? ie - re : ie + (6 - re), $);
            case r:
            case C:
              return q(oe + "Hours", 0);
            case v:
              return q(oe + "Minutes", 1);
            case f:
              return q(oe + "Seconds", 2);
            case g:
              return q(oe + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, P.endOf = function(G) {
          return this.startOf(G, !1);
        }, P.$set = function(G, V) {
          var X, Z = T.p(G), j = "set" + (this.$u ? "UTC" : ""), U = (X = {}, X[r] = j + "Date", X[C] = j + "Date", X[c] = j + "Month", X[y] = j + "FullYear", X[v] = j + "Hours", X[f] = j + "Minutes", X[g] = j + "Seconds", X[u] = j + "Milliseconds", X)[Z], q = Z === r ? this.$D + (V - this.$W) : V;
          if (Z === c || Z === y) {
            var W = this.clone().set(C, 1);
            W.$d[U](q), W.init(), this.$d = W.set(C, Math.min(this.$D, W.daysInMonth())).$d;
          } else U && this.$d[U](q);
          return this.init(), this;
        }, P.set = function(G, V) {
          return this.clone().$set(G, V);
        }, P.get = function(G) {
          return this[T.p(G)]();
        }, P.add = function(G, V) {
          var X, Z = this;
          G = Number(G);
          var j = T.p(V), U = function($) {
            var ie = S(Z);
            return T.w(ie.date(ie.date() + Math.round($ * G)), Z);
          };
          if (j === c) return this.set(c, this.$M + G);
          if (j === y) return this.set(y, this.$y + G);
          if (j === r) return U(1);
          if (j === i) return U(7);
          var q = (X = {}, X[f] = a, X[v] = x, X[g] = s, X)[j] || 1, W = this.$d.getTime() + G * q;
          return T.w(W, this);
        }, P.subtract = function(G, V) {
          return this.add(-1 * G, V);
        }, P.format = function(G) {
          var V = this, X = this.$locale();
          if (!this.isValid()) return X.invalidDate || B;
          var Z = G || "YYYY-MM-DDTHH:mm:ssZ", j = T.z(this), U = this.$H, q = this.$m, W = this.$M, $ = X.weekdays, ie = X.months, oe = X.meridiem, ae = function(ce, ye, ge, ue) {
            return ce && (ce[ye] || ce(V, Z)) || ge[ye].slice(0, ue);
          }, re = function(ce) {
            return T.s(U % 12 || 12, ce, "0");
          }, xe = oe || function(ce, ye, ge) {
            var ue = ce < 12 ? "AM" : "PM";
            return ge ? ue.toLowerCase() : ue;
          };
          return Z.replace(I, (function(ce, ye) {
            return ye || (function(ge) {
              switch (ge) {
                case "YY":
                  return String(V.$y).slice(-2);
                case "YYYY":
                  return T.s(V.$y, 4, "0");
                case "M":
                  return W + 1;
                case "MM":
                  return T.s(W + 1, 2, "0");
                case "MMM":
                  return ae(X.monthsShort, W, ie, 3);
                case "MMMM":
                  return ae(ie, W);
                case "D":
                  return V.$D;
                case "DD":
                  return T.s(V.$D, 2, "0");
                case "d":
                  return String(V.$W);
                case "dd":
                  return ae(X.weekdaysMin, V.$W, $, 2);
                case "ddd":
                  return ae(X.weekdaysShort, V.$W, $, 3);
                case "dddd":
                  return $[V.$W];
                case "H":
                  return String(U);
                case "HH":
                  return T.s(U, 2, "0");
                case "h":
                  return re(1);
                case "hh":
                  return re(2);
                case "a":
                  return xe(U, q, !0);
                case "A":
                  return xe(U, q, !1);
                case "m":
                  return String(q);
                case "mm":
                  return T.s(q, 2, "0");
                case "s":
                  return String(V.$s);
                case "ss":
                  return T.s(V.$s, 2, "0");
                case "SSS":
                  return T.s(V.$ms, 3, "0");
                case "Z":
                  return j;
              }
              return null;
            })(ce) || j.replace(":", "");
          }));
        }, P.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, P.diff = function(G, V, X) {
          var Z, j = this, U = T.p(V), q = S(G), W = (q.utcOffset() - this.utcOffset()) * a, $ = this - q, ie = function() {
            return T.m(j, q);
          };
          switch (U) {
            case y:
              Z = ie() / 12;
              break;
            case c:
              Z = ie();
              break;
            case l:
              Z = ie() / 3;
              break;
            case i:
              Z = ($ - W) / 6048e5;
              break;
            case r:
              Z = ($ - W) / 864e5;
              break;
            case v:
              Z = $ / x;
              break;
            case f:
              Z = $ / a;
              break;
            case g:
              Z = $ / s;
              break;
            default:
              Z = $;
          }
          return X ? Z : T.a(Z);
        }, P.daysInMonth = function() {
          return this.endOf(c).$D;
        }, P.$locale = function() {
          return b[this.$L];
        }, P.locale = function(G, V) {
          if (!G) return this.$L;
          var X = this.clone(), Z = k(G, V, !0);
          return Z && (X.$L = Z), X;
        }, P.clone = function() {
          return T.w(this.$d, this);
        }, P.toDate = function() {
          return new Date(this.valueOf());
        }, P.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, P.toISOString = function() {
          return this.$d.toISOString();
        }, P.toString = function() {
          return this.$d.toUTCString();
        }, K;
      })(), L = N.prototype;
      return S.prototype = L, [["$ms", u], ["$s", g], ["$m", f], ["$H", v], ["$W", r], ["$M", c], ["$y", y], ["$D", C]].forEach((function(K) {
        L[K[1]] = function(P) {
          return this.$g(P, K[0], K[1]);
        };
      })), S.extend = function(K, P) {
        return K.$i || (K(P, N, S), K.$i = !0), S;
      }, S.locale = k, S.isDayjs = M, S.unix = function(K) {
        return S(1e3 * K);
      }, S.en = b[w], S.Ls = b, S.p = {}, S;
    }));
  })(nt)), nt.exports;
}
var ln = fn();
const Fr = /* @__PURE__ */ Gt(ln);
var Wt = {}, $e = {}, br;
function hn() {
  if (br) return $e;
  br = 1, $e.byteLength = f, $e.toByteArray = r, $e.fromByteArray = l;
  for (var h = [], n = [], s = typeof Uint8Array < "u" ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", x = 0, u = a.length; x < u; ++x)
    h[x] = a[x], n[a.charCodeAt(x)] = x;
  n[45] = 62, n[95] = 63;
  function g(y) {
    var C = y.length;
    if (C % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var B = y.indexOf("=");
    B === -1 && (B = C);
    var _ = B === C ? 0 : 4 - B % 4;
    return [B, _];
  }
  function f(y) {
    var C = g(y), B = C[0], _ = C[1];
    return (B + _) * 3 / 4 - _;
  }
  function v(y, C, B) {
    return (C + B) * 3 / 4 - B;
  }
  function r(y) {
    var C, B = g(y), _ = B[0], I = B[1], A = new s(v(y, _, I)), D = 0, E = I > 0 ? _ - 4 : _, w;
    for (w = 0; w < E; w += 4)
      C = n[y.charCodeAt(w)] << 18 | n[y.charCodeAt(w + 1)] << 12 | n[y.charCodeAt(w + 2)] << 6 | n[y.charCodeAt(w + 3)], A[D++] = C >> 16 & 255, A[D++] = C >> 8 & 255, A[D++] = C & 255;
    return I === 2 && (C = n[y.charCodeAt(w)] << 2 | n[y.charCodeAt(w + 1)] >> 4, A[D++] = C & 255), I === 1 && (C = n[y.charCodeAt(w)] << 10 | n[y.charCodeAt(w + 1)] << 4 | n[y.charCodeAt(w + 2)] >> 2, A[D++] = C >> 8 & 255, A[D++] = C & 255), A;
  }
  function i(y) {
    return h[y >> 18 & 63] + h[y >> 12 & 63] + h[y >> 6 & 63] + h[y & 63];
  }
  function c(y, C, B) {
    for (var _, I = [], A = C; A < B; A += 3)
      _ = (y[A] << 16 & 16711680) + (y[A + 1] << 8 & 65280) + (y[A + 2] & 255), I.push(i(_));
    return I.join("");
  }
  function l(y) {
    for (var C, B = y.length, _ = B % 3, I = [], A = 16383, D = 0, E = B - _; D < E; D += A)
      I.push(c(y, D, D + A > E ? E : D + A));
    return _ === 1 ? (C = y[B - 1], I.push(
      h[C >> 2] + h[C << 4 & 63] + "=="
    )) : _ === 2 && (C = (y[B - 2] << 8) + y[B - 1], I.push(
      h[C >> 10] + h[C >> 4 & 63] + h[C << 2 & 63] + "="
    )), I.join("");
  }
  return $e;
}
var ze = {};
var Sr;
function xn() {
  return Sr || (Sr = 1, ze.read = function(h, n, s, a, x) {
    var u, g, f = x * 8 - a - 1, v = (1 << f) - 1, r = v >> 1, i = -7, c = s ? x - 1 : 0, l = s ? -1 : 1, y = h[n + c];
    for (c += l, u = y & (1 << -i) - 1, y >>= -i, i += f; i > 0; u = u * 256 + h[n + c], c += l, i -= 8)
      ;
    for (g = u & (1 << -i) - 1, u >>= -i, i += a; i > 0; g = g * 256 + h[n + c], c += l, i -= 8)
      ;
    if (u === 0)
      u = 1 - r;
    else {
      if (u === v)
        return g ? NaN : (y ? -1 : 1) * (1 / 0);
      g = g + Math.pow(2, a), u = u - r;
    }
    return (y ? -1 : 1) * g * Math.pow(2, u - a);
  }, ze.write = function(h, n, s, a, x, u) {
    var g, f, v, r = u * 8 - x - 1, i = (1 << r) - 1, c = i >> 1, l = x === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = a ? 0 : u - 1, C = a ? 1 : -1, B = n < 0 || n === 0 && 1 / n < 0 ? 1 : 0;
    for (n = Math.abs(n), isNaN(n) || n === 1 / 0 ? (f = isNaN(n) ? 1 : 0, g = i) : (g = Math.floor(Math.log(n) / Math.LN2), n * (v = Math.pow(2, -g)) < 1 && (g--, v *= 2), g + c >= 1 ? n += l / v : n += l * Math.pow(2, 1 - c), n * v >= 2 && (g++, v /= 2), g + c >= i ? (f = 0, g = i) : g + c >= 1 ? (f = (n * v - 1) * Math.pow(2, x), g = g + c) : (f = n * Math.pow(2, c - 1) * Math.pow(2, x), g = 0)); x >= 8; h[s + y] = f & 255, y += C, f /= 256, x -= 8)
      ;
    for (g = g << x | f, r += x; r > 0; h[s + y] = g & 255, y += C, g /= 256, r -= 8)
      ;
    h[s + y - C] |= B * 128;
  }), ze;
}
var Rr;
function pn() {
  return Rr || (Rr = 1, (function(h) {
    const n = hn(), s = xn(), a = typeof Symbol == "function" && typeof Symbol.for == "function" ? /* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom") : null;
    h.Buffer = f, h.SlowBuffer = A, h.INSPECT_MAX_BYTES = 50;
    const x = 2147483647;
    h.kMaxLength = x, f.TYPED_ARRAY_SUPPORT = u(), !f.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function u() {
      try {
        const o = new Uint8Array(1), e = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(e, Uint8Array.prototype), Object.setPrototypeOf(o, e), o.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(f.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (f.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(f.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (f.isBuffer(this))
          return this.byteOffset;
      }
    });
    function g(o) {
      if (o > x)
        throw new RangeError('The value "' + o + '" is invalid for option "size"');
      const e = new Uint8Array(o);
      return Object.setPrototypeOf(e, f.prototype), e;
    }
    function f(o, e, t) {
      if (typeof o == "number") {
        if (typeof e == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return c(o);
      }
      return v(o, e, t);
    }
    f.poolSize = 8192;
    function v(o, e, t) {
      if (typeof o == "string")
        return l(o, e);
      if (ArrayBuffer.isView(o))
        return C(o);
      if (o == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof o
        );
      if (fe(o, ArrayBuffer) || o && fe(o.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (fe(o, SharedArrayBuffer) || o && fe(o.buffer, SharedArrayBuffer)))
        return B(o, e, t);
      if (typeof o == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const d = o.valueOf && o.valueOf();
      if (d != null && d !== o)
        return f.from(d, e, t);
      const m = _(o);
      if (m) return m;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof o[Symbol.toPrimitive] == "function")
        return f.from(o[Symbol.toPrimitive]("string"), e, t);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof o
      );
    }
    f.from = function(o, e, t) {
      return v(o, e, t);
    }, Object.setPrototypeOf(f.prototype, Uint8Array.prototype), Object.setPrototypeOf(f, Uint8Array);
    function r(o) {
      if (typeof o != "number")
        throw new TypeError('"size" argument must be of type number');
      if (o < 0)
        throw new RangeError('The value "' + o + '" is invalid for option "size"');
    }
    function i(o, e, t) {
      return r(o), o <= 0 ? g(o) : e !== void 0 ? typeof t == "string" ? g(o).fill(e, t) : g(o).fill(e) : g(o);
    }
    f.alloc = function(o, e, t) {
      return i(o, e, t);
    };
    function c(o) {
      return r(o), g(o < 0 ? 0 : I(o) | 0);
    }
    f.allocUnsafe = function(o) {
      return c(o);
    }, f.allocUnsafeSlow = function(o) {
      return c(o);
    };
    function l(o, e) {
      if ((typeof e != "string" || e === "") && (e = "utf8"), !f.isEncoding(e))
        throw new TypeError("Unknown encoding: " + e);
      const t = D(o, e) | 0;
      let d = g(t);
      const m = d.write(o, e);
      return m !== t && (d = d.slice(0, m)), d;
    }
    function y(o) {
      const e = o.length < 0 ? 0 : I(o.length) | 0, t = g(e);
      for (let d = 0; d < e; d += 1)
        t[d] = o[d] & 255;
      return t;
    }
    function C(o) {
      if (fe(o, Uint8Array)) {
        const e = new Uint8Array(o);
        return B(e.buffer, e.byteOffset, e.byteLength);
      }
      return y(o);
    }
    function B(o, e, t) {
      if (e < 0 || o.byteLength < e)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (o.byteLength < e + (t || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let d;
      return e === void 0 && t === void 0 ? d = new Uint8Array(o) : t === void 0 ? d = new Uint8Array(o, e) : d = new Uint8Array(o, e, t), Object.setPrototypeOf(d, f.prototype), d;
    }
    function _(o) {
      if (f.isBuffer(o)) {
        const e = I(o.length) | 0, t = g(e);
        return t.length === 0 || o.copy(t, 0, 0, e), t;
      }
      if (o.length !== void 0)
        return typeof o.length != "number" || Be(o.length) ? g(0) : y(o);
      if (o.type === "Buffer" && Array.isArray(o.data))
        return y(o.data);
    }
    function I(o) {
      if (o >= x)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + x.toString(16) + " bytes");
      return o | 0;
    }
    function A(o) {
      return +o != o && (o = 0), f.alloc(+o);
    }
    f.isBuffer = function(e) {
      return e != null && e._isBuffer === !0 && e !== f.prototype;
    }, f.compare = function(e, t) {
      if (fe(e, Uint8Array) && (e = f.from(e, e.offset, e.byteLength)), fe(t, Uint8Array) && (t = f.from(t, t.offset, t.byteLength)), !f.isBuffer(e) || !f.isBuffer(t))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (e === t) return 0;
      let d = e.length, m = t.length;
      for (let F = 0, R = Math.min(d, m); F < R; ++F)
        if (e[F] !== t[F]) {
          d = e[F], m = t[F];
          break;
        }
      return d < m ? -1 : m < d ? 1 : 0;
    }, f.isEncoding = function(e) {
      switch (String(e).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, f.concat = function(e, t) {
      if (!Array.isArray(e))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (e.length === 0)
        return f.alloc(0);
      let d;
      if (t === void 0)
        for (t = 0, d = 0; d < e.length; ++d)
          t += e[d].length;
      const m = f.allocUnsafe(t);
      let F = 0;
      for (d = 0; d < e.length; ++d) {
        let R = e[d];
        if (fe(R, Uint8Array))
          F + R.length > m.length ? (f.isBuffer(R) || (R = f.from(R)), R.copy(m, F)) : Uint8Array.prototype.set.call(
            m,
            R,
            F
          );
        else if (f.isBuffer(R))
          R.copy(m, F);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        F += R.length;
      }
      return m;
    };
    function D(o, e) {
      if (f.isBuffer(o))
        return o.length;
      if (ArrayBuffer.isView(o) || fe(o, ArrayBuffer))
        return o.byteLength;
      if (typeof o != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof o
        );
      const t = o.length, d = arguments.length > 2 && arguments[2] === !0;
      if (!d && t === 0) return 0;
      let m = !1;
      for (; ; )
        switch (e) {
          case "ascii":
          case "latin1":
          case "binary":
            return t;
          case "utf8":
          case "utf-8":
            return we(o).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return t * 2;
          case "hex":
            return t >>> 1;
          case "base64":
            return Ae(o).length;
          default:
            if (m)
              return d ? -1 : we(o).length;
            e = ("" + e).toLowerCase(), m = !0;
        }
    }
    f.byteLength = D;
    function E(o, e, t) {
      let d = !1;
      if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
        return "";
      for (o || (o = "utf8"); ; )
        switch (o) {
          case "hex":
            return Z(this, e, t);
          case "utf8":
          case "utf-8":
            return K(this, e, t);
          case "ascii":
            return V(this, e, t);
          case "latin1":
          case "binary":
            return X(this, e, t);
          case "base64":
            return L(this, e, t);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return j(this, e, t);
          default:
            if (d) throw new TypeError("Unknown encoding: " + o);
            o = (o + "").toLowerCase(), d = !0;
        }
    }
    f.prototype._isBuffer = !0;
    function w(o, e, t) {
      const d = o[e];
      o[e] = o[t], o[t] = d;
    }
    f.prototype.swap16 = function() {
      const e = this.length;
      if (e % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let t = 0; t < e; t += 2)
        w(this, t, t + 1);
      return this;
    }, f.prototype.swap32 = function() {
      const e = this.length;
      if (e % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let t = 0; t < e; t += 4)
        w(this, t, t + 3), w(this, t + 1, t + 2);
      return this;
    }, f.prototype.swap64 = function() {
      const e = this.length;
      if (e % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let t = 0; t < e; t += 8)
        w(this, t, t + 7), w(this, t + 1, t + 6), w(this, t + 2, t + 5), w(this, t + 3, t + 4);
      return this;
    }, f.prototype.toString = function() {
      const e = this.length;
      return e === 0 ? "" : arguments.length === 0 ? K(this, 0, e) : E.apply(this, arguments);
    }, f.prototype.toLocaleString = f.prototype.toString, f.prototype.equals = function(e) {
      if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
      return this === e ? !0 : f.compare(this, e) === 0;
    }, f.prototype.inspect = function() {
      let e = "";
      const t = h.INSPECT_MAX_BYTES;
      return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
    }, a && (f.prototype[a] = f.prototype.inspect), f.prototype.compare = function(e, t, d, m, F) {
      if (fe(e, Uint8Array) && (e = f.from(e, e.offset, e.byteLength)), !f.isBuffer(e))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e
        );
      if (t === void 0 && (t = 0), d === void 0 && (d = e ? e.length : 0), m === void 0 && (m = 0), F === void 0 && (F = this.length), t < 0 || d > e.length || m < 0 || F > this.length)
        throw new RangeError("out of range index");
      if (m >= F && t >= d)
        return 0;
      if (m >= F)
        return -1;
      if (t >= d)
        return 1;
      if (t >>>= 0, d >>>= 0, m >>>= 0, F >>>= 0, this === e) return 0;
      let R = F - m, H = d - t;
      const J = Math.min(R, H), Y = this.slice(m, F), Q = e.slice(t, d);
      for (let ee = 0; ee < J; ++ee)
        if (Y[ee] !== Q[ee]) {
          R = Y[ee], H = Q[ee];
          break;
        }
      return R < H ? -1 : H < R ? 1 : 0;
    };
    function b(o, e, t, d, m) {
      if (o.length === 0) return -1;
      if (typeof t == "string" ? (d = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, Be(t) && (t = m ? 0 : o.length - 1), t < 0 && (t = o.length + t), t >= o.length) {
        if (m) return -1;
        t = o.length - 1;
      } else if (t < 0)
        if (m) t = 0;
        else return -1;
      if (typeof e == "string" && (e = f.from(e, d)), f.isBuffer(e))
        return e.length === 0 ? -1 : O(o, e, t, d, m);
      if (typeof e == "number")
        return e = e & 255, typeof Uint8Array.prototype.indexOf == "function" ? m ? Uint8Array.prototype.indexOf.call(o, e, t) : Uint8Array.prototype.lastIndexOf.call(o, e, t) : O(o, [e], t, d, m);
      throw new TypeError("val must be string, number or Buffer");
    }
    function O(o, e, t, d, m) {
      let F = 1, R = o.length, H = e.length;
      if (d !== void 0 && (d = String(d).toLowerCase(), d === "ucs2" || d === "ucs-2" || d === "utf16le" || d === "utf-16le")) {
        if (o.length < 2 || e.length < 2)
          return -1;
        F = 2, R /= 2, H /= 2, t /= 2;
      }
      function J(Q, ee) {
        return F === 1 ? Q[ee] : Q.readUInt16BE(ee * F);
      }
      let Y;
      if (m) {
        let Q = -1;
        for (Y = t; Y < R; Y++)
          if (J(o, Y) === J(e, Q === -1 ? 0 : Y - Q)) {
            if (Q === -1 && (Q = Y), Y - Q + 1 === H) return Q * F;
          } else
            Q !== -1 && (Y -= Y - Q), Q = -1;
      } else
        for (t + H > R && (t = R - H), Y = t; Y >= 0; Y--) {
          let Q = !0;
          for (let ee = 0; ee < H; ee++)
            if (J(o, Y + ee) !== J(e, ee)) {
              Q = !1;
              break;
            }
          if (Q) return Y;
        }
      return -1;
    }
    f.prototype.includes = function(e, t, d) {
      return this.indexOf(e, t, d) !== -1;
    }, f.prototype.indexOf = function(e, t, d) {
      return b(this, e, t, d, !0);
    }, f.prototype.lastIndexOf = function(e, t, d) {
      return b(this, e, t, d, !1);
    };
    function M(o, e, t, d) {
      t = Number(t) || 0;
      const m = o.length - t;
      d ? (d = Number(d), d > m && (d = m)) : d = m;
      const F = e.length;
      d > F / 2 && (d = F / 2);
      let R;
      for (R = 0; R < d; ++R) {
        const H = parseInt(e.substr(R * 2, 2), 16);
        if (Be(H)) return R;
        o[t + R] = H;
      }
      return R;
    }
    function k(o, e, t, d) {
      return pe(we(e, o.length - t), o, t, d);
    }
    function S(o, e, t, d) {
      return pe(Fe(e), o, t, d);
    }
    function T(o, e, t, d) {
      return pe(Ae(e), o, t, d);
    }
    function N(o, e, t, d) {
      return pe(Ne(e, o.length - t), o, t, d);
    }
    f.prototype.write = function(e, t, d, m) {
      if (t === void 0)
        m = "utf8", d = this.length, t = 0;
      else if (d === void 0 && typeof t == "string")
        m = t, d = this.length, t = 0;
      else if (isFinite(t))
        t = t >>> 0, isFinite(d) ? (d = d >>> 0, m === void 0 && (m = "utf8")) : (m = d, d = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const F = this.length - t;
      if ((d === void 0 || d > F) && (d = F), e.length > 0 && (d < 0 || t < 0) || t > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      m || (m = "utf8");
      let R = !1;
      for (; ; )
        switch (m) {
          case "hex":
            return M(this, e, t, d);
          case "utf8":
          case "utf-8":
            return k(this, e, t, d);
          case "ascii":
          case "latin1":
          case "binary":
            return S(this, e, t, d);
          case "base64":
            return T(this, e, t, d);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return N(this, e, t, d);
          default:
            if (R) throw new TypeError("Unknown encoding: " + m);
            m = ("" + m).toLowerCase(), R = !0;
        }
    }, f.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function L(o, e, t) {
      return e === 0 && t === o.length ? n.fromByteArray(o) : n.fromByteArray(o.slice(e, t));
    }
    function K(o, e, t) {
      t = Math.min(o.length, t);
      const d = [];
      let m = e;
      for (; m < t; ) {
        const F = o[m];
        let R = null, H = F > 239 ? 4 : F > 223 ? 3 : F > 191 ? 2 : 1;
        if (m + H <= t) {
          let J, Y, Q, ee;
          switch (H) {
            case 1:
              F < 128 && (R = F);
              break;
            case 2:
              J = o[m + 1], (J & 192) === 128 && (ee = (F & 31) << 6 | J & 63, ee > 127 && (R = ee));
              break;
            case 3:
              J = o[m + 1], Y = o[m + 2], (J & 192) === 128 && (Y & 192) === 128 && (ee = (F & 15) << 12 | (J & 63) << 6 | Y & 63, ee > 2047 && (ee < 55296 || ee > 57343) && (R = ee));
              break;
            case 4:
              J = o[m + 1], Y = o[m + 2], Q = o[m + 3], (J & 192) === 128 && (Y & 192) === 128 && (Q & 192) === 128 && (ee = (F & 15) << 18 | (J & 63) << 12 | (Y & 63) << 6 | Q & 63, ee > 65535 && ee < 1114112 && (R = ee));
          }
        }
        R === null ? (R = 65533, H = 1) : R > 65535 && (R -= 65536, d.push(R >>> 10 & 1023 | 55296), R = 56320 | R & 1023), d.push(R), m += H;
      }
      return G(d);
    }
    const P = 4096;
    function G(o) {
      const e = o.length;
      if (e <= P)
        return String.fromCharCode.apply(String, o);
      let t = "", d = 0;
      for (; d < e; )
        t += String.fromCharCode.apply(
          String,
          o.slice(d, d += P)
        );
      return t;
    }
    function V(o, e, t) {
      let d = "";
      t = Math.min(o.length, t);
      for (let m = e; m < t; ++m)
        d += String.fromCharCode(o[m] & 127);
      return d;
    }
    function X(o, e, t) {
      let d = "";
      t = Math.min(o.length, t);
      for (let m = e; m < t; ++m)
        d += String.fromCharCode(o[m]);
      return d;
    }
    function Z(o, e, t) {
      const d = o.length;
      (!e || e < 0) && (e = 0), (!t || t < 0 || t > d) && (t = d);
      let m = "";
      for (let F = e; F < t; ++F)
        m += ne[o[F]];
      return m;
    }
    function j(o, e, t) {
      const d = o.slice(e, t);
      let m = "";
      for (let F = 0; F < d.length - 1; F += 2)
        m += String.fromCharCode(d[F] + d[F + 1] * 256);
      return m;
    }
    f.prototype.slice = function(e, t) {
      const d = this.length;
      e = ~~e, t = t === void 0 ? d : ~~t, e < 0 ? (e += d, e < 0 && (e = 0)) : e > d && (e = d), t < 0 ? (t += d, t < 0 && (t = 0)) : t > d && (t = d), t < e && (t = e);
      const m = this.subarray(e, t);
      return Object.setPrototypeOf(m, f.prototype), m;
    };
    function U(o, e, t) {
      if (o % 1 !== 0 || o < 0) throw new RangeError("offset is not uint");
      if (o + e > t) throw new RangeError("Trying to access beyond buffer length");
    }
    f.prototype.readUintLE = f.prototype.readUIntLE = function(e, t, d) {
      e = e >>> 0, t = t >>> 0, d || U(e, t, this.length);
      let m = this[e], F = 1, R = 0;
      for (; ++R < t && (F *= 256); )
        m += this[e + R] * F;
      return m;
    }, f.prototype.readUintBE = f.prototype.readUIntBE = function(e, t, d) {
      e = e >>> 0, t = t >>> 0, d || U(e, t, this.length);
      let m = this[e + --t], F = 1;
      for (; t > 0 && (F *= 256); )
        m += this[e + --t] * F;
      return m;
    }, f.prototype.readUint8 = f.prototype.readUInt8 = function(e, t) {
      return e = e >>> 0, t || U(e, 1, this.length), this[e];
    }, f.prototype.readUint16LE = f.prototype.readUInt16LE = function(e, t) {
      return e = e >>> 0, t || U(e, 2, this.length), this[e] | this[e + 1] << 8;
    }, f.prototype.readUint16BE = f.prototype.readUInt16BE = function(e, t) {
      return e = e >>> 0, t || U(e, 2, this.length), this[e] << 8 | this[e + 1];
    }, f.prototype.readUint32LE = f.prototype.readUInt32LE = function(e, t) {
      return e = e >>> 0, t || U(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
    }, f.prototype.readUint32BE = f.prototype.readUInt32BE = function(e, t) {
      return e = e >>> 0, t || U(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
    }, f.prototype.readBigUInt64LE = de(function(e) {
      e = e >>> 0, ue(e, "offset");
      const t = this[e], d = this[e + 7];
      (t === void 0 || d === void 0) && he(e, this.length - 8);
      const m = t + this[++e] * 2 ** 8 + this[++e] * 2 ** 16 + this[++e] * 2 ** 24, F = this[++e] + this[++e] * 2 ** 8 + this[++e] * 2 ** 16 + d * 2 ** 24;
      return BigInt(m) + (BigInt(F) << BigInt(32));
    }), f.prototype.readBigUInt64BE = de(function(e) {
      e = e >>> 0, ue(e, "offset");
      const t = this[e], d = this[e + 7];
      (t === void 0 || d === void 0) && he(e, this.length - 8);
      const m = t * 2 ** 24 + this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + this[++e], F = this[++e] * 2 ** 24 + this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + d;
      return (BigInt(m) << BigInt(32)) + BigInt(F);
    }), f.prototype.readIntLE = function(e, t, d) {
      e = e >>> 0, t = t >>> 0, d || U(e, t, this.length);
      let m = this[e], F = 1, R = 0;
      for (; ++R < t && (F *= 256); )
        m += this[e + R] * F;
      return F *= 128, m >= F && (m -= Math.pow(2, 8 * t)), m;
    }, f.prototype.readIntBE = function(e, t, d) {
      e = e >>> 0, t = t >>> 0, d || U(e, t, this.length);
      let m = t, F = 1, R = this[e + --m];
      for (; m > 0 && (F *= 256); )
        R += this[e + --m] * F;
      return F *= 128, R >= F && (R -= Math.pow(2, 8 * t)), R;
    }, f.prototype.readInt8 = function(e, t) {
      return e = e >>> 0, t || U(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
    }, f.prototype.readInt16LE = function(e, t) {
      e = e >>> 0, t || U(e, 2, this.length);
      const d = this[e] | this[e + 1] << 8;
      return d & 32768 ? d | 4294901760 : d;
    }, f.prototype.readInt16BE = function(e, t) {
      e = e >>> 0, t || U(e, 2, this.length);
      const d = this[e + 1] | this[e] << 8;
      return d & 32768 ? d | 4294901760 : d;
    }, f.prototype.readInt32LE = function(e, t) {
      return e = e >>> 0, t || U(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
    }, f.prototype.readInt32BE = function(e, t) {
      return e = e >>> 0, t || U(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
    }, f.prototype.readBigInt64LE = de(function(e) {
      e = e >>> 0, ue(e, "offset");
      const t = this[e], d = this[e + 7];
      (t === void 0 || d === void 0) && he(e, this.length - 8);
      const m = this[e + 4] + this[e + 5] * 2 ** 8 + this[e + 6] * 2 ** 16 + (d << 24);
      return (BigInt(m) << BigInt(32)) + BigInt(t + this[++e] * 2 ** 8 + this[++e] * 2 ** 16 + this[++e] * 2 ** 24);
    }), f.prototype.readBigInt64BE = de(function(e) {
      e = e >>> 0, ue(e, "offset");
      const t = this[e], d = this[e + 7];
      (t === void 0 || d === void 0) && he(e, this.length - 8);
      const m = (t << 24) + // Overflow
      this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + this[++e];
      return (BigInt(m) << BigInt(32)) + BigInt(this[++e] * 2 ** 24 + this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + d);
    }), f.prototype.readFloatLE = function(e, t) {
      return e = e >>> 0, t || U(e, 4, this.length), s.read(this, e, !0, 23, 4);
    }, f.prototype.readFloatBE = function(e, t) {
      return e = e >>> 0, t || U(e, 4, this.length), s.read(this, e, !1, 23, 4);
    }, f.prototype.readDoubleLE = function(e, t) {
      return e = e >>> 0, t || U(e, 8, this.length), s.read(this, e, !0, 52, 8);
    }, f.prototype.readDoubleBE = function(e, t) {
      return e = e >>> 0, t || U(e, 8, this.length), s.read(this, e, !1, 52, 8);
    };
    function q(o, e, t, d, m, F) {
      if (!f.isBuffer(o)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (e > m || e < F) throw new RangeError('"value" argument is out of bounds');
      if (t + d > o.length) throw new RangeError("Index out of range");
    }
    f.prototype.writeUintLE = f.prototype.writeUIntLE = function(e, t, d, m) {
      if (e = +e, t = t >>> 0, d = d >>> 0, !m) {
        const H = Math.pow(2, 8 * d) - 1;
        q(this, e, t, d, H, 0);
      }
      let F = 1, R = 0;
      for (this[t] = e & 255; ++R < d && (F *= 256); )
        this[t + R] = e / F & 255;
      return t + d;
    }, f.prototype.writeUintBE = f.prototype.writeUIntBE = function(e, t, d, m) {
      if (e = +e, t = t >>> 0, d = d >>> 0, !m) {
        const H = Math.pow(2, 8 * d) - 1;
        q(this, e, t, d, H, 0);
      }
      let F = d - 1, R = 1;
      for (this[t + F] = e & 255; --F >= 0 && (R *= 256); )
        this[t + F] = e / R & 255;
      return t + d;
    }, f.prototype.writeUint8 = f.prototype.writeUInt8 = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 1, 255, 0), this[t] = e & 255, t + 1;
    }, f.prototype.writeUint16LE = f.prototype.writeUInt16LE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 2, 65535, 0), this[t] = e & 255, this[t + 1] = e >>> 8, t + 2;
    }, f.prototype.writeUint16BE = f.prototype.writeUInt16BE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = e & 255, t + 2;
    }, f.prototype.writeUint32LE = f.prototype.writeUInt32LE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255, t + 4;
    }, f.prototype.writeUint32BE = f.prototype.writeUInt32BE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255, t + 4;
    };
    function W(o, e, t, d, m) {
      ge(e, d, m, o, t, 7);
      let F = Number(e & BigInt(4294967295));
      o[t++] = F, F = F >> 8, o[t++] = F, F = F >> 8, o[t++] = F, F = F >> 8, o[t++] = F;
      let R = Number(e >> BigInt(32) & BigInt(4294967295));
      return o[t++] = R, R = R >> 8, o[t++] = R, R = R >> 8, o[t++] = R, R = R >> 8, o[t++] = R, t;
    }
    function $(o, e, t, d, m) {
      ge(e, d, m, o, t, 7);
      let F = Number(e & BigInt(4294967295));
      o[t + 7] = F, F = F >> 8, o[t + 6] = F, F = F >> 8, o[t + 5] = F, F = F >> 8, o[t + 4] = F;
      let R = Number(e >> BigInt(32) & BigInt(4294967295));
      return o[t + 3] = R, R = R >> 8, o[t + 2] = R, R = R >> 8, o[t + 1] = R, R = R >> 8, o[t] = R, t + 8;
    }
    f.prototype.writeBigUInt64LE = de(function(e, t = 0) {
      return W(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
    }), f.prototype.writeBigUInt64BE = de(function(e, t = 0) {
      return $(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
    }), f.prototype.writeIntLE = function(e, t, d, m) {
      if (e = +e, t = t >>> 0, !m) {
        const J = Math.pow(2, 8 * d - 1);
        q(this, e, t, d, J - 1, -J);
      }
      let F = 0, R = 1, H = 0;
      for (this[t] = e & 255; ++F < d && (R *= 256); )
        e < 0 && H === 0 && this[t + F - 1] !== 0 && (H = 1), this[t + F] = (e / R >> 0) - H & 255;
      return t + d;
    }, f.prototype.writeIntBE = function(e, t, d, m) {
      if (e = +e, t = t >>> 0, !m) {
        const J = Math.pow(2, 8 * d - 1);
        q(this, e, t, d, J - 1, -J);
      }
      let F = d - 1, R = 1, H = 0;
      for (this[t + F] = e & 255; --F >= 0 && (R *= 256); )
        e < 0 && H === 0 && this[t + F + 1] !== 0 && (H = 1), this[t + F] = (e / R >> 0) - H & 255;
      return t + d;
    }, f.prototype.writeInt8 = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
    }, f.prototype.writeInt16LE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 2, 32767, -32768), this[t] = e & 255, this[t + 1] = e >>> 8, t + 2;
    }, f.prototype.writeInt16BE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = e & 255, t + 2;
    }, f.prototype.writeInt32LE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 4, 2147483647, -2147483648), this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
    }, f.prototype.writeInt32BE = function(e, t, d) {
      return e = +e, t = t >>> 0, d || q(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255, t + 4;
    }, f.prototype.writeBigInt64LE = de(function(e, t = 0) {
      return W(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), f.prototype.writeBigInt64BE = de(function(e, t = 0) {
      return $(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function ie(o, e, t, d, m, F) {
      if (t + d > o.length) throw new RangeError("Index out of range");
      if (t < 0) throw new RangeError("Index out of range");
    }
    function oe(o, e, t, d, m) {
      return e = +e, t = t >>> 0, m || ie(o, e, t, 4), s.write(o, e, t, d, 23, 4), t + 4;
    }
    f.prototype.writeFloatLE = function(e, t, d) {
      return oe(this, e, t, !0, d);
    }, f.prototype.writeFloatBE = function(e, t, d) {
      return oe(this, e, t, !1, d);
    };
    function ae(o, e, t, d, m) {
      return e = +e, t = t >>> 0, m || ie(o, e, t, 8), s.write(o, e, t, d, 52, 8), t + 8;
    }
    f.prototype.writeDoubleLE = function(e, t, d) {
      return ae(this, e, t, !0, d);
    }, f.prototype.writeDoubleBE = function(e, t, d) {
      return ae(this, e, t, !1, d);
    }, f.prototype.copy = function(e, t, d, m) {
      if (!f.isBuffer(e)) throw new TypeError("argument should be a Buffer");
      if (d || (d = 0), !m && m !== 0 && (m = this.length), t >= e.length && (t = e.length), t || (t = 0), m > 0 && m < d && (m = d), m === d || e.length === 0 || this.length === 0) return 0;
      if (t < 0)
        throw new RangeError("targetStart out of bounds");
      if (d < 0 || d >= this.length) throw new RangeError("Index out of range");
      if (m < 0) throw new RangeError("sourceEnd out of bounds");
      m > this.length && (m = this.length), e.length - t < m - d && (m = e.length - t + d);
      const F = m - d;
      return this === e && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(t, d, m) : Uint8Array.prototype.set.call(
        e,
        this.subarray(d, m),
        t
      ), F;
    }, f.prototype.fill = function(e, t, d, m) {
      if (typeof e == "string") {
        if (typeof t == "string" ? (m = t, t = 0, d = this.length) : typeof d == "string" && (m = d, d = this.length), m !== void 0 && typeof m != "string")
          throw new TypeError("encoding must be a string");
        if (typeof m == "string" && !f.isEncoding(m))
          throw new TypeError("Unknown encoding: " + m);
        if (e.length === 1) {
          const R = e.charCodeAt(0);
          (m === "utf8" && R < 128 || m === "latin1") && (e = R);
        }
      } else typeof e == "number" ? e = e & 255 : typeof e == "boolean" && (e = Number(e));
      if (t < 0 || this.length < t || this.length < d)
        throw new RangeError("Out of range index");
      if (d <= t)
        return this;
      t = t >>> 0, d = d === void 0 ? this.length : d >>> 0, e || (e = 0);
      let F;
      if (typeof e == "number")
        for (F = t; F < d; ++F)
          this[F] = e;
      else {
        const R = f.isBuffer(e) ? e : f.from(e, m), H = R.length;
        if (H === 0)
          throw new TypeError('The value "' + e + '" is invalid for argument "value"');
        for (F = 0; F < d - t; ++F)
          this[F + t] = R[F % H];
      }
      return this;
    };
    const re = {};
    function xe(o, e, t) {
      re[o] = class extends t {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: e.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${o}]`, this.stack, delete this.name;
        }
        get code() {
          return o;
        }
        set code(m) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: m,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${o}]: ${this.message}`;
        }
      };
    }
    xe(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(o) {
        return o ? `${o} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), xe(
      "ERR_INVALID_ARG_TYPE",
      function(o, e) {
        return `The "${o}" argument must be of type number. Received type ${typeof e}`;
      },
      TypeError
    ), xe(
      "ERR_OUT_OF_RANGE",
      function(o, e, t) {
        let d = `The value of "${o}" is out of range.`, m = t;
        return Number.isInteger(t) && Math.abs(t) > 2 ** 32 ? m = ce(String(t)) : typeof t == "bigint" && (m = String(t), (t > BigInt(2) ** BigInt(32) || t < -(BigInt(2) ** BigInt(32))) && (m = ce(m)), m += "n"), d += ` It must be ${e}. Received ${m}`, d;
      },
      RangeError
    );
    function ce(o) {
      let e = "", t = o.length;
      const d = o[0] === "-" ? 1 : 0;
      for (; t >= d + 4; t -= 3)
        e = `_${o.slice(t - 3, t)}${e}`;
      return `${o.slice(0, t)}${e}`;
    }
    function ye(o, e, t) {
      ue(e, "offset"), (o[e] === void 0 || o[e + t] === void 0) && he(e, o.length - (t + 1));
    }
    function ge(o, e, t, d, m, F) {
      if (o > t || o < e) {
        const R = typeof e == "bigint" ? "n" : "";
        let H;
        throw e === 0 || e === BigInt(0) ? H = `>= 0${R} and < 2${R} ** ${(F + 1) * 8}${R}` : H = `>= -(2${R} ** ${(F + 1) * 8 - 1}${R}) and < 2 ** ${(F + 1) * 8 - 1}${R}`, new re.ERR_OUT_OF_RANGE("value", H, o);
      }
      ye(d, m, F);
    }
    function ue(o, e) {
      if (typeof o != "number")
        throw new re.ERR_INVALID_ARG_TYPE(e, "number", o);
    }
    function he(o, e, t) {
      throw Math.floor(o) !== o ? (ue(o, t), new re.ERR_OUT_OF_RANGE("offset", "an integer", o)) : e < 0 ? new re.ERR_BUFFER_OUT_OF_BOUNDS() : new re.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${e}`,
        o
      );
    }
    const Re = /[^+/0-9A-Za-z-_]/g;
    function Se(o) {
      if (o = o.split("=")[0], o = o.trim().replace(Re, ""), o.length < 2) return "";
      for (; o.length % 4 !== 0; )
        o = o + "=";
      return o;
    }
    function we(o, e) {
      e = e || 1 / 0;
      let t;
      const d = o.length;
      let m = null;
      const F = [];
      for (let R = 0; R < d; ++R) {
        if (t = o.charCodeAt(R), t > 55295 && t < 57344) {
          if (!m) {
            if (t > 56319) {
              (e -= 3) > -1 && F.push(239, 191, 189);
              continue;
            } else if (R + 1 === d) {
              (e -= 3) > -1 && F.push(239, 191, 189);
              continue;
            }
            m = t;
            continue;
          }
          if (t < 56320) {
            (e -= 3) > -1 && F.push(239, 191, 189), m = t;
            continue;
          }
          t = (m - 55296 << 10 | t - 56320) + 65536;
        } else m && (e -= 3) > -1 && F.push(239, 191, 189);
        if (m = null, t < 128) {
          if ((e -= 1) < 0) break;
          F.push(t);
        } else if (t < 2048) {
          if ((e -= 2) < 0) break;
          F.push(
            t >> 6 | 192,
            t & 63 | 128
          );
        } else if (t < 65536) {
          if ((e -= 3) < 0) break;
          F.push(
            t >> 12 | 224,
            t >> 6 & 63 | 128,
            t & 63 | 128
          );
        } else if (t < 1114112) {
          if ((e -= 4) < 0) break;
          F.push(
            t >> 18 | 240,
            t >> 12 & 63 | 128,
            t >> 6 & 63 | 128,
            t & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return F;
    }
    function Fe(o) {
      const e = [];
      for (let t = 0; t < o.length; ++t)
        e.push(o.charCodeAt(t) & 255);
      return e;
    }
    function Ne(o, e) {
      let t, d, m;
      const F = [];
      for (let R = 0; R < o.length && !((e -= 2) < 0); ++R)
        t = o.charCodeAt(R), d = t >> 8, m = t % 256, F.push(m), F.push(d);
      return F;
    }
    function Ae(o) {
      return n.toByteArray(Se(o));
    }
    function pe(o, e, t, d) {
      let m;
      for (m = 0; m < d && !(m + t >= e.length || m >= o.length); ++m)
        e[m + t] = o[m];
      return m;
    }
    function fe(o, e) {
      return o instanceof e || o != null && o.constructor != null && o.constructor.name != null && o.constructor.name === e.name;
    }
    function Be(o) {
      return o !== o;
    }
    const ne = (function() {
      const o = "0123456789abcdef", e = new Array(256);
      for (let t = 0; t < 16; ++t) {
        const d = t * 16;
        for (let m = 0; m < 16; ++m)
          e[d + m] = o[t] + o[m];
      }
      return e;
    })();
    function de(o) {
      return typeof BigInt > "u" ? p : o;
    }
    function p() {
      throw new Error("BigInt not supported");
    }
  })(Wt)), Wt;
}
var Te = pn(), Xe = { exports: {} }, Ve = {}, je = { exports: {} }, Ir;
function dn() {
  if (Ir) return je.exports;
  Ir = 1;
  try {
    je.exports = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
  } catch {
    je.exports = !1;
  }
  return je.exports;
}
var zt, Tr;
function dr() {
  return Tr || (Tr = 1, zt = (function() {
    return typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
  })()), zt;
}
var Xt, Or;
function vr() {
  if (Or) return Xt;
  Or = 1;
  var h = dn(), n = dr();
  return Xt = function(s) {
    var a = s.xdomain, x = s.xscheme, u = s.enablesXDR;
    try {
      if (typeof XMLHttpRequest < "u" && (!a || h))
        return new XMLHttpRequest();
    } catch {
    }
    try {
      if (typeof XDomainRequest < "u" && !x && u)
        return new XDomainRequest();
    } catch {
    }
    if (!a)
      try {
        return new n[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
      } catch {
      }
  }, Xt;
}
var Ze = { exports: {} }, Vt = {}, jt, Mr;
function vn() {
  return Mr || (Mr = 1, jt = Object.keys || function(n) {
    var s = [], a = Object.prototype.hasOwnProperty;
    for (var x in n)
      a.call(n, x) && s.push(x);
    return s;
  }), jt;
}
var Zt, Nr;
function yn() {
  if (Nr) return Zt;
  Nr = 1;
  var h = {}.toString;
  return Zt = Array.isArray || function(n) {
    return h.call(n) == "[object Array]";
  }, Zt;
}
var Jt, Ur;
function gn() {
  if (Ur) return Jt;
  Ur = 1;
  var h = yn(), n = Object.prototype.toString, s = typeof Blob == "function" || typeof Blob < "u" && n.call(Blob) === "[object BlobConstructor]", a = typeof File == "function" || typeof File < "u" && n.call(File) === "[object FileConstructor]";
  Jt = x;
  function x(u) {
    if (!u || typeof u != "object")
      return !1;
    if (h(u)) {
      for (var g = 0, f = u.length; g < f; g++)
        if (x(u[g]))
          return !0;
      return !1;
    }
    if (typeof Buffer == "function" && Buffer.isBuffer && Buffer.isBuffer(u) || typeof ArrayBuffer == "function" && u instanceof ArrayBuffer || s && u instanceof Blob || a && u instanceof File)
      return !0;
    if (u.toJSON && typeof u.toJSON == "function" && arguments.length === 1)
      return x(u.toJSON(), !0);
    for (var v in u)
      if (Object.prototype.hasOwnProperty.call(u, v) && x(u[v]))
        return !0;
    return !1;
  }
  return Jt;
}
var Qt, kr;
function mn() {
  return kr || (kr = 1, Qt = function(h, n, s) {
    var a = h.byteLength;
    if (n = n || 0, s = s || a, h.slice)
      return h.slice(n, s);
    if (n < 0 && (n += a), s < 0 && (s += a), s > a && (s = a), n >= a || n >= s || a === 0)
      return new ArrayBuffer(0);
    for (var x = new Uint8Array(h), u = new Uint8Array(s - n), g = n, f = 0; g < s; g++, f++)
      u[f] = x[g];
    return u.buffer;
  }), Qt;
}
var Yt, Pr;
function Cn() {
  if (Pr) return Yt;
  Pr = 1, Yt = h;
  function h(s, a, x) {
    var u = !1;
    return x = x || n, g.count = s, s === 0 ? a() : g;
    function g(f, v) {
      if (g.count <= 0)
        throw new Error("after called too many times");
      --g.count, f ? (u = !0, a(f), a = x) : g.count === 0 && !u && a(null, v);
    }
  }
  function n() {
  }
  return Yt;
}
var er, Lr;
function En() {
  if (Lr) return er;
  Lr = 1;
  var h = String.fromCharCode;
  function n(y) {
    for (var C = [], B = 0, _ = y.length, I, A; B < _; )
      I = y.charCodeAt(B++), I >= 55296 && I <= 56319 && B < _ ? (A = y.charCodeAt(B++), (A & 64512) == 56320 ? C.push(((I & 1023) << 10) + (A & 1023) + 65536) : (C.push(I), B--)) : C.push(I);
    return C;
  }
  function s(y) {
    for (var C = y.length, B = -1, _, I = ""; ++B < C; )
      _ = y[B], _ > 65535 && (_ -= 65536, I += h(_ >>> 10 & 1023 | 55296), _ = 56320 | _ & 1023), I += h(_);
    return I;
  }
  function a(y, C) {
    if (y >= 55296 && y <= 57343) {
      if (C)
        throw Error(
          "Lone surrogate U+" + y.toString(16).toUpperCase() + " is not a scalar value"
        );
      return !1;
    }
    return !0;
  }
  function x(y, C) {
    return h(y >> C & 63 | 128);
  }
  function u(y, C) {
    if ((y & 4294967168) == 0)
      return h(y);
    var B = "";
    return (y & 4294965248) == 0 ? B = h(y >> 6 & 31 | 192) : (y & 4294901760) == 0 ? (a(y, C) || (y = 65533), B = h(y >> 12 & 15 | 224), B += x(y, 6)) : (y & 4292870144) == 0 && (B = h(y >> 18 & 7 | 240), B += x(y, 12), B += x(y, 6)), B += h(y & 63 | 128), B;
  }
  function g(y, C) {
    C = C || {};
    for (var B = C.strict !== !1, _ = n(y), I = _.length, A = -1, D, E = ""; ++A < I; )
      D = _[A], E += u(D, B);
    return E;
  }
  function f() {
    if (c >= i)
      throw Error("Invalid byte index");
    var y = r[c] & 255;
    if (c++, (y & 192) == 128)
      return y & 63;
    throw Error("Invalid continuation byte");
  }
  function v(y) {
    var C, B, _, I, A;
    if (c > i)
      throw Error("Invalid byte index");
    if (c == i)
      return !1;
    if (C = r[c] & 255, c++, (C & 128) == 0)
      return C;
    if ((C & 224) == 192) {
      if (B = f(), A = (C & 31) << 6 | B, A >= 128)
        return A;
      throw Error("Invalid continuation byte");
    }
    if ((C & 240) == 224) {
      if (B = f(), _ = f(), A = (C & 15) << 12 | B << 6 | _, A >= 2048)
        return a(A, y) ? A : 65533;
      throw Error("Invalid continuation byte");
    }
    if ((C & 248) == 240 && (B = f(), _ = f(), I = f(), A = (C & 7) << 18 | B << 12 | _ << 6 | I, A >= 65536 && A <= 1114111))
      return A;
    throw Error("Invalid UTF-8 detected");
  }
  var r, i, c;
  function l(y, C) {
    C = C || {};
    var B = C.strict !== !1;
    r = n(y), i = r.length, c = 0;
    for (var _ = [], I; (I = v(B)) !== !1; )
      _.push(I);
    return s(_);
  }
  return er = {
    version: "2.1.2",
    encode: g,
    decode: l
  }, er;
}
var Je = {}, Gr;
function An() {
  return Gr || (Gr = 1, (function(h) {
    Je.encode = function(n) {
      var s = new Uint8Array(n), a, x = s.length, u = "";
      for (a = 0; a < x; a += 3)
        u += h[s[a] >> 2], u += h[(s[a] & 3) << 4 | s[a + 1] >> 4], u += h[(s[a + 1] & 15) << 2 | s[a + 2] >> 6], u += h[s[a + 2] & 63];
      return x % 3 === 2 ? u = u.substring(0, u.length - 1) + "=" : x % 3 === 1 && (u = u.substring(0, u.length - 2) + "=="), u;
    }, Je.decode = function(n) {
      var s = n.length * 0.75, a = n.length, x, u = 0, g, f, v, r;
      n[n.length - 1] === "=" && (s--, n[n.length - 2] === "=" && s--);
      var i = new ArrayBuffer(s), c = new Uint8Array(i);
      for (x = 0; x < a; x += 4)
        g = h.indexOf(n[x]), f = h.indexOf(n[x + 1]), v = h.indexOf(n[x + 2]), r = h.indexOf(n[x + 3]), c[u++] = g << 2 | f >> 4, c[u++] = (f & 15) << 4 | v >> 2, c[u++] = (v & 3) << 6 | r & 63;
      return i;
    };
  })("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")), Je;
}
var tr, qr;
function Bn() {
  if (qr) return tr;
  qr = 1;
  var h = typeof h < "u" ? h : typeof WebKitBlobBuilder < "u" ? WebKitBlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : !1, n = (function() {
    try {
      var f = new Blob(["hi"]);
      return f.size === 2;
    } catch {
      return !1;
    }
  })(), s = n && (function() {
    try {
      var f = new Blob([new Uint8Array([1, 2])]);
      return f.size === 2;
    } catch {
      return !1;
    }
  })(), a = h && h.prototype.append && h.prototype.getBlob;
  function x(f) {
    return f.map(function(v) {
      if (v.buffer instanceof ArrayBuffer) {
        var r = v.buffer;
        if (v.byteLength !== r.byteLength) {
          var i = new Uint8Array(v.byteLength);
          i.set(new Uint8Array(r, v.byteOffset, v.byteLength)), r = i.buffer;
        }
        return r;
      }
      return v;
    });
  }
  function u(f, v) {
    v = v || {};
    var r = new h();
    return x(f).forEach(function(i) {
      r.append(i);
    }), v.type ? r.getBlob(v.type) : r.getBlob();
  }
  function g(f, v) {
    return new Blob(x(f), v || {});
  }
  return typeof Blob < "u" && (u.prototype = Blob.prototype, g.prototype = Blob.prototype), tr = /* @__PURE__ */ (function() {
    return n ? s ? Blob : g : a ? u : void 0;
  })(), tr;
}
var Hr;
function He() {
  return Hr || (Hr = 1, (function(h) {
    var n = vn(), s = gn(), a = mn(), x = Cn(), u = En(), g;
    typeof ArrayBuffer < "u" && (g = An());
    var f = typeof navigator < "u" && /Android/i.test(navigator.userAgent), v = typeof navigator < "u" && /PhantomJS/i.test(navigator.userAgent), r = f || v;
    h.protocol = 3;
    var i = h.packets = {
      open: 0,
      close: 1,
      ping: 2,
      pong: 3,
      message: 4,
      upgrade: 5,
      noop: 6
    }, c = n(i), l = { type: "error", data: "parser error" }, y = Bn();
    h.encodePacket = function(E, w, b, O) {
      typeof w == "function" && (O = w, w = !1), typeof b == "function" && (O = b, b = null);
      var M = E.data === void 0 ? void 0 : E.data.buffer || E.data;
      if (typeof ArrayBuffer < "u" && M instanceof ArrayBuffer)
        return B(E, w, O);
      if (typeof y < "u" && M instanceof y)
        return I(E, w, O);
      if (M && M.base64)
        return C(E, O);
      var k = i[E.type];
      return E.data !== void 0 && (k += b ? u.encode(String(E.data), { strict: !1 }) : String(E.data)), O("" + k);
    };
    function C(E, w) {
      var b = "b" + h.packets[E.type] + E.data.data;
      return w(b);
    }
    function B(E, w, b) {
      if (!w)
        return h.encodeBase64Packet(E, b);
      var O = E.data, M = new Uint8Array(O), k = new Uint8Array(1 + O.byteLength);
      k[0] = i[E.type];
      for (var S = 0; S < M.length; S++)
        k[S + 1] = M[S];
      return b(k.buffer);
    }
    function _(E, w, b) {
      if (!w)
        return h.encodeBase64Packet(E, b);
      var O = new FileReader();
      return O.onload = function() {
        h.encodePacket({ type: E.type, data: O.result }, w, !0, b);
      }, O.readAsArrayBuffer(E.data);
    }
    function I(E, w, b) {
      if (!w)
        return h.encodeBase64Packet(E, b);
      if (r)
        return _(E, w, b);
      var O = new Uint8Array(1);
      O[0] = i[E.type];
      var M = new y([O.buffer, E.data]);
      return b(M);
    }
    h.encodeBase64Packet = function(E, w) {
      var b = "b" + h.packets[E.type];
      if (typeof y < "u" && E.data instanceof y) {
        var O = new FileReader();
        return O.onload = function() {
          var N = O.result.split(",")[1];
          w(b + N);
        }, O.readAsDataURL(E.data);
      }
      var M;
      try {
        M = String.fromCharCode.apply(null, new Uint8Array(E.data));
      } catch {
        for (var k = new Uint8Array(E.data), S = new Array(k.length), T = 0; T < k.length; T++)
          S[T] = k[T];
        M = String.fromCharCode.apply(null, S);
      }
      return b += btoa(M), w(b);
    }, h.decodePacket = function(E, w, b) {
      if (E === void 0)
        return l;
      if (typeof E == "string") {
        if (E.charAt(0) === "b")
          return h.decodeBase64Packet(E.substr(1), w);
        if (b && (E = A(E), E === !1))
          return l;
        var M = E.charAt(0);
        return Number(M) != M || !c[M] ? l : E.length > 1 ? { type: c[M], data: E.substring(1) } : { type: c[M] };
      }
      var O = new Uint8Array(E), M = O[0], k = a(E, 1);
      return y && w === "blob" && (k = new y([k])), { type: c[M], data: k };
    };
    function A(E) {
      try {
        E = u.decode(E, { strict: !1 });
      } catch {
        return !1;
      }
      return E;
    }
    h.decodeBase64Packet = function(E, w) {
      var b = c[E.charAt(0)];
      if (!g)
        return { type: b, data: { base64: !0, data: E.substr(1) } };
      var O = g.decode(E.substr(1));
      return w === "blob" && y && (O = new y([O])), { type: b, data: O };
    }, h.encodePayload = function(E, w, b) {
      typeof w == "function" && (b = w, w = null);
      var O = s(E);
      if (w && O)
        return y && !r ? h.encodePayloadAsBlob(E, b) : h.encodePayloadAsArrayBuffer(E, b);
      if (!E.length)
        return b("0:");
      function M(S) {
        return S.length + ":" + S;
      }
      function k(S, T) {
        h.encodePacket(S, O ? w : !1, !1, function(N) {
          T(null, M(N));
        });
      }
      D(E, k, function(S, T) {
        return b(T.join(""));
      });
    };
    function D(E, w, b) {
      for (var O = new Array(E.length), M = x(E.length, b), k = function(T, N, L) {
        w(N, function(K, P) {
          O[T] = P, L(K, O);
        });
      }, S = 0; S < E.length; S++)
        k(S, E[S], M);
    }
    h.decodePayload = function(E, w, b) {
      if (typeof E != "string")
        return h.decodePayloadAsBinary(E, w, b);
      typeof w == "function" && (b = w, w = null);
      var O;
      if (E === "")
        return b(l, 0, 1);
      for (var M = "", k, S, T = 0, N = E.length; T < N; T++) {
        var L = E.charAt(T);
        if (L !== ":") {
          M += L;
          continue;
        }
        if (M === "" || M != (k = Number(M)) || (S = E.substr(T + 1, k), M != S.length))
          return b(l, 0, 1);
        if (S.length) {
          if (O = h.decodePacket(S, w, !1), l.type === O.type && l.data === O.data)
            return b(l, 0, 1);
          var K = b(O, T + k, N);
          if (K === !1) return;
        }
        T += k, M = "";
      }
      if (M !== "")
        return b(l, 0, 1);
    }, h.encodePayloadAsArrayBuffer = function(E, w) {
      if (!E.length)
        return w(new ArrayBuffer(0));
      function b(O, M) {
        h.encodePacket(O, !0, !0, function(k) {
          return M(null, k);
        });
      }
      D(E, b, function(O, M) {
        var k = M.reduce(function(N, L) {
          var K;
          return typeof L == "string" ? K = L.length : K = L.byteLength, N + K.toString().length + K + 2;
        }, 0), S = new Uint8Array(k), T = 0;
        return M.forEach(function(N) {
          var L = typeof N == "string", K = N;
          if (L) {
            for (var V = new Uint8Array(N.length), P = 0; P < N.length; P++)
              V[P] = N.charCodeAt(P);
            K = V.buffer;
          }
          L ? S[T++] = 0 : S[T++] = 1;
          for (var G = K.byteLength.toString(), P = 0; P < G.length; P++)
            S[T++] = parseInt(G[P]);
          S[T++] = 255;
          for (var V = new Uint8Array(K), P = 0; P < V.length; P++)
            S[T++] = V[P];
        }), w(S.buffer);
      });
    }, h.encodePayloadAsBlob = function(E, w) {
      function b(O, M) {
        h.encodePacket(O, !0, !0, function(k) {
          var S = new Uint8Array(1);
          if (S[0] = 1, typeof k == "string") {
            for (var T = new Uint8Array(k.length), N = 0; N < k.length; N++)
              T[N] = k.charCodeAt(N);
            k = T.buffer, S[0] = 0;
          }
          for (var L = k instanceof ArrayBuffer ? k.byteLength : k.size, K = L.toString(), P = new Uint8Array(K.length + 1), N = 0; N < K.length; N++)
            P[N] = parseInt(K[N]);
          if (P[K.length] = 255, y) {
            var G = new y([S.buffer, P.buffer, k]);
            M(null, G);
          }
        });
      }
      D(E, b, function(O, M) {
        return w(new y(M));
      });
    }, h.decodePayloadAsBinary = function(E, w, b) {
      typeof w == "function" && (b = w, w = null);
      for (var O = E, M = []; O.byteLength > 0; ) {
        for (var k = new Uint8Array(O), S = k[0] === 0, T = "", N = 1; k[N] !== 255; N++) {
          if (T.length > 310)
            return b(l, 0, 1);
          T += k[N];
        }
        O = a(O, 2 + T.length), T = parseInt(T);
        var L = a(O, 0, T);
        if (S)
          try {
            L = String.fromCharCode.apply(null, new Uint8Array(L));
          } catch {
            var K = new Uint8Array(L);
            L = "";
            for (var N = 0; N < K.length; N++)
              L += String.fromCharCode(K[N]);
          }
        M.push(L), O = a(O, T);
      }
      var P = M.length;
      M.forEach(function(G, V) {
        b(h.decodePacket(G, w, !0), V, P);
      });
    };
  })(Vt)), Vt;
}
var rr = { exports: {} }, Kr;
function yr() {
  return Kr || (Kr = 1, (function(h) {
    h.exports = n;
    function n(a) {
      if (a) return s(a);
    }
    function s(a) {
      for (var x in n.prototype)
        a[x] = n.prototype[x];
      return a;
    }
    n.prototype.on = n.prototype.addEventListener = function(a, x) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + a] = this._callbacks["$" + a] || []).push(x), this;
    }, n.prototype.once = function(a, x) {
      function u() {
        this.off(a, u), x.apply(this, arguments);
      }
      return u.fn = x, this.on(a, u), this;
    }, n.prototype.off = n.prototype.removeListener = n.prototype.removeAllListeners = n.prototype.removeEventListener = function(a, x) {
      if (this._callbacks = this._callbacks || {}, arguments.length == 0)
        return this._callbacks = {}, this;
      var u = this._callbacks["$" + a];
      if (!u) return this;
      if (arguments.length == 1)
        return delete this._callbacks["$" + a], this;
      for (var g, f = 0; f < u.length; f++)
        if (g = u[f], g === x || g.fn === x) {
          u.splice(f, 1);
          break;
        }
      return u.length === 0 && delete this._callbacks["$" + a], this;
    }, n.prototype.emit = function(a) {
      this._callbacks = this._callbacks || {};
      for (var x = new Array(arguments.length - 1), u = this._callbacks["$" + a], g = 1; g < arguments.length; g++)
        x[g - 1] = arguments[g];
      if (u) {
        u = u.slice(0);
        for (var g = 0, f = u.length; g < f; ++g)
          u[g].apply(this, x);
      }
      return this;
    }, n.prototype.listeners = function(a) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + a] || [];
    }, n.prototype.hasListeners = function(a) {
      return !!this.listeners(a).length;
    };
  })(rr)), rr.exports;
}
var nr, $r;
function gr() {
  if ($r) return nr;
  $r = 1;
  var h = He(), n = yr();
  nr = s;
  function s(a) {
    this.path = a.path, this.hostname = a.hostname, this.port = a.port, this.secure = a.secure, this.query = a.query, this.timestampParam = a.timestampParam, this.timestampRequests = a.timestampRequests, this.readyState = "", this.agent = a.agent || !1, this.socket = a.socket, this.enablesXDR = a.enablesXDR, this.withCredentials = a.withCredentials, this.pfx = a.pfx, this.key = a.key, this.passphrase = a.passphrase, this.cert = a.cert, this.ca = a.ca, this.ciphers = a.ciphers, this.rejectUnauthorized = a.rejectUnauthorized, this.forceNode = a.forceNode, this.isReactNative = a.isReactNative, this.extraHeaders = a.extraHeaders, this.localAddress = a.localAddress;
  }
  return n(s.prototype), s.prototype.onError = function(a, x) {
    var u = new Error(a);
    return u.type = "TransportError", u.description = x, this.emit("error", u), this;
  }, s.prototype.open = function() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }, s.prototype.close = function() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }, s.prototype.send = function(a) {
    if (this.readyState === "open")
      this.write(a);
    else
      throw new Error("Transport not open");
  }, s.prototype.onOpen = function() {
    this.readyState = "open", this.writable = !0, this.emit("open");
  }, s.prototype.onData = function(a) {
    var x = h.decodePacket(a, this.socket.binaryType);
    this.onPacket(x);
  }, s.prototype.onPacket = function(a) {
    this.emit("packet", a);
  }, s.prototype.onClose = function() {
    this.readyState = "closed", this.emit("close");
  }, nr;
}
var Qe = {}, Wr;
function mr() {
  return Wr || (Wr = 1, Qe.encode = function(h) {
    var n = "";
    for (var s in h)
      h.hasOwnProperty(s) && (n.length && (n += "&"), n += encodeURIComponent(s) + "=" + encodeURIComponent(h[s]));
    return n;
  }, Qe.decode = function(h) {
    for (var n = {}, s = h.split("&"), a = 0, x = s.length; a < x; a++) {
      var u = s[a].split("=");
      n[decodeURIComponent(u[0])] = decodeURIComponent(u[1]);
    }
    return n;
  }), Qe;
}
var ir, zr;
function qt() {
  return zr || (zr = 1, ir = function(h, n) {
    var s = function() {
    };
    s.prototype = n.prototype, h.prototype = new s(), h.prototype.constructor = h;
  }), ir;
}
var or, Xr;
function z0() {
  if (Xr) return or;
  Xr = 1;
  var h = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), n = 64, s = {}, a = 0, x = 0, u;
  function g(r) {
    var i = "";
    do
      i = h[r % n] + i, r = Math.floor(r / n);
    while (r > 0);
    return i;
  }
  function f(r) {
    var i = 0;
    for (x = 0; x < r.length; x++)
      i = i * n + s[r.charAt(x)];
    return i;
  }
  function v() {
    var r = g(+/* @__PURE__ */ new Date());
    return r !== u ? (a = 0, u = r) : r + "." + g(a++);
  }
  for (; x < n; x++) s[h[x]] = x;
  return v.encode = g, v.decode = f, or = v, or;
}
var Ye = { exports: {} }, et = { exports: {} }, sr, Vr;
function _n() {
  if (Vr) return sr;
  Vr = 1;
  var h = 1e3, n = h * 60, s = n * 60, a = s * 24, x = a * 365.25;
  sr = function(r, i) {
    i = i || {};
    var c = typeof r;
    if (c === "string" && r.length > 0)
      return u(r);
    if (c === "number" && isNaN(r) === !1)
      return i.long ? f(r) : g(r);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(r)
    );
  };
  function u(r) {
    if (r = String(r), !(r.length > 100)) {
      var i = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        r
      );
      if (i) {
        var c = parseFloat(i[1]), l = (i[2] || "ms").toLowerCase();
        switch (l) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return c * x;
          case "days":
          case "day":
          case "d":
            return c * a;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return c * s;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return c * n;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return c * h;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return c;
          default:
            return;
        }
      }
    }
  }
  function g(r) {
    return r >= a ? Math.round(r / a) + "d" : r >= s ? Math.round(r / s) + "h" : r >= n ? Math.round(r / n) + "m" : r >= h ? Math.round(r / h) + "s" : r + "ms";
  }
  function f(r) {
    return v(r, a, "day") || v(r, s, "hour") || v(r, n, "minute") || v(r, h, "second") || r + " ms";
  }
  function v(r, i, c) {
    if (!(r < i))
      return r < i * 1.5 ? Math.floor(r / i) + " " + c : Math.ceil(r / i) + " " + c + "s";
  }
  return sr;
}
var jr;
function Dn() {
  return jr || (jr = 1, (function(h, n) {
    n = h.exports = a.debug = a.default = a, n.coerce = v, n.disable = g, n.enable = u, n.enabled = f, n.humanize = _n(), n.instances = [], n.names = [], n.skips = [], n.formatters = {};
    function s(r) {
      var i = 0, c;
      for (c in r)
        i = (i << 5) - i + r.charCodeAt(c), i |= 0;
      return n.colors[Math.abs(i) % n.colors.length];
    }
    function a(r) {
      var i;
      function c() {
        if (c.enabled) {
          var l = c, y = +/* @__PURE__ */ new Date(), C = y - (i || y);
          l.diff = C, l.prev = i, l.curr = y, i = y;
          for (var B = new Array(arguments.length), _ = 0; _ < B.length; _++)
            B[_] = arguments[_];
          B[0] = n.coerce(B[0]), typeof B[0] != "string" && B.unshift("%O");
          var I = 0;
          B[0] = B[0].replace(/%([a-zA-Z%])/g, function(D, E) {
            if (D === "%%") return D;
            I++;
            var w = n.formatters[E];
            if (typeof w == "function") {
              var b = B[I];
              D = w.call(l, b), B.splice(I, 1), I--;
            }
            return D;
          }), n.formatArgs.call(l, B);
          var A = c.log || n.log || console.log.bind(console);
          A.apply(l, B);
        }
      }
      return c.namespace = r, c.enabled = n.enabled(r), c.useColors = n.useColors(), c.color = s(r), c.destroy = x, typeof n.init == "function" && n.init(c), n.instances.push(c), c;
    }
    function x() {
      var r = n.instances.indexOf(this);
      return r !== -1 ? (n.instances.splice(r, 1), !0) : !1;
    }
    function u(r) {
      n.save(r), n.names = [], n.skips = [];
      var i, c = (typeof r == "string" ? r : "").split(/[\s,]+/), l = c.length;
      for (i = 0; i < l; i++)
        c[i] && (r = c[i].replace(/\*/g, ".*?"), r[0] === "-" ? n.skips.push(new RegExp("^" + r.substr(1) + "$")) : n.names.push(new RegExp("^" + r + "$")));
      for (i = 0; i < n.instances.length; i++) {
        var y = n.instances[i];
        y.enabled = n.enabled(y.namespace);
      }
    }
    function g() {
      n.enable("");
    }
    function f(r) {
      if (r[r.length - 1] === "*")
        return !0;
      var i, c;
      for (i = 0, c = n.skips.length; i < c; i++)
        if (n.skips[i].test(r))
          return !1;
      for (i = 0, c = n.names.length; i < c; i++)
        if (n.names[i].test(r))
          return !0;
      return !1;
    }
    function v(r) {
      return r instanceof Error ? r.stack || r.message : r;
    }
  })(et, et.exports)), et.exports;
}
var Zr;
function Ht() {
  return Zr || (Zr = 1, (function(h, n) {
    n = h.exports = Dn(), n.log = x, n.formatArgs = a, n.save = u, n.load = g, n.useColors = s, n.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : f(), n.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function s() {
      return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    n.formatters.j = function(v) {
      try {
        return JSON.stringify(v);
      } catch (r) {
        return "[UnexpectedJSONParseError]: " + r.message;
      }
    };
    function a(v) {
      var r = this.useColors;
      if (v[0] = (r ? "%c" : "") + this.namespace + (r ? " %c" : " ") + v[0] + (r ? "%c " : " ") + "+" + n.humanize(this.diff), !!r) {
        var i = "color: " + this.color;
        v.splice(1, 0, i, "color: inherit");
        var c = 0, l = 0;
        v[0].replace(/%[a-zA-Z%]/g, function(y) {
          y !== "%%" && (c++, y === "%c" && (l = c));
        }), v.splice(l, 0, i);
      }
    }
    function x() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function u(v) {
      try {
        v == null ? n.storage.removeItem("debug") : n.storage.debug = v;
      } catch {
      }
    }
    function g() {
      var v;
      try {
        v = n.storage.debug;
      } catch {
      }
      return !v && typeof process < "u" && "env" in process && (v = process.env.DEBUG), v;
    }
    n.enable(g());
    function f() {
      try {
        return window.localStorage;
      } catch {
      }
    }
  })(Ye, Ye.exports)), Ye.exports;
}
var ar, Jr;
function X0() {
  if (Jr) return ar;
  Jr = 1;
  var h = gr(), n = mr(), s = He(), a = qt(), x = z0(), u = Ht()("engine.io-client:polling");
  ar = f;
  var g = (function() {
    var v = vr(), r = new v({ xdomain: !1 });
    return r.responseType != null;
  })();
  function f(v) {
    var r = v && v.forceBase64;
    (!g || r) && (this.supportsBinary = !1), h.call(this, v);
  }
  return a(f, h), f.prototype.name = "polling", f.prototype.doOpen = function() {
    this.poll();
  }, f.prototype.pause = function(v) {
    var r = this;
    this.readyState = "pausing";
    function i() {
      u("paused"), r.readyState = "paused", v();
    }
    if (this.polling || !this.writable) {
      var c = 0;
      this.polling && (u("we are currently polling - waiting to pause"), c++, this.once("pollComplete", function() {
        u("pre-pause polling complete"), --c || i();
      })), this.writable || (u("we are currently writing - waiting to pause"), c++, this.once("drain", function() {
        u("pre-pause writing complete"), --c || i();
      }));
    } else
      i();
  }, f.prototype.poll = function() {
    u("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
  }, f.prototype.onData = function(v) {
    var r = this;
    u("polling got data %s", v);
    var i = function(c, l, y) {
      if (r.readyState === "opening" && c.type === "open" && r.onOpen(), c.type === "close")
        return r.onClose(), !1;
      r.onPacket(c);
    };
    s.decodePayload(v, this.socket.binaryType, i), this.readyState !== "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState === "open" ? this.poll() : u('ignoring poll - transport state "%s"', this.readyState));
  }, f.prototype.doClose = function() {
    var v = this;
    function r() {
      u("writing close packet"), v.write([{ type: "close" }]);
    }
    this.readyState === "open" ? (u("transport open - closing"), r()) : (u("transport not open - deferring close"), this.once("open", r));
  }, f.prototype.write = function(v) {
    var r = this;
    this.writable = !1;
    var i = function() {
      r.writable = !0, r.emit("drain");
    };
    s.encodePayload(v, this.supportsBinary, function(c) {
      r.doWrite(c, i);
    });
  }, f.prototype.uri = function() {
    var v = this.query || {}, r = this.secure ? "https" : "http", i = "";
    this.timestampRequests !== !1 && (v[this.timestampParam] = x()), !this.supportsBinary && !v.sid && (v.b64 = 1), v = n.encode(v), this.port && (r === "https" && Number(this.port) !== 443 || r === "http" && Number(this.port) !== 80) && (i = ":" + this.port), v.length && (v = "?" + v);
    var c = this.hostname.indexOf(":") !== -1;
    return r + "://" + (c ? "[" + this.hostname + "]" : this.hostname) + i + this.path + v;
  }, ar;
}
var Qr;
function wn() {
  if (Qr) return Ze.exports;
  Qr = 1;
  var h = vr(), n = X0(), s = yr(), a = qt(), x = Ht()("engine.io-client:polling-xhr"), u = dr();
  Ze.exports = f, Ze.exports.Request = v;
  function g() {
  }
  function f(c) {
    if (n.call(this, c), this.requestTimeout = c.requestTimeout, this.extraHeaders = c.extraHeaders, typeof location < "u") {
      var l = location.protocol === "https:", y = location.port;
      y || (y = l ? 443 : 80), this.xd = typeof location < "u" && c.hostname !== location.hostname || y !== c.port, this.xs = c.secure !== l;
    }
  }
  a(f, n), f.prototype.supportsBinary = !0, f.prototype.request = function(c) {
    return c = c || {}, c.uri = this.uri(), c.xd = this.xd, c.xs = this.xs, c.agent = this.agent || !1, c.supportsBinary = this.supportsBinary, c.enablesXDR = this.enablesXDR, c.withCredentials = this.withCredentials, c.pfx = this.pfx, c.key = this.key, c.passphrase = this.passphrase, c.cert = this.cert, c.ca = this.ca, c.ciphers = this.ciphers, c.rejectUnauthorized = this.rejectUnauthorized, c.requestTimeout = this.requestTimeout, c.extraHeaders = this.extraHeaders, new v(c);
  }, f.prototype.doWrite = function(c, l) {
    var y = typeof c != "string" && c !== void 0, C = this.request({ method: "POST", data: c, isBinary: y }), B = this;
    C.on("success", l), C.on("error", function(_) {
      B.onError("xhr post error", _);
    }), this.sendXhr = C;
  }, f.prototype.doPoll = function() {
    x("xhr poll");
    var c = this.request(), l = this;
    c.on("data", function(y) {
      l.onData(y);
    }), c.on("error", function(y) {
      l.onError("xhr poll error", y);
    }), this.pollXhr = c;
  };
  function v(c) {
    this.method = c.method || "GET", this.uri = c.uri, this.xd = !!c.xd, this.xs = !!c.xs, this.async = c.async !== !1, this.data = c.data !== void 0 ? c.data : null, this.agent = c.agent, this.isBinary = c.isBinary, this.supportsBinary = c.supportsBinary, this.enablesXDR = c.enablesXDR, this.withCredentials = c.withCredentials, this.requestTimeout = c.requestTimeout, this.pfx = c.pfx, this.key = c.key, this.passphrase = c.passphrase, this.cert = c.cert, this.ca = c.ca, this.ciphers = c.ciphers, this.rejectUnauthorized = c.rejectUnauthorized, this.extraHeaders = c.extraHeaders, this.create();
  }
  if (s(v.prototype), v.prototype.create = function() {
    var c = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
    c.pfx = this.pfx, c.key = this.key, c.passphrase = this.passphrase, c.cert = this.cert, c.ca = this.ca, c.ciphers = this.ciphers, c.rejectUnauthorized = this.rejectUnauthorized;
    var l = this.xhr = new h(c), y = this;
    try {
      x("xhr open %s: %s", this.method, this.uri), l.open(this.method, this.uri, this.async);
      try {
        if (this.extraHeaders) {
          l.setDisableHeaderCheck && l.setDisableHeaderCheck(!0);
          for (var C in this.extraHeaders)
            this.extraHeaders.hasOwnProperty(C) && l.setRequestHeader(C, this.extraHeaders[C]);
        }
      } catch {
      }
      if (this.method === "POST")
        try {
          this.isBinary ? l.setRequestHeader("Content-type", "application/octet-stream") : l.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        l.setRequestHeader("Accept", "*/*");
      } catch {
      }
      "withCredentials" in l && (l.withCredentials = this.withCredentials), this.requestTimeout && (l.timeout = this.requestTimeout), this.hasXDR() ? (l.onload = function() {
        y.onLoad();
      }, l.onerror = function() {
        y.onError(l.responseText);
      }) : l.onreadystatechange = function() {
        if (l.readyState === 2)
          try {
            var B = l.getResponseHeader("Content-Type");
            (y.supportsBinary && B === "application/octet-stream" || B === "application/octet-stream; charset=UTF-8") && (l.responseType = "arraybuffer");
          } catch {
          }
        l.readyState === 4 && (l.status === 200 || l.status === 1223 ? y.onLoad() : setTimeout(function() {
          y.onError(typeof l.status == "number" ? l.status : 0);
        }, 0));
      }, x("xhr data %s", this.data), l.send(this.data);
    } catch (B) {
      setTimeout(function() {
        y.onError(B);
      }, 0);
      return;
    }
    typeof document < "u" && (this.index = v.requestsCount++, v.requests[this.index] = this);
  }, v.prototype.onSuccess = function() {
    this.emit("success"), this.cleanup();
  }, v.prototype.onData = function(c) {
    this.emit("data", c), this.onSuccess();
  }, v.prototype.onError = function(c) {
    this.emit("error", c), this.cleanup(!0);
  }, v.prototype.cleanup = function(c) {
    if (!(typeof this.xhr > "u" || this.xhr === null)) {
      if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = g : this.xhr.onreadystatechange = g, c)
        try {
          this.xhr.abort();
        } catch {
        }
      typeof document < "u" && delete v.requests[this.index], this.xhr = null;
    }
  }, v.prototype.onLoad = function() {
    var c;
    try {
      var l;
      try {
        l = this.xhr.getResponseHeader("Content-Type");
      } catch {
      }
      l === "application/octet-stream" || l === "application/octet-stream; charset=UTF-8" ? c = this.xhr.response || this.xhr.responseText : c = this.xhr.responseText;
    } catch (y) {
      this.onError(y);
    }
    c != null && this.onData(c);
  }, v.prototype.hasXDR = function() {
    return typeof XDomainRequest < "u" && !this.xs && this.enablesXDR;
  }, v.prototype.abort = function() {
    this.cleanup();
  }, v.requestsCount = 0, v.requests = {}, typeof document < "u") {
    if (typeof attachEvent == "function")
      attachEvent("onunload", i);
    else if (typeof addEventListener == "function") {
      var r = "onpagehide" in u ? "pagehide" : "unload";
      addEventListener(r, i, !1);
    }
  }
  function i() {
    for (var c in v.requests)
      v.requests.hasOwnProperty(c) && v.requests[c].abort();
  }
  return Ze.exports;
}
var cr, Yr;
function Fn() {
  if (Yr) return cr;
  Yr = 1;
  var h = X0(), n = qt(), s = dr();
  cr = f;
  var a = /\n/g, x = /\\n/g, u;
  function g() {
  }
  function f(v) {
    h.call(this, v), this.query = this.query || {}, u || (u = s.___eio = s.___eio || []), this.index = u.length;
    var r = this;
    u.push(function(i) {
      r.onData(i);
    }), this.query.j = this.index, typeof addEventListener == "function" && addEventListener("beforeunload", function() {
      r.script && (r.script.onerror = g);
    }, !1);
  }
  return n(f, h), f.prototype.supportsBinary = !1, f.prototype.doClose = function() {
    this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), h.prototype.doClose.call(this);
  }, f.prototype.doPoll = function() {
    var v = this, r = document.createElement("script");
    this.script && (this.script.parentNode.removeChild(this.script), this.script = null), r.async = !0, r.src = this.uri(), r.onerror = function(l) {
      v.onError("jsonp poll error", l);
    };
    var i = document.getElementsByTagName("script")[0];
    i ? i.parentNode.insertBefore(r, i) : (document.head || document.body).appendChild(r), this.script = r;
    var c = typeof navigator < "u" && /gecko/i.test(navigator.userAgent);
    c && setTimeout(function() {
      var l = document.createElement("iframe");
      document.body.appendChild(l), document.body.removeChild(l);
    }, 100);
  }, f.prototype.doWrite = function(v, r) {
    var i = this;
    if (!this.form) {
      var c = document.createElement("form"), l = document.createElement("textarea"), y = this.iframeId = "eio_iframe_" + this.index, C;
      c.className = "socketio", c.style.position = "absolute", c.style.top = "-1000px", c.style.left = "-1000px", c.target = y, c.method = "POST", c.setAttribute("accept-charset", "utf-8"), l.name = "d", c.appendChild(l), document.body.appendChild(c), this.form = c, this.area = l;
    }
    this.form.action = this.uri();
    function B() {
      _(), r();
    }
    function _() {
      if (i.iframe)
        try {
          i.form.removeChild(i.iframe);
        } catch (A) {
          i.onError("jsonp polling iframe removal error", A);
        }
      try {
        var I = '<iframe src="javascript:0" name="' + i.iframeId + '">';
        C = document.createElement(I);
      } catch {
        C = document.createElement("iframe"), C.name = i.iframeId, C.src = "javascript:0";
      }
      C.id = i.iframeId, i.form.appendChild(C), i.iframe = C;
    }
    _(), v = v.replace(x, `\\
`), this.area.value = v.replace(a, "\\n");
    try {
      this.form.submit();
    } catch {
    }
    this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
      i.iframe.readyState === "complete" && B();
    } : this.iframe.onload = B;
  }, cr;
}
const bn = {}, Sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bn
}, Symbol.toStringTag, { value: "Module" })), V0 = /* @__PURE__ */ cn(Sn);
var ur, e0;
function Rn() {
  if (e0) return ur;
  e0 = 1;
  var h = gr(), n = He(), s = mr(), a = qt(), x = z0(), u = Ht()("engine.io-client:websocket"), g, f;
  if (typeof WebSocket < "u" ? g = WebSocket : typeof self < "u" && (g = self.WebSocket || self.MozWebSocket), typeof window > "u")
    try {
      f = V0;
    } catch {
    }
  var v = g || f;
  ur = r;
  function r(i) {
    var c = i && i.forceBase64;
    c && (this.supportsBinary = !1), this.perMessageDeflate = i.perMessageDeflate, this.usingBrowserWebSocket = g && !i.forceNode, this.protocols = i.protocols, this.usingBrowserWebSocket || (v = f), h.call(this, i);
  }
  return a(r, h), r.prototype.name = "websocket", r.prototype.supportsBinary = !0, r.prototype.doOpen = function() {
    if (this.check()) {
      var i = this.uri(), c = this.protocols, l = {};
      this.isReactNative || (l.agent = this.agent, l.perMessageDeflate = this.perMessageDeflate, l.pfx = this.pfx, l.key = this.key, l.passphrase = this.passphrase, l.cert = this.cert, l.ca = this.ca, l.ciphers = this.ciphers, l.rejectUnauthorized = this.rejectUnauthorized), this.extraHeaders && (l.headers = this.extraHeaders), this.localAddress && (l.localAddress = this.localAddress);
      try {
        this.ws = this.usingBrowserWebSocket && !this.isReactNative ? c ? new v(i, c) : new v(i) : new v(i, c, l);
      } catch (y) {
        return this.emit("error", y);
      }
      this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
    }
  }, r.prototype.addEventListeners = function() {
    var i = this;
    this.ws.onopen = function() {
      i.onOpen();
    }, this.ws.onclose = function() {
      i.onClose();
    }, this.ws.onmessage = function(c) {
      i.onData(c.data);
    }, this.ws.onerror = function(c) {
      i.onError("websocket error", c);
    };
  }, r.prototype.write = function(i) {
    var c = this;
    this.writable = !1;
    for (var l = i.length, y = 0, C = l; y < C; y++)
      (function(_) {
        n.encodePacket(_, c.supportsBinary, function(I) {
          if (!c.usingBrowserWebSocket) {
            var A = {};
            if (_.options && (A.compress = _.options.compress), c.perMessageDeflate) {
              var D = typeof I == "string" ? Buffer.byteLength(I) : I.length;
              D < c.perMessageDeflate.threshold && (A.compress = !1);
            }
          }
          try {
            c.usingBrowserWebSocket ? c.ws.send(I) : c.ws.send(I, A);
          } catch {
            u("websocket closed before onclose event");
          }
          --l || B();
        });
      })(i[y]);
    function B() {
      c.emit("flush"), setTimeout(function() {
        c.writable = !0, c.emit("drain");
      }, 0);
    }
  }, r.prototype.onClose = function() {
    h.prototype.onClose.call(this);
  }, r.prototype.doClose = function() {
    typeof this.ws < "u" && (this.ws.onerror = function() {
    }, this.ws.close());
  }, r.prototype.uri = function() {
    var i = this.query || {}, c = this.secure ? "wss" : "ws", l = "";
    this.port && (c === "wss" && Number(this.port) !== 443 || c === "ws" && Number(this.port) !== 80) && (l = ":" + this.port), this.timestampRequests && (i[this.timestampParam] = x()), this.supportsBinary || (i.b64 = 1), i = s.encode(i), i.length && (i = "?" + i);
    var y = this.hostname.indexOf(":") !== -1;
    return c + "://" + (y ? "[" + this.hostname + "]" : this.hostname) + l + this.path + i;
  }, r.prototype.check = function() {
    return !!v && !("__initialize" in v && this.name === r.prototype.name);
  }, ur;
}
var t0;
function r0() {
  if (t0) return Ve;
  t0 = 1;
  var h = vr(), n = wn(), s = Fn(), a = Rn();
  Ve.polling = x, Ve.websocket = a;
  function x(u) {
    var g, f = !1, v = !1, r = u.jsonp !== !1;
    if (typeof location < "u") {
      var i = location.protocol === "https:", c = location.port;
      c || (c = i ? 443 : 80), f = u.hostname !== location.hostname || c !== u.port, v = u.secure !== i;
    }
    if (u.xdomain = f, u.xscheme = v, g = new h(u), "open" in g && !u.forceJSONP)
      return new n(u);
    if (!r) throw new Error("JSONP disabled");
    return new s(u);
  }
  return Ve;
}
var fr, n0;
function In() {
  if (n0) return fr;
  n0 = 1;
  var h = [].indexOf;
  return fr = function(n, s) {
    if (h) return n.indexOf(s);
    for (var a = 0; a < n.length; ++a)
      if (n[a] === s) return a;
    return -1;
  }, fr;
}
var lr, i0;
function Tn() {
  if (i0) return lr;
  i0 = 1;
  var h = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, n = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
  ];
  lr = function(u) {
    var g = u, f = u.indexOf("["), v = u.indexOf("]");
    f != -1 && v != -1 && (u = u.substring(0, f) + u.substring(f, v).replace(/:/g, ";") + u.substring(v, u.length));
    for (var r = h.exec(u || ""), i = {}, c = 14; c--; )
      i[n[c]] = r[c] || "";
    return f != -1 && v != -1 && (i.source = g, i.host = i.host.substring(1, i.host.length - 1).replace(/;/g, ":"), i.authority = i.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i.ipv6uri = !0), i.pathNames = s(i, i.path), i.queryKey = a(i, i.query), i;
  };
  function s(x, u) {
    var g = /\/{2,9}/g, f = u.replace(g, "/").split("/");
    return (u.substr(0, 1) == "/" || u.length === 0) && f.splice(0, 1), u.substr(u.length - 1, 1) == "/" && f.splice(f.length - 1, 1), f;
  }
  function a(x, u) {
    var g = {};
    return u.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(f, v, r) {
      v && (g[v] = r);
    }), g;
  }
  return lr;
}
var hr, o0;
function On() {
  if (o0) return hr;
  o0 = 1;
  var h = r0(), n = yr(), s = Ht()("engine.io-client:socket"), a = In(), x = He(), u = Tn(), g = mr();
  hr = f;
  function f(r, i) {
    if (!(this instanceof f)) return new f(r, i);
    i = i || {}, r && typeof r == "object" && (i = r, r = null), r ? (r = u(r), i.hostname = r.host, i.secure = r.protocol === "https" || r.protocol === "wss", i.port = r.port, r.query && (i.query = r.query)) : i.host && (i.hostname = u(i.host).host), this.secure = i.secure != null ? i.secure : typeof location < "u" && location.protocol === "https:", i.hostname && !i.port && (i.port = this.secure ? "443" : "80"), this.agent = i.agent || !1, this.hostname = i.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = i.port || (typeof location < "u" && location.port ? location.port : this.secure ? 443 : 80), this.query = i.query || {}, typeof this.query == "string" && (this.query = g.decode(this.query)), this.upgrade = i.upgrade !== !1, this.path = (i.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!i.forceJSONP, this.jsonp = i.jsonp !== !1, this.forceBase64 = !!i.forceBase64, this.enablesXDR = !!i.enablesXDR, this.withCredentials = i.withCredentials !== !1, this.timestampParam = i.timestampParam || "t", this.timestampRequests = i.timestampRequests, this.transports = i.transports || ["polling", "websocket"], this.transportOptions = i.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = i.policyPort || 843, this.rememberUpgrade = i.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = i.onlyBinaryUpgrades, this.perMessageDeflate = i.perMessageDeflate !== !1 ? i.perMessageDeflate || {} : !1, this.perMessageDeflate === !0 && (this.perMessageDeflate = {}), this.perMessageDeflate && this.perMessageDeflate.threshold == null && (this.perMessageDeflate.threshold = 1024), this.pfx = i.pfx || void 0, this.key = i.key || void 0, this.passphrase = i.passphrase || void 0, this.cert = i.cert || void 0, this.ca = i.ca || void 0, this.ciphers = i.ciphers || void 0, this.rejectUnauthorized = i.rejectUnauthorized === void 0 ? !0 : i.rejectUnauthorized, this.forceNode = !!i.forceNode, this.isReactNative = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", (typeof self > "u" || this.isReactNative) && (i.extraHeaders && Object.keys(i.extraHeaders).length > 0 && (this.extraHeaders = i.extraHeaders), i.localAddress && (this.localAddress = i.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
  }
  f.priorWebsocketSuccess = !1, n(f.prototype), f.protocol = x.protocol, f.Socket = f, f.Transport = gr(), f.transports = r0(), f.parser = He(), f.prototype.createTransport = function(r) {
    s('creating transport "%s"', r);
    var i = v(this.query);
    i.EIO = x.protocol, i.transport = r;
    var c = this.transportOptions[r] || {};
    this.id && (i.sid = this.id);
    var l = new h[r]({
      query: i,
      socket: this,
      agent: c.agent || this.agent,
      hostname: c.hostname || this.hostname,
      port: c.port || this.port,
      secure: c.secure || this.secure,
      path: c.path || this.path,
      forceJSONP: c.forceJSONP || this.forceJSONP,
      jsonp: c.jsonp || this.jsonp,
      forceBase64: c.forceBase64 || this.forceBase64,
      enablesXDR: c.enablesXDR || this.enablesXDR,
      withCredentials: c.withCredentials || this.withCredentials,
      timestampRequests: c.timestampRequests || this.timestampRequests,
      timestampParam: c.timestampParam || this.timestampParam,
      policyPort: c.policyPort || this.policyPort,
      pfx: c.pfx || this.pfx,
      key: c.key || this.key,
      passphrase: c.passphrase || this.passphrase,
      cert: c.cert || this.cert,
      ca: c.ca || this.ca,
      ciphers: c.ciphers || this.ciphers,
      rejectUnauthorized: c.rejectUnauthorized || this.rejectUnauthorized,
      perMessageDeflate: c.perMessageDeflate || this.perMessageDeflate,
      extraHeaders: c.extraHeaders || this.extraHeaders,
      forceNode: c.forceNode || this.forceNode,
      localAddress: c.localAddress || this.localAddress,
      requestTimeout: c.requestTimeout || this.requestTimeout,
      protocols: c.protocols || void 0,
      isReactNative: this.isReactNative
    });
    return l;
  };
  function v(r) {
    var i = {};
    for (var c in r)
      r.hasOwnProperty(c) && (i[c] = r[c]);
    return i;
  }
  return f.prototype.open = function() {
    var r;
    if (this.rememberUpgrade && f.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      r = "websocket";
    else if (this.transports.length === 0) {
      var i = this;
      setTimeout(function() {
        i.emit("error", "No transports available");
      }, 0);
      return;
    } else
      r = this.transports[0];
    this.readyState = "opening";
    try {
      r = this.createTransport(r);
    } catch {
      this.transports.shift(), this.open();
      return;
    }
    r.open(), this.setTransport(r);
  }, f.prototype.setTransport = function(r) {
    s("setting transport %s", r.name);
    var i = this;
    this.transport && (s("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = r, r.on("drain", function() {
      i.onDrain();
    }).on("packet", function(c) {
      i.onPacket(c);
    }).on("error", function(c) {
      i.onError(c);
    }).on("close", function() {
      i.onClose("transport close");
    });
  }, f.prototype.probe = function(r) {
    s('probing transport "%s"', r);
    var i = this.createTransport(r, { probe: 1 }), c = !1, l = this;
    f.priorWebsocketSuccess = !1;
    function y() {
      if (l.onlyBinaryUpgrades) {
        var E = !this.supportsBinary && l.transport.supportsBinary;
        c = c || E;
      }
      c || (s('probe transport "%s" opened', r), i.send([{ type: "ping", data: "probe" }]), i.once("packet", function(w) {
        if (!c)
          if (w.type === "pong" && w.data === "probe") {
            if (s('probe transport "%s" pong', r), l.upgrading = !0, l.emit("upgrading", i), !i) return;
            f.priorWebsocketSuccess = i.name === "websocket", s('pausing current transport "%s"', l.transport.name), l.transport.pause(function() {
              c || l.readyState !== "closed" && (s("changing transport and sending upgrade packet"), D(), l.setTransport(i), i.send([{ type: "upgrade" }]), l.emit("upgrade", i), i = null, l.upgrading = !1, l.flush());
            });
          } else {
            s('probe transport "%s" failed', r);
            var b = new Error("probe error");
            b.transport = i.name, l.emit("upgradeError", b);
          }
      }));
    }
    function C() {
      c || (c = !0, D(), i.close(), i = null);
    }
    function B(E) {
      var w = new Error("probe error: " + E);
      w.transport = i.name, C(), s('probe transport "%s" failed because of error: %s', r, E), l.emit("upgradeError", w);
    }
    function _() {
      B("transport closed");
    }
    function I() {
      B("socket closed");
    }
    function A(E) {
      i && E.name !== i.name && (s('"%s" works - aborting "%s"', E.name, i.name), C());
    }
    function D() {
      i.removeListener("open", y), i.removeListener("error", B), i.removeListener("close", _), l.removeListener("close", I), l.removeListener("upgrading", A);
    }
    i.once("open", y), i.once("error", B), i.once("close", _), this.once("close", I), this.once("upgrading", A), i.open();
  }, f.prototype.onOpen = function() {
    if (s("socket open"), this.readyState = "open", f.priorWebsocketSuccess = this.transport.name === "websocket", this.emit("open"), this.flush(), this.readyState === "open" && this.upgrade && this.transport.pause) {
      s("starting upgrade probes");
      for (var r = 0, i = this.upgrades.length; r < i; r++)
        this.probe(this.upgrades[r]);
    }
  }, f.prototype.onPacket = function(r) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (s('socket receive: type "%s", data "%s"', r.type, r.data), this.emit("packet", r), this.emit("heartbeat"), r.type) {
        case "open":
          this.onHandshake(JSON.parse(r.data));
          break;
        case "pong":
          this.setPing(), this.emit("pong");
          break;
        case "error":
          var i = new Error("server error");
          i.code = r.data, this.onError(i);
          break;
        case "message":
          this.emit("data", r.data), this.emit("message", r.data);
          break;
      }
    else
      s('packet received with socket readyState "%s"', this.readyState);
  }, f.prototype.onHandshake = function(r) {
    this.emit("handshake", r), this.id = r.sid, this.transport.query.sid = r.sid, this.upgrades = this.filterUpgrades(r.upgrades), this.pingInterval = r.pingInterval, this.pingTimeout = r.pingTimeout, this.onOpen(), this.readyState !== "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
  }, f.prototype.onHeartbeat = function(r) {
    clearTimeout(this.pingTimeoutTimer);
    var i = this;
    i.pingTimeoutTimer = setTimeout(function() {
      i.readyState !== "closed" && i.onClose("ping timeout");
    }, r || i.pingInterval + i.pingTimeout);
  }, f.prototype.setPing = function() {
    var r = this;
    clearTimeout(r.pingIntervalTimer), r.pingIntervalTimer = setTimeout(function() {
      s("writing ping packet - expecting pong within %sms", r.pingTimeout), r.ping(), r.onHeartbeat(r.pingTimeout);
    }, r.pingInterval);
  }, f.prototype.ping = function() {
    var r = this;
    this.sendPacket("ping", function() {
      r.emit("ping");
    });
  }, f.prototype.onDrain = function() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emit("drain") : this.flush();
  }, f.prototype.flush = function() {
    this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (s("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
  }, f.prototype.write = f.prototype.send = function(r, i, c) {
    return this.sendPacket("message", r, i, c), this;
  }, f.prototype.sendPacket = function(r, i, c, l) {
    if (typeof i == "function" && (l = i, i = void 0), typeof c == "function" && (l = c, c = null), !(this.readyState === "closing" || this.readyState === "closed")) {
      c = c || {}, c.compress = c.compress !== !1;
      var y = {
        type: r,
        data: i,
        options: c
      };
      this.emit("packetCreate", y), this.writeBuffer.push(y), l && this.once("flush", l), this.flush();
    }
  }, f.prototype.close = function() {
    if (this.readyState === "opening" || this.readyState === "open") {
      this.readyState = "closing";
      var r = this;
      this.writeBuffer.length ? this.once("drain", function() {
        this.upgrading ? l() : i();
      }) : this.upgrading ? l() : i();
    }
    function i() {
      r.onClose("forced close"), s("socket closing - telling transport to close"), r.transport.close();
    }
    function c() {
      r.removeListener("upgrade", c), r.removeListener("upgradeError", c), i();
    }
    function l() {
      r.once("upgrade", c), r.once("upgradeError", c);
    }
    return this;
  }, f.prototype.onError = function(r) {
    s("socket error %j", r), f.priorWebsocketSuccess = !1, this.emit("error", r), this.onClose("transport error", r);
  }, f.prototype.onClose = function(r, i) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      s('socket close with reason: "%s"', r);
      var c = this;
      clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", r, i), c.writeBuffer = [], c.prevBufferLen = 0;
    }
  }, f.prototype.filterUpgrades = function(r) {
    for (var i = [], c = 0, l = r.length; c < l; c++)
      ~a(this.transports, r[c]) && i.push(r[c]);
    return i;
  }, hr;
}
var s0;
function Mn() {
  return s0 || (s0 = 1, Xe.exports = On(), Xe.exports.parser = He()), Xe.exports;
}
var Nn = Mn();
const a0 = /* @__PURE__ */ Gt(Nn);
function tt(h) {
  for (var n = 1; n < arguments.length; n++) {
    var s = arguments[n];
    for (var a in s)
      h[a] = s[a];
  }
  return h;
}
var Un = {
  read: function(h) {
    return h[0] === '"' && (h = h.slice(1, -1)), h.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(h) {
    return encodeURIComponent(h).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function pr(h, n) {
  function s(x, u, g) {
    if (!(typeof document > "u")) {
      g = tt({}, n, g), typeof g.expires == "number" && (g.expires = new Date(Date.now() + g.expires * 864e5)), g.expires && (g.expires = g.expires.toUTCString()), x = encodeURIComponent(x).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var v in g)
        g[v] && (f += "; " + v, g[v] !== !0 && (f += "=" + g[v].split(";")[0]));
      return document.cookie = x + "=" + h.write(u, x) + f;
    }
  }
  function a(x) {
    if (!(typeof document > "u" || arguments.length && !x)) {
      for (var u = document.cookie ? document.cookie.split("; ") : [], g = {}, f = 0; f < u.length; f++) {
        var v = u[f].split("="), r = v.slice(1).join("=");
        try {
          var i = decodeURIComponent(v[0]);
          if (g[i] = h.read(r, i), x === i)
            break;
        } catch {
        }
      }
      return x ? g[x] : g;
    }
  }
  return Object.create(
    {
      set: s,
      get: a,
      remove: function(x, u) {
        s(
          x,
          "",
          tt({}, u, {
            expires: -1
          })
        );
      },
      withAttributes: function(x) {
        return pr(this.converter, tt({}, this.attributes, x));
      },
      withConverter: function(x) {
        return pr(tt({}, this.converter, x), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(n) },
      converter: { value: Object.freeze(h) }
    }
  );
}
var kn = pr(Un, { path: "/" }), xr = { exports: {} }, c0;
function Pn() {
  return c0 || (c0 = 1, (function(h) {
    var n = (function(s) {
      var a = 1e7, x = 7, u = 9007199254740992, g = C(u), f = "0123456789abcdefghijklmnopqrstuvwxyz", v = typeof BigInt == "function";
      function r(p, o, e, t) {
        return typeof p > "u" ? r[0] : typeof o < "u" ? +o == 10 && !e ? ne(p) : we(p, o, e, t) : ne(p);
      }
      function i(p, o) {
        this.value = p, this.sign = o, this.isSmall = !1;
      }
      i.prototype = Object.create(r.prototype);
      function c(p) {
        this.value = p, this.sign = p < 0, this.isSmall = !0;
      }
      c.prototype = Object.create(r.prototype);
      function l(p) {
        this.value = p;
      }
      l.prototype = Object.create(r.prototype);
      function y(p) {
        return -u < p && p < u;
      }
      function C(p) {
        return p < 1e7 ? [p] : p < 1e14 ? [p % 1e7, Math.floor(p / 1e7)] : [p % 1e7, Math.floor(p / 1e7) % 1e7, Math.floor(p / 1e14)];
      }
      function B(p) {
        _(p);
        var o = p.length;
        if (o < 4 && j(p, g) < 0)
          switch (o) {
            case 0:
              return 0;
            case 1:
              return p[0];
            case 2:
              return p[0] + p[1] * a;
            default:
              return p[0] + (p[1] + p[2] * a) * a;
          }
        return p;
      }
      function _(p) {
        for (var o = p.length; p[--o] === 0; ) ;
        p.length = o + 1;
      }
      function I(p) {
        for (var o = new Array(p), e = -1; ++e < p; )
          o[e] = 0;
        return o;
      }
      function A(p) {
        return p > 0 ? Math.floor(p) : Math.ceil(p);
      }
      function D(p, o) {
        var e = p.length, t = o.length, d = new Array(e), m = 0, F = a, R, H;
        for (H = 0; H < t; H++)
          R = p[H] + o[H] + m, m = R >= F ? 1 : 0, d[H] = R - m * F;
        for (; H < e; )
          R = p[H] + m, m = R === F ? 1 : 0, d[H++] = R - m * F;
        return m > 0 && d.push(m), d;
      }
      function E(p, o) {
        return p.length >= o.length ? D(p, o) : D(o, p);
      }
      function w(p, o) {
        var e = p.length, t = new Array(e), d = a, m, F;
        for (F = 0; F < e; F++)
          m = p[F] - d + o, o = Math.floor(m / d), t[F] = m - o * d, o += 1;
        for (; o > 0; )
          t[F++] = o % d, o = Math.floor(o / d);
        return t;
      }
      i.prototype.add = function(p) {
        var o = ne(p);
        if (this.sign !== o.sign)
          return this.subtract(o.negate());
        var e = this.value, t = o.value;
        return o.isSmall ? new i(w(e, Math.abs(t)), this.sign) : new i(E(e, t), this.sign);
      }, i.prototype.plus = i.prototype.add, c.prototype.add = function(p) {
        var o = ne(p), e = this.value;
        if (e < 0 !== o.sign)
          return this.subtract(o.negate());
        var t = o.value;
        if (o.isSmall) {
          if (y(e + t)) return new c(e + t);
          t = C(Math.abs(t));
        }
        return new i(w(t, Math.abs(e)), e < 0);
      }, c.prototype.plus = c.prototype.add, l.prototype.add = function(p) {
        return new l(this.value + ne(p).value);
      }, l.prototype.plus = l.prototype.add;
      function b(p, o) {
        var e = p.length, t = o.length, d = new Array(e), m = 0, F = a, R, H;
        for (R = 0; R < t; R++)
          H = p[R] - m - o[R], H < 0 ? (H += F, m = 1) : m = 0, d[R] = H;
        for (R = t; R < e; R++) {
          if (H = p[R] - m, H < 0) H += F;
          else {
            d[R++] = H;
            break;
          }
          d[R] = H;
        }
        for (; R < e; R++)
          d[R] = p[R];
        return _(d), d;
      }
      function O(p, o, e) {
        var t;
        return j(p, o) >= 0 ? t = b(p, o) : (t = b(o, p), e = !e), t = B(t), typeof t == "number" ? (e && (t = -t), new c(t)) : new i(t, e);
      }
      function M(p, o, e) {
        var t = p.length, d = new Array(t), m = -o, F = a, R, H;
        for (R = 0; R < t; R++)
          H = p[R] + m, m = Math.floor(H / F), H %= F, d[R] = H < 0 ? H + F : H;
        return d = B(d), typeof d == "number" ? (e && (d = -d), new c(d)) : new i(d, e);
      }
      i.prototype.subtract = function(p) {
        var o = ne(p);
        if (this.sign !== o.sign)
          return this.add(o.negate());
        var e = this.value, t = o.value;
        return o.isSmall ? M(e, Math.abs(t), this.sign) : O(e, t, this.sign);
      }, i.prototype.minus = i.prototype.subtract, c.prototype.subtract = function(p) {
        var o = ne(p), e = this.value;
        if (e < 0 !== o.sign)
          return this.add(o.negate());
        var t = o.value;
        return o.isSmall ? new c(e - t) : M(t, Math.abs(e), e >= 0);
      }, c.prototype.minus = c.prototype.subtract, l.prototype.subtract = function(p) {
        return new l(this.value - ne(p).value);
      }, l.prototype.minus = l.prototype.subtract, i.prototype.negate = function() {
        return new i(this.value, !this.sign);
      }, c.prototype.negate = function() {
        var p = this.sign, o = new c(-this.value);
        return o.sign = !p, o;
      }, l.prototype.negate = function() {
        return new l(-this.value);
      }, i.prototype.abs = function() {
        return new i(this.value, !1);
      }, c.prototype.abs = function() {
        return new c(Math.abs(this.value));
      }, l.prototype.abs = function() {
        return new l(this.value >= 0 ? this.value : -this.value);
      };
      function k(p, o) {
        var e = p.length, t = o.length, d = e + t, m = I(d), F = a, R, H, J, Y, Q;
        for (J = 0; J < e; ++J) {
          Y = p[J];
          for (var ee = 0; ee < t; ++ee)
            Q = o[ee], R = Y * Q + m[J + ee], H = Math.floor(R / F), m[J + ee] = R - H * F, m[J + ee + 1] += H;
        }
        return _(m), m;
      }
      function S(p, o) {
        var e = p.length, t = new Array(e), d = a, m = 0, F, R;
        for (R = 0; R < e; R++)
          F = p[R] * o + m, m = Math.floor(F / d), t[R] = F - m * d;
        for (; m > 0; )
          t[R++] = m % d, m = Math.floor(m / d);
        return t;
      }
      function T(p, o) {
        for (var e = []; o-- > 0; ) e.push(0);
        return e.concat(p);
      }
      function N(p, o) {
        var e = Math.max(p.length, o.length);
        if (e <= 30) return k(p, o);
        e = Math.ceil(e / 2);
        var t = p.slice(e), d = p.slice(0, e), m = o.slice(e), F = o.slice(0, e), R = N(d, F), H = N(t, m), J = N(E(d, t), E(F, m)), Y = E(E(R, T(b(b(J, R), H), e)), T(H, 2 * e));
        return _(Y), Y;
      }
      function L(p, o) {
        return -0.012 * p - 0.012 * o + 15e-6 * p * o > 0;
      }
      i.prototype.multiply = function(p) {
        var o = ne(p), e = this.value, t = o.value, d = this.sign !== o.sign, m;
        if (o.isSmall) {
          if (t === 0) return r[0];
          if (t === 1) return this;
          if (t === -1) return this.negate();
          if (m = Math.abs(t), m < a)
            return new i(S(e, m), d);
          t = C(m);
        }
        return L(e.length, t.length) ? new i(N(e, t), d) : new i(k(e, t), d);
      }, i.prototype.times = i.prototype.multiply;
      function K(p, o, e) {
        return p < a ? new i(S(o, p), e) : new i(k(o, C(p)), e);
      }
      c.prototype._multiplyBySmall = function(p) {
        return y(p.value * this.value) ? new c(p.value * this.value) : K(Math.abs(p.value), C(Math.abs(this.value)), this.sign !== p.sign);
      }, i.prototype._multiplyBySmall = function(p) {
        return p.value === 0 ? r[0] : p.value === 1 ? this : p.value === -1 ? this.negate() : K(Math.abs(p.value), this.value, this.sign !== p.sign);
      }, c.prototype.multiply = function(p) {
        return ne(p)._multiplyBySmall(this);
      }, c.prototype.times = c.prototype.multiply, l.prototype.multiply = function(p) {
        return new l(this.value * ne(p).value);
      }, l.prototype.times = l.prototype.multiply;
      function P(p) {
        var o = p.length, e = I(o + o), t = a, d, m, F, R, H;
        for (F = 0; F < o; F++) {
          R = p[F], m = 0 - R * R;
          for (var J = F; J < o; J++)
            H = p[J], d = 2 * (R * H) + e[F + J] + m, m = Math.floor(d / t), e[F + J] = d - m * t;
          e[F + o] = m;
        }
        return _(e), e;
      }
      i.prototype.square = function() {
        return new i(P(this.value), !1);
      }, c.prototype.square = function() {
        var p = this.value * this.value;
        return y(p) ? new c(p) : new i(P(C(Math.abs(this.value))), !1);
      }, l.prototype.square = function(p) {
        return new l(this.value * this.value);
      };
      function G(p, o) {
        var e = p.length, t = o.length, d = a, m = I(o.length), F = o[t - 1], R = Math.ceil(d / (2 * F)), H = S(p, R), J = S(o, R), Y, Q, ee, Ee, me, Ke, qe;
        for (H.length <= e && H.push(0), J.push(0), F = J[t - 1], Q = e - t; Q >= 0; Q--) {
          for (Y = d - 1, H[Q + t] !== F && (Y = Math.floor((H[Q + t] * d + H[Q + t - 1]) / F)), ee = 0, Ee = 0, Ke = J.length, me = 0; me < Ke; me++)
            ee += Y * J[me], qe = Math.floor(ee / d), Ee += H[Q + me] - (ee - qe * d), ee = qe, Ee < 0 ? (H[Q + me] = Ee + d, Ee = -1) : (H[Q + me] = Ee, Ee = 0);
          for (; Ee !== 0; ) {
            for (Y -= 1, ee = 0, me = 0; me < Ke; me++)
              ee += H[Q + me] - d + J[me], ee < 0 ? (H[Q + me] = ee + d, ee = 0) : (H[Q + me] = ee, ee = 1);
            Ee += ee;
          }
          m[Q] = Y;
        }
        return H = X(H, R)[0], [B(m), B(H)];
      }
      function V(p, o) {
        for (var e = p.length, t = o.length, d = [], m = [], F = a, R, H, J, Y, Q; e; ) {
          if (m.unshift(p[--e]), _(m), j(m, o) < 0) {
            d.push(0);
            continue;
          }
          H = m.length, J = m[H - 1] * F + m[H - 2], Y = o[t - 1] * F + o[t - 2], H > t && (J = (J + 1) * F), R = Math.ceil(J / Y);
          do {
            if (Q = S(o, R), j(Q, m) <= 0) break;
            R--;
          } while (R);
          d.push(R), m = b(m, Q);
        }
        return d.reverse(), [B(d), B(m)];
      }
      function X(p, o) {
        var e = p.length, t = I(e), d = a, m, F, R, H;
        for (R = 0, m = e - 1; m >= 0; --m)
          H = R * d + p[m], F = A(H / o), R = H - F * o, t[m] = F | 0;
        return [t, R | 0];
      }
      function Z(p, o) {
        var e, t = ne(o);
        if (v)
          return [new l(p.value / t.value), new l(p.value % t.value)];
        var d = p.value, m = t.value, F;
        if (m === 0) throw new Error("Cannot divide by zero");
        if (p.isSmall)
          return t.isSmall ? [new c(A(d / m)), new c(d % m)] : [r[0], p];
        if (t.isSmall) {
          if (m === 1) return [p, r[0]];
          if (m == -1) return [p.negate(), r[0]];
          var R = Math.abs(m);
          if (R < a) {
            e = X(d, R), F = B(e[0]);
            var H = e[1];
            return p.sign && (H = -H), typeof F == "number" ? (p.sign !== t.sign && (F = -F), [new c(F), new c(H)]) : [new i(F, p.sign !== t.sign), new c(H)];
          }
          m = C(R);
        }
        var J = j(d, m);
        if (J === -1) return [r[0], p];
        if (J === 0) return [r[p.sign === t.sign ? 1 : -1], r[0]];
        d.length + m.length <= 200 ? e = G(d, m) : e = V(d, m), F = e[0];
        var Y = p.sign !== t.sign, Q = e[1], ee = p.sign;
        return typeof F == "number" ? (Y && (F = -F), F = new c(F)) : F = new i(F, Y), typeof Q == "number" ? (ee && (Q = -Q), Q = new c(Q)) : Q = new i(Q, ee), [F, Q];
      }
      i.prototype.divmod = function(p) {
        var o = Z(this, p);
        return {
          quotient: o[0],
          remainder: o[1]
        };
      }, l.prototype.divmod = c.prototype.divmod = i.prototype.divmod, i.prototype.divide = function(p) {
        return Z(this, p)[0];
      }, l.prototype.over = l.prototype.divide = function(p) {
        return new l(this.value / ne(p).value);
      }, c.prototype.over = c.prototype.divide = i.prototype.over = i.prototype.divide, i.prototype.mod = function(p) {
        return Z(this, p)[1];
      }, l.prototype.mod = l.prototype.remainder = function(p) {
        return new l(this.value % ne(p).value);
      }, c.prototype.remainder = c.prototype.mod = i.prototype.remainder = i.prototype.mod, i.prototype.pow = function(p) {
        var o = ne(p), e = this.value, t = o.value, d, m, F;
        if (t === 0) return r[1];
        if (e === 0) return r[0];
        if (e === 1) return r[1];
        if (e === -1) return o.isEven() ? r[1] : r[-1];
        if (o.sign)
          return r[0];
        if (!o.isSmall) throw new Error("The exponent " + o.toString() + " is too large.");
        if (this.isSmall && y(d = Math.pow(e, t)))
          return new c(A(d));
        for (m = this, F = r[1]; t & !0 && (F = F.times(m), --t), t !== 0; )
          t /= 2, m = m.square();
        return F;
      }, c.prototype.pow = i.prototype.pow, l.prototype.pow = function(p) {
        var o = ne(p), e = this.value, t = o.value, d = BigInt(0), m = BigInt(1), F = BigInt(2);
        if (t === d) return r[1];
        if (e === d) return r[0];
        if (e === m) return r[1];
        if (e === BigInt(-1)) return o.isEven() ? r[1] : r[-1];
        if (o.isNegative()) return new l(d);
        for (var R = this, H = r[1]; (t & m) === m && (H = H.times(R), --t), t !== d; )
          t /= F, R = R.square();
        return H;
      }, i.prototype.modPow = function(p, o) {
        if (p = ne(p), o = ne(o), o.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var e = r[1], t = this.mod(o);
        for (p.isNegative() && (p = p.multiply(r[-1]), t = t.modInv(o)); p.isPositive(); ) {
          if (t.isZero()) return r[0];
          p.isOdd() && (e = e.multiply(t).mod(o)), p = p.divide(2), t = t.square().mod(o);
        }
        return e;
      }, l.prototype.modPow = c.prototype.modPow = i.prototype.modPow;
      function j(p, o) {
        if (p.length !== o.length)
          return p.length > o.length ? 1 : -1;
        for (var e = p.length - 1; e >= 0; e--)
          if (p[e] !== o[e]) return p[e] > o[e] ? 1 : -1;
        return 0;
      }
      i.prototype.compareAbs = function(p) {
        var o = ne(p), e = this.value, t = o.value;
        return o.isSmall ? 1 : j(e, t);
      }, c.prototype.compareAbs = function(p) {
        var o = ne(p), e = Math.abs(this.value), t = o.value;
        return o.isSmall ? (t = Math.abs(t), e === t ? 0 : e > t ? 1 : -1) : -1;
      }, l.prototype.compareAbs = function(p) {
        var o = this.value, e = ne(p).value;
        return o = o >= 0 ? o : -o, e = e >= 0 ? e : -e, o === e ? 0 : o > e ? 1 : -1;
      }, i.prototype.compare = function(p) {
        if (p === 1 / 0)
          return -1;
        if (p === -1 / 0)
          return 1;
        var o = ne(p), e = this.value, t = o.value;
        return this.sign !== o.sign ? o.sign ? 1 : -1 : o.isSmall ? this.sign ? -1 : 1 : j(e, t) * (this.sign ? -1 : 1);
      }, i.prototype.compareTo = i.prototype.compare, c.prototype.compare = function(p) {
        if (p === 1 / 0)
          return -1;
        if (p === -1 / 0)
          return 1;
        var o = ne(p), e = this.value, t = o.value;
        return o.isSmall ? e == t ? 0 : e > t ? 1 : -1 : e < 0 !== o.sign ? e < 0 ? -1 : 1 : e < 0 ? 1 : -1;
      }, c.prototype.compareTo = c.prototype.compare, l.prototype.compare = function(p) {
        if (p === 1 / 0)
          return -1;
        if (p === -1 / 0)
          return 1;
        var o = this.value, e = ne(p).value;
        return o === e ? 0 : o > e ? 1 : -1;
      }, l.prototype.compareTo = l.prototype.compare, i.prototype.equals = function(p) {
        return this.compare(p) === 0;
      }, l.prototype.eq = l.prototype.equals = c.prototype.eq = c.prototype.equals = i.prototype.eq = i.prototype.equals, i.prototype.notEquals = function(p) {
        return this.compare(p) !== 0;
      }, l.prototype.neq = l.prototype.notEquals = c.prototype.neq = c.prototype.notEquals = i.prototype.neq = i.prototype.notEquals, i.prototype.greater = function(p) {
        return this.compare(p) > 0;
      }, l.prototype.gt = l.prototype.greater = c.prototype.gt = c.prototype.greater = i.prototype.gt = i.prototype.greater, i.prototype.lesser = function(p) {
        return this.compare(p) < 0;
      }, l.prototype.lt = l.prototype.lesser = c.prototype.lt = c.prototype.lesser = i.prototype.lt = i.prototype.lesser, i.prototype.greaterOrEquals = function(p) {
        return this.compare(p) >= 0;
      }, l.prototype.geq = l.prototype.greaterOrEquals = c.prototype.geq = c.prototype.greaterOrEquals = i.prototype.geq = i.prototype.greaterOrEquals, i.prototype.lesserOrEquals = function(p) {
        return this.compare(p) <= 0;
      }, l.prototype.leq = l.prototype.lesserOrEquals = c.prototype.leq = c.prototype.lesserOrEquals = i.prototype.leq = i.prototype.lesserOrEquals, i.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
      }, c.prototype.isEven = function() {
        return (this.value & 1) === 0;
      }, l.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
      }, i.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
      }, c.prototype.isOdd = function() {
        return (this.value & 1) === 1;
      }, l.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
      }, i.prototype.isPositive = function() {
        return !this.sign;
      }, c.prototype.isPositive = function() {
        return this.value > 0;
      }, l.prototype.isPositive = c.prototype.isPositive, i.prototype.isNegative = function() {
        return this.sign;
      }, c.prototype.isNegative = function() {
        return this.value < 0;
      }, l.prototype.isNegative = c.prototype.isNegative, i.prototype.isUnit = function() {
        return !1;
      }, c.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
      }, l.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
      }, i.prototype.isZero = function() {
        return !1;
      }, c.prototype.isZero = function() {
        return this.value === 0;
      }, l.prototype.isZero = function() {
        return this.value === BigInt(0);
      }, i.prototype.isDivisibleBy = function(p) {
        var o = ne(p);
        return o.isZero() ? !1 : o.isUnit() ? !0 : o.compareAbs(2) === 0 ? this.isEven() : this.mod(o).isZero();
      }, l.prototype.isDivisibleBy = c.prototype.isDivisibleBy = i.prototype.isDivisibleBy;
      function U(p) {
        var o = p.abs();
        if (o.isUnit()) return !1;
        if (o.equals(2) || o.equals(3) || o.equals(5)) return !0;
        if (o.isEven() || o.isDivisibleBy(3) || o.isDivisibleBy(5)) return !1;
        if (o.lesser(49)) return !0;
      }
      function q(p, o) {
        for (var e = p.prev(), t = e, d = 0, m, F, R; t.isEven(); ) t = t.divide(2), d++;
        e: for (F = 0; F < o.length; F++)
          if (!p.lesser(o[F]) && (R = n(o[F]).modPow(t, p), !(R.isUnit() || R.equals(e)))) {
            for (m = d - 1; m != 0; m--) {
              if (R = R.square().mod(p), R.isUnit()) return !1;
              if (R.equals(e)) continue e;
            }
            return !1;
          }
        return !0;
      }
      i.prototype.isPrime = function(p) {
        var o = U(this);
        if (o !== s) return o;
        var e = this.abs(), t = e.bitLength();
        if (t <= 64)
          return q(e, [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37]);
        for (var d = Math.log(2) * t.toJSNumber(), m = Math.ceil(p === !0 ? 2 * Math.pow(d, 2) : d), F = [], R = 0; R < m; R++)
          F.push(n(R + 2));
        return q(e, F);
      }, l.prototype.isPrime = c.prototype.isPrime = i.prototype.isPrime, i.prototype.isProbablePrime = function(p, o) {
        var e = U(this);
        if (e !== s) return e;
        for (var t = this.abs(), d = p === s ? 5 : p, m = [], F = 0; F < d; F++)
          m.push(n.randBetween(2, t.minus(2), o));
        return q(t, m);
      }, l.prototype.isProbablePrime = c.prototype.isProbablePrime = i.prototype.isProbablePrime, i.prototype.modInv = function(p) {
        for (var o = n.zero, e = n.one, t = ne(p), d = this.abs(), m, F, R; !d.isZero(); )
          m = t.divide(d), F = o, R = t, o = e, t = d, e = F.subtract(m.multiply(e)), d = R.subtract(m.multiply(d));
        if (!t.isUnit()) throw new Error(this.toString() + " and " + p.toString() + " are not co-prime");
        return o.compare(0) === -1 && (o = o.add(p)), this.isNegative() ? o.negate() : o;
      }, l.prototype.modInv = c.prototype.modInv = i.prototype.modInv, i.prototype.next = function() {
        var p = this.value;
        return this.sign ? M(p, 1, this.sign) : new i(w(p, 1), this.sign);
      }, c.prototype.next = function() {
        var p = this.value;
        return p + 1 < u ? new c(p + 1) : new i(g, !1);
      }, l.prototype.next = function() {
        return new l(this.value + BigInt(1));
      }, i.prototype.prev = function() {
        var p = this.value;
        return this.sign ? new i(w(p, 1), !0) : M(p, 1, this.sign);
      }, c.prototype.prev = function() {
        var p = this.value;
        return p - 1 > -u ? new c(p - 1) : new i(g, !0);
      }, l.prototype.prev = function() {
        return new l(this.value - BigInt(1));
      };
      for (var W = [1]; 2 * W[W.length - 1] <= a; ) W.push(2 * W[W.length - 1]);
      var $ = W.length, ie = W[$ - 1];
      function oe(p) {
        return Math.abs(p) <= a;
      }
      i.prototype.shiftLeft = function(p) {
        var o = ne(p).toJSNumber();
        if (!oe(o))
          throw new Error(String(o) + " is too large for shifting.");
        if (o < 0) return this.shiftRight(-o);
        var e = this;
        if (e.isZero()) return e;
        for (; o >= $; )
          e = e.multiply(ie), o -= $ - 1;
        return e.multiply(W[o]);
      }, l.prototype.shiftLeft = c.prototype.shiftLeft = i.prototype.shiftLeft, i.prototype.shiftRight = function(p) {
        var o, e = ne(p).toJSNumber();
        if (!oe(e))
          throw new Error(String(e) + " is too large for shifting.");
        if (e < 0) return this.shiftLeft(-e);
        for (var t = this; e >= $; ) {
          if (t.isZero() || t.isNegative() && t.isUnit()) return t;
          o = Z(t, ie), t = o[1].isNegative() ? o[0].prev() : o[0], e -= $ - 1;
        }
        return o = Z(t, W[e]), o[1].isNegative() ? o[0].prev() : o[0];
      }, l.prototype.shiftRight = c.prototype.shiftRight = i.prototype.shiftRight;
      function ae(p, o, e) {
        o = ne(o);
        for (var t = p.isNegative(), d = o.isNegative(), m = t ? p.not() : p, F = d ? o.not() : o, R = 0, H = 0, J = null, Y = null, Q = []; !m.isZero() || !F.isZero(); )
          J = Z(m, ie), R = J[1].toJSNumber(), t && (R = ie - 1 - R), Y = Z(F, ie), H = Y[1].toJSNumber(), d && (H = ie - 1 - H), m = J[0], F = Y[0], Q.push(e(R, H));
        for (var ee = e(t ? 1 : 0, d ? 1 : 0) !== 0 ? n(-1) : n(0), Ee = Q.length - 1; Ee >= 0; Ee -= 1)
          ee = ee.multiply(ie).add(n(Q[Ee]));
        return ee;
      }
      i.prototype.not = function() {
        return this.negate().prev();
      }, l.prototype.not = c.prototype.not = i.prototype.not, i.prototype.and = function(p) {
        return ae(this, p, function(o, e) {
          return o & e;
        });
      }, l.prototype.and = c.prototype.and = i.prototype.and, i.prototype.or = function(p) {
        return ae(this, p, function(o, e) {
          return o | e;
        });
      }, l.prototype.or = c.prototype.or = i.prototype.or, i.prototype.xor = function(p) {
        return ae(this, p, function(o, e) {
          return o ^ e;
        });
      }, l.prototype.xor = c.prototype.xor = i.prototype.xor;
      var re = 1 << 30, xe = (a & -a) * (a & -a) | re;
      function ce(p) {
        var o = p.value, e = typeof o == "number" ? o | re : typeof o == "bigint" ? o | BigInt(re) : o[0] + o[1] * a | xe;
        return e & -e;
      }
      function ye(p, o) {
        if (o.compareTo(p) <= 0) {
          var e = ye(p, o.square(o)), t = e.p, d = e.e, m = t.multiply(o);
          return m.compareTo(p) <= 0 ? { p: m, e: d * 2 + 1 } : { p: t, e: d * 2 };
        }
        return { p: n(1), e: 0 };
      }
      i.prototype.bitLength = function() {
        var p = this;
        return p.compareTo(n(0)) < 0 && (p = p.negate().subtract(n(1))), p.compareTo(n(0)) === 0 ? n(0) : n(ye(p, n(2)).e).add(n(1));
      }, l.prototype.bitLength = c.prototype.bitLength = i.prototype.bitLength;
      function ge(p, o) {
        return p = ne(p), o = ne(o), p.greater(o) ? p : o;
      }
      function ue(p, o) {
        return p = ne(p), o = ne(o), p.lesser(o) ? p : o;
      }
      function he(p, o) {
        if (p = ne(p).abs(), o = ne(o).abs(), p.equals(o)) return p;
        if (p.isZero()) return o;
        if (o.isZero()) return p;
        for (var e = r[1], t, d; p.isEven() && o.isEven(); )
          t = ue(ce(p), ce(o)), p = p.divide(t), o = o.divide(t), e = e.multiply(t);
        for (; p.isEven(); )
          p = p.divide(ce(p));
        do {
          for (; o.isEven(); )
            o = o.divide(ce(o));
          p.greater(o) && (d = o, o = p, p = d), o = o.subtract(p);
        } while (!o.isZero());
        return e.isUnit() ? p : p.multiply(e);
      }
      function Re(p, o) {
        return p = ne(p).abs(), o = ne(o).abs(), p.divide(he(p, o)).multiply(o);
      }
      function Se(p, o, e) {
        p = ne(p), o = ne(o);
        var t = e || Math.random, d = ue(p, o), m = ge(p, o), F = m.subtract(d).add(1);
        if (F.isSmall) return d.add(Math.floor(t() * F));
        for (var R = Ae(F, a).value, H = [], J = !0, Y = 0; Y < R.length; Y++) {
          var Q = J ? R[Y] + (Y + 1 < R.length ? R[Y + 1] / a : 0) : a, ee = A(t() * Q);
          H.push(ee), ee < R[Y] && (J = !1);
        }
        return d.add(r.fromArray(H, a, !1));
      }
      var we = function(p, o, e, t) {
        e = e || f, p = String(p), t || (p = p.toLowerCase(), e = e.toLowerCase());
        var d = p.length, m, F = Math.abs(o), R = {};
        for (m = 0; m < e.length; m++)
          R[e[m]] = m;
        for (m = 0; m < d; m++) {
          var H = p[m];
          if (H !== "-" && H in R && R[H] >= F) {
            if (H === "1" && F === 1) continue;
            throw new Error(H + " is not a valid digit in base " + o + ".");
          }
        }
        o = ne(o);
        var J = [], Y = p[0] === "-";
        for (m = Y ? 1 : 0; m < p.length; m++) {
          var H = p[m];
          if (H in R) J.push(ne(R[H]));
          else if (H === "<") {
            var Q = m;
            do
              m++;
            while (p[m] !== ">" && m < p.length);
            J.push(ne(p.slice(Q + 1, m)));
          } else throw new Error(H + " is not a valid character");
        }
        return Fe(J, o, Y);
      };
      function Fe(p, o, e) {
        var t = r[0], d = r[1], m;
        for (m = p.length - 1; m >= 0; m--)
          t = t.add(p[m].times(d)), d = d.times(o);
        return e ? t.negate() : t;
      }
      function Ne(p, o) {
        return o = o || f, p < o.length ? o[p] : "<" + p + ">";
      }
      function Ae(p, o) {
        if (o = n(o), o.isZero()) {
          if (p.isZero()) return { value: [0], isNegative: !1 };
          throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (o.equals(-1)) {
          if (p.isZero()) return { value: [0], isNegative: !1 };
          if (p.isNegative())
            return {
              value: [].concat.apply(
                [],
                Array.apply(null, Array(-p.toJSNumber())).map(Array.prototype.valueOf, [1, 0])
              ),
              isNegative: !1
            };
          var e = Array.apply(null, Array(p.toJSNumber() - 1)).map(Array.prototype.valueOf, [0, 1]);
          return e.unshift([1]), {
            value: [].concat.apply([], e),
            isNegative: !1
          };
        }
        var t = !1;
        if (p.isNegative() && o.isPositive() && (t = !0, p = p.abs()), o.isUnit())
          return p.isZero() ? { value: [0], isNegative: !1 } : {
            value: Array.apply(null, Array(p.toJSNumber())).map(Number.prototype.valueOf, 1),
            isNegative: t
          };
        for (var d = [], m = p, F; m.isNegative() || m.compareAbs(o) >= 0; ) {
          F = m.divmod(o), m = F.quotient;
          var R = F.remainder;
          R.isNegative() && (R = o.minus(R).abs(), m = m.next()), d.push(R.toJSNumber());
        }
        return d.push(m.toJSNumber()), { value: d.reverse(), isNegative: t };
      }
      function pe(p, o, e) {
        var t = Ae(p, o);
        return (t.isNegative ? "-" : "") + t.value.map(function(d) {
          return Ne(d, e);
        }).join("");
      }
      i.prototype.toArray = function(p) {
        return Ae(this, p);
      }, c.prototype.toArray = function(p) {
        return Ae(this, p);
      }, l.prototype.toArray = function(p) {
        return Ae(this, p);
      }, i.prototype.toString = function(p, o) {
        if (p === s && (p = 10), p !== 10 || o) return pe(this, p, o);
        for (var e = this.value, t = e.length, d = String(e[--t]), m = "0000000", F; --t >= 0; )
          F = String(e[t]), d += m.slice(F.length) + F;
        var R = this.sign ? "-" : "";
        return R + d;
      }, c.prototype.toString = function(p, o) {
        return p === s && (p = 10), p != 10 || o ? pe(this, p, o) : String(this.value);
      }, l.prototype.toString = c.prototype.toString, l.prototype.toJSON = i.prototype.toJSON = c.prototype.toJSON = function() {
        return this.toString();
      }, i.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
      }, i.prototype.toJSNumber = i.prototype.valueOf, c.prototype.valueOf = function() {
        return this.value;
      }, c.prototype.toJSNumber = c.prototype.valueOf, l.prototype.valueOf = l.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
      };
      function fe(p) {
        if (y(+p)) {
          var o = +p;
          if (o === A(o))
            return v ? new l(BigInt(o)) : new c(o);
          throw new Error("Invalid integer: " + p);
        }
        var e = p[0] === "-";
        e && (p = p.slice(1));
        var t = p.split(/e/i);
        if (t.length > 2) throw new Error("Invalid integer: " + t.join("e"));
        if (t.length === 2) {
          var d = t[1];
          if (d[0] === "+" && (d = d.slice(1)), d = +d, d !== A(d) || !y(d)) throw new Error("Invalid integer: " + d + " is not a valid exponent.");
          var m = t[0], F = m.indexOf(".");
          if (F >= 0 && (d -= m.length - F - 1, m = m.slice(0, F) + m.slice(F + 1)), d < 0) throw new Error("Cannot include negative exponent part for integers");
          m += new Array(d + 1).join("0"), p = m;
        }
        var R = /^([0-9][0-9]*)$/.test(p);
        if (!R) throw new Error("Invalid integer: " + p);
        if (v)
          return new l(BigInt(e ? "-" + p : p));
        for (var H = [], J = p.length, Y = x, Q = J - Y; J > 0; )
          H.push(+p.slice(Q, J)), Q -= Y, Q < 0 && (Q = 0), J -= Y;
        return _(H), new i(H, e);
      }
      function Be(p) {
        if (v)
          return new l(BigInt(p));
        if (y(p)) {
          if (p !== A(p)) throw new Error(p + " is not an integer.");
          return new c(p);
        }
        return fe(p.toString());
      }
      function ne(p) {
        return typeof p == "number" ? Be(p) : typeof p == "string" ? fe(p) : typeof p == "bigint" ? new l(p) : p;
      }
      for (var de = 0; de < 1e3; de++)
        r[de] = ne(de), de > 0 && (r[-de] = ne(-de));
      return r.one = r[1], r.zero = r[0], r.minusOne = r[-1], r.max = ge, r.min = ue, r.gcd = he, r.lcm = Re, r.isInstance = function(p) {
        return p instanceof i || p instanceof c || p instanceof l;
      }, r.randBetween = Se, r.fromArray = function(p, o, e) {
        return Fe(p.map(ne), ne(o || 10), e);
      }, r;
    })();
    h.hasOwnProperty("exports") && (h.exports = n);
  })(xr)), xr.exports;
}
var Ln = Pn();
const j0 = /* @__PURE__ */ Gt(Ln), Ue = (h, n, s) => {
  h[n] = 255 & s >> 24, h[n + 1] = 255 & s >> 16, h[n + 2] = 255 & s >> 8, h[n + 3] = 255 & s;
}, ke = (h, n) => (255 & h[n]) << 24 | (255 & h[n + 1]) << 16 | (255 & h[n + 2]) << 8 | 255 & h[n + 3], be = (h, n, s) => {
  let a, x;
  if (typeof s == "string") {
    const u = j0(s);
    x = Number(u.and(4294967295)), a = Number(u.shiftRight(32));
  } else
    a = Math.floor(s / 4294967296), x = s - a * 4294967296;
  h[n] = 255 & a >> 24, h[n + 1] = 255 & a >> 16, h[n + 2] = 255 & a >> 8, h[n + 3] = 255 & a, h[n + 4] = 255 & x >> 24, h[n + 5] = 255 & x >> 16, h[n + 6] = 255 & x >> 8, h[n + 7] = 255 & x;
}, le = (h, n) => {
  const a = (255 & h[n + 4]) * 16777216 + ((255 & h[n + 5]) << 16 | (255 & h[n + 6]) << 8 | 255 & h[n + 7]), x = (255 & h[n]) << 24 | (255 & h[n + 1]) << 16 | (255 & h[n + 2]) << 8 | 255 & h[n + 3], g = j0(x).shiftLeft(32).add(a);
  return g.gt(-9007199254740992) && g.lesser(9007199254740992) ? g.toJSNumber() : g.toString();
};
var Ce = /* @__PURE__ */ ((h) => (h.SDK_READY = "sdkStateReady", h.SDK_NOT_READY = "sdkStateNotReady", h.MESSAGE_RECEIVED = "onMessageReceived", h.ROOM_CUSTOM_DATA_RECEIVED = "onRoomCustomDataReceived", h.MESSAGE_MODIFIED = "onMessageModified", h.MESSAGE_REVOKED = "onMessageRevoked", h.MESSAGE_READ_BY_PEER = "onMessageReadByPeer", h.MESSAGE_READ_RECEIPT_RECEIVED = "onMessageReadReceiptReceived", h.CONVERSATION_LIST_UPDATED = "onConversationListUpdated", h.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED = "onTotalUnreadMessageCountUpdated", h.CONVERSATION_GROUP_LIST_UPDATED = "onConversationGroupListUpdated", h.CONVERSATION_IN_GROUP_UPDATED = "onConversationInGroupUpdated", h.GROUP_LIST_UPDATED = "onGroupListUpdated", h.GROUP_ATTRIBUTES_UPDATED = "groupAttributesUpdated", h.GROUP_COUNTER_UPDATED = "onGroupCounterUpdated", h.TOPIC_CREATED = "onTopicCreated", h.TOPIC_DELETED = "onTopicDeleted", h.TOPIC_UPDATED = "onTopicUpdated", h.PROFILE_UPDATED = "onProfileUpdated", h.USER_STATUS_UPDATED = "onUserStatusUpdated", h.BLACKLIST_UPDATED = "blacklistUpdated", h.FRIEND_LIST_UPDATED = "onFriendListUpdated", h.FRIEND_GROUP_LIST_UPDATED = "onFriendGroupListUpdated", h.FRIEND_APPLICATION_LIST_UPDATED = "onFriendApplicationListUpdated", h.MY_FOLLOWERS_LIST_UPDATED = "onMyFollowersListUpdated", h.MY_FOLLOWING_LIST_UPDATED = "onMyFollowingListUpdated", h.MUTUAL_FOLLOWERS_LIST_UPDATED = "onMutualFollowersListUpdated", h.KICKED_OUT = "kickedOut", h.ERROR = "error", h.NET_STATE_CHANGE = "netStateChange", h.ALL_RECEIVE_MESSAGE_OPT_UPDATED = "onAllReceiveMessageOptUpdated", h))(Ce || {}), te = /* @__PURE__ */ ((h) => (h.MSG_TEXT = "TIMTextElem", h.MSG_IMAGE = "TIMImageElem", h.MSG_AUDIO = "TIMSoundElem", h.MSG_FILE = "TIMFileElem", h.MSG_VOIP = "VOIP", h.MSG_FACE = "TIMFaceElem", h.MSG_VIDEO = "TIMVideoFileElem", h.MSG_LOCATION = "TIMLocationElem", h.MSG_GRP_TIP = "TIMGroupTipElem", h.MSG_GRP_SYS_NOTICE = "TIMGroupSystemNoticeElem", h.MSG_CUSTOM = "TIMCustomElem", h.MSG_MERGER = "TIMRelayElem", h.MSG_PRIORITY_HIGH = "High", h.MSG_PRIORITY_NORMAL = "Normal", h.MSG_PRIORITY_LOW = "Low", h.MSG_PRIORITY_LOWEST = "Lowest", h.CONV_C2C = "C2C", h.CONV_GROUP = "GROUP", h.CONV_TOPIC = "TOPIC", h.CONV_SYSTEM = "@TIM#SYSTEM", h[h.CONV_AT_ME = 1] = "CONV_AT_ME", h[h.CONV_AT_ALL = 2] = "CONV_AT_ALL", h[h.CONV_AT_ALL_AT_ME = 3] = "CONV_AT_ALL_AT_ME", h[h.CONV_MARK_TYPE_STAR = 1] = "CONV_MARK_TYPE_STAR", h[h.CONV_MARK_TYPE_UNREAD = 2] = "CONV_MARK_TYPE_UNREAD", h[h.CONV_MARK_TYPE_FOLD = 3] = "CONV_MARK_TYPE_FOLD", h[h.CONV_MARK_TYPE_HIDE = 4] = "CONV_MARK_TYPE_HIDE", h.GRP_WORK = "Private", h.GRP_PUBLIC = "Public", h.GRP_MEETING = "ChatRoom", h.GRP_AVCHATROOM = "AVChatRoom", h.GRP_COMMUNITY = "Community", h.GRP_MBR_ROLE_OWNER = "Owner", h.GRP_MBR_ROLE_ADMIN = "Admin", h.GRP_MBR_ROLE_MEMBER = "Member", h.GRP_MBR_ROLE_CUSTOM = "Custom", h[h.GRP_TIP_MBR_JOIN = 1] = "GRP_TIP_MBR_JOIN", h[h.GRP_TIP_MBR_QUIT = 2] = "GRP_TIP_MBR_QUIT", h[h.GRP_TIP_MBR_KICKED_OUT = 3] = "GRP_TIP_MBR_KICKED_OUT", h[h.GRP_TIP_MBR_SET_ADMIN = 4] = "GRP_TIP_MBR_SET_ADMIN", h[h.GRP_TIP_MBR_CANCELED_ADMIN = 5] = "GRP_TIP_MBR_CANCELED_ADMIN", h[h.GRP_TIP_GRP_PROFILE_UPDATED = 6] = "GRP_TIP_GRP_PROFILE_UPDATED", h[h.GRP_TIP_MBR_PROFILE_UPDATED = 7] = "GRP_TIP_MBR_PROFILE_UPDATED", h[h.GRP_TIP_BAN_AVCHATROOM_MEMBER = 10] = "GRP_TIP_BAN_AVCHATROOM_MEMBER", h[h.GRP_TIP_UNBAN_AVCHATROOM_MEMBER = 11] = "GRP_TIP_UNBAN_AVCHATROOM_MEMBER", h.MSG_REMIND_ACPT_AND_NOTE = "AcceptAndNotify", h.MSG_REMIND_ACPT_NOT_NOTE = "AcceptNotNotify", h.MSG_REMIND_DISCARD = "Discard", h.NOT_RECEIVE_OFFLINE_PUSH_EXCEPT_AT = "AcceptNotNotifyExceptAt", h.NOT_RECEIVE_MSG_EXCEPT_AT = "NotReceiveMsgExceptAt", h.GENDER_UNKNOWN = "Gender_Type_Unknown", h.GENDER_FEMALE = "Gender_Type_Female", h.GENDER_MALE = "Gender_Type_Male", h.KICKED_OUT_MULT_ACCOUNT = "multipleAccount", h.KICKED_OUT_MULT_DEVICE = "multipleDevice", h.KICKED_OUT_USERSIG_EXPIRED = "userSigExpired", h.KICKED_OUT_REST_API = "REST_API_Kick", h.ALLOW_TYPE_ALLOW_ANY = "AllowType_Type_AllowAny", h.ALLOW_TYPE_NEED_CONFIRM = "AllowType_Type_NeedConfirm", h.ALLOW_TYPE_DENY_ANY = "AllowType_Type_DenyAny", h.FORBID_TYPE_NONE = "AdminForbid_Type_None", h.FORBID_TYPE_SEND_OUT = "AdminForbid_Type_SendOut", h.JOIN_OPTIONS_FREE_ACCESS = "FreeAccess", h.JOIN_OPTIONS_NEED_PERMISSION = "NeedPermission", h.JOIN_OPTIONS_DISABLE_APPLY = "DisableApply", h.JOIN_STATUS_SUCCESS = "JoinedSuccess", h.JOIN_STATUS_ALREADY_IN_GROUP = "AlreadyInGroup", h.JOIN_STATUS_WAIT_APPROVAL = "WaitAdminApproval", h.GRP_PROFILE_OWNER_ID = "ownerID", h.GRP_PROFILE_CREATE_TIME = "createTime", h.GRP_PROFILE_LAST_INFO_TIME = "lastInfoTime", h.GRP_PROFILE_MEMBER_NUM = "memberNum", h.GRP_PROFILE_MAX_MEMBER_NUM = "maxMemberNum", h.GRP_PROFILE_JOIN_OPTION = "joinOption", h.GRP_PROFILE_INTRODUCTION = "introduction", h.GRP_PROFILE_NOTIFICATION = "notification", h.GRP_PROFILE_MUTE_ALL_MBRS = "muteAllMembers", h.SNS_ADD_TYPE_SINGLE = "Add_Type_Single", h.SNS_ADD_TYPE_BOTH = "Add_Type_Both", h.SNS_DELETE_TYPE_SINGLE = "Delete_Type_Single", h.SNS_DELETE_TYPE_BOTH = "Delete_Type_Both", h.SNS_APPLICATION_TYPE_BOTH = "Pendency_Type_Both", h.SNS_APPLICATION_SENT_TO_ME = "Pendency_Type_ComeIn", h.SNS_APPLICATION_SENT_BY_ME = "Pendency_Type_SendOut", h.SNS_APPLICATION_AGREE = "Response_Action_Agree", h.SNS_APPLICATION_AGREE_AND_ADD = "Response_Action_AgreeAndAdd", h.SNS_CHECK_TYPE_BOTH = "CheckResult_Type_Both", h.SNS_CHECK_TYPE_SINGLE = "CheckResult_Type_Single", h.SNS_TYPE_NO_RELATION = "CheckResult_Type_NoRelation", h.SNS_TYPE_A_WITH_B = "CheckResult_Type_AWithB", h.SNS_TYPE_B_WITH_A = "CheckResult_Type_BWithA", h.SNS_TYPE_BOTH_WAY = "CheckResult_Type_BothWay", h.NET_STATE_CONNECTED = "connected", h.NET_STATE_CONNECTING = "connecting", h.NET_STATE_DISCONNECTED = "disconnected", h.MSG_AT_ALL = "__kImSDK_MesssageAtALL__", h.READ_ALL_C2C_MSG = "readAllC2CMessage", h.READ_ALL_GROUP_MSG = "readAllGroupMessage", h.READ_ALL_MSG = "readAllMessage", h[h.USER_STATUS_UNKNOWN = 0] = "USER_STATUS_UNKNOWN", h[h.USER_STATUS_ONLINE = 1] = "USER_STATUS_ONLINE", h[h.USER_STATUS_OFFLINE = 2] = "USER_STATUS_OFFLINE", h[h.USER_STATUS_UNLOGINED = 3] = "USER_STATUS_UNLOGINED", h.IOS_OFFLINE_PUSH_NO_SOUND = "push.no_sound", h.IOS_OFFLINE_PUSH_DEFAULT_SOUND = "default", h))(te || {});
let Gn = 0;
const Pe = ({
  to: h = "",
  from: n = "",
  flow: s = "out",
  payload: a = {},
  type: x = te.MSG_TEXT,
  conversationType: u = te.CONV_C2C
} = {}) => {
  if (!h || !n)
    throw new Error("to or from is required");
  return {
    ID: ((f = "WEBIM") => {
      const v = /* @__PURE__ */ new Date(), r = new Date(2010, 1, 1), c = (v.getTime() - r.getTime()).toString(16) + Gn++;
      return `${f}_${c}`;
    })(),
    type: x,
    payload: a,
    conversationID: `${u}${h}`,
    conversationType: u,
    to: h,
    from: n,
    flow: s,
    time: Math.floor(Date.now() / 1e3),
    status: "unSend",
    isRevoked: !1,
    priority: te.MSG_PRIORITY_NORMAL,
    nick: "",
    avatar: "",
    isPeerRead: !1,
    nameCard: "",
    atUserList: [],
    cloudCustomData: "",
    isDeleted: !1,
    isModified: !1,
    needReadReceipt: !1,
    readReceiptInfo: {
      readCount: 0,
      readMembers: [],
      readByPeer: !1
    },
    isBroadcastMessage: !1,
    isSupportExtension: !1,
    revoker: "",
    revokerInfo: { avatar: "", nick: "", userID: "" },
    revokeReason: "",
    sequence: 0,
    hasRiskContent: !1
  };
};
var it = { exports: {} };
function qn(h) {
  throw new Error('Could not dynamically require "' + h + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ot = { exports: {} }, Hn = ot.exports, u0;
function se() {
  return u0 || (u0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a();
    })(Hn, function() {
      var s = s || (function(a, x) {
        var u;
        if (typeof window < "u" && window.crypto && (u = window.crypto), typeof self < "u" && self.crypto && (u = self.crypto), typeof globalThis < "u" && globalThis.crypto && (u = globalThis.crypto), !u && typeof window < "u" && window.msCrypto && (u = window.msCrypto), !u && typeof $t < "u" && $t.crypto && (u = $t.crypto), !u && typeof qn == "function")
          try {
            u = V0;
          } catch {
          }
        var g = function() {
          if (u) {
            if (typeof u.getRandomValues == "function")
              try {
                return u.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof u.randomBytes == "function")
              try {
                return u.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, f = Object.create || /* @__PURE__ */ (function() {
          function A() {
          }
          return function(D) {
            var E;
            return A.prototype = D, E = new A(), A.prototype = null, E;
          };
        })(), v = {}, r = v.lib = {}, i = r.Base = /* @__PURE__ */ (function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(A) {
              var D = f(this);
              return A && D.mixIn(A), (!D.hasOwnProperty("init") || this.init === D.init) && (D.init = function() {
                D.$super.init.apply(this, arguments);
              }), D.init.prototype = D, D.$super = this, D;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var A = this.extend();
              return A.init.apply(A, arguments), A;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(A) {
              for (var D in A)
                A.hasOwnProperty(D) && (this[D] = A[D]);
              A.hasOwnProperty("toString") && (this.toString = A.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        })(), c = r.WordArray = i.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(A, D) {
            A = this.words = A || [], D != x ? this.sigBytes = D : this.sigBytes = A.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(A) {
            return (A || y).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(A) {
            var D = this.words, E = A.words, w = this.sigBytes, b = A.sigBytes;
            if (this.clamp(), w % 4)
              for (var O = 0; O < b; O++) {
                var M = E[O >>> 2] >>> 24 - O % 4 * 8 & 255;
                D[w + O >>> 2] |= M << 24 - (w + O) % 4 * 8;
              }
            else
              for (var k = 0; k < b; k += 4)
                D[w + k >>> 2] = E[k >>> 2];
            return this.sigBytes += b, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var A = this.words, D = this.sigBytes;
            A[D >>> 2] &= 4294967295 << 32 - D % 4 * 8, A.length = a.ceil(D / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var A = i.clone.call(this);
            return A.words = this.words.slice(0), A;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(A) {
            for (var D = [], E = 0; E < A; E += 4)
              D.push(g());
            return new c.init(D, A);
          }
        }), l = v.enc = {}, y = l.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(A) {
            for (var D = A.words, E = A.sigBytes, w = [], b = 0; b < E; b++) {
              var O = D[b >>> 2] >>> 24 - b % 4 * 8 & 255;
              w.push((O >>> 4).toString(16)), w.push((O & 15).toString(16));
            }
            return w.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(A) {
            for (var D = A.length, E = [], w = 0; w < D; w += 2)
              E[w >>> 3] |= parseInt(A.substr(w, 2), 16) << 24 - w % 8 * 4;
            return new c.init(E, D / 2);
          }
        }, C = l.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(A) {
            for (var D = A.words, E = A.sigBytes, w = [], b = 0; b < E; b++) {
              var O = D[b >>> 2] >>> 24 - b % 4 * 8 & 255;
              w.push(String.fromCharCode(O));
            }
            return w.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(A) {
            for (var D = A.length, E = [], w = 0; w < D; w++)
              E[w >>> 2] |= (A.charCodeAt(w) & 255) << 24 - w % 4 * 8;
            return new c.init(E, D);
          }
        }, B = l.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(A) {
            try {
              return decodeURIComponent(escape(C.stringify(A)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(A) {
            return C.parse(unescape(encodeURIComponent(A)));
          }
        }, _ = r.BufferedBlockAlgorithm = i.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new c.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(A) {
            typeof A == "string" && (A = B.parse(A)), this._data.concat(A), this._nDataBytes += A.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(A) {
            var D, E = this._data, w = E.words, b = E.sigBytes, O = this.blockSize, M = O * 4, k = b / M;
            A ? k = a.ceil(k) : k = a.max((k | 0) - this._minBufferSize, 0);
            var S = k * O, T = a.min(S * 4, b);
            if (S) {
              for (var N = 0; N < S; N += O)
                this._doProcessBlock(w, N);
              D = w.splice(0, S), E.sigBytes -= T;
            }
            return new c.init(D, T);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var A = i.clone.call(this);
            return A._data = this._data.clone(), A;
          },
          _minBufferSize: 0
        });
        r.Hasher = _.extend({
          /**
           * Configuration options.
           */
          cfg: i.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(A) {
            this.cfg = this.cfg.extend(A), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            _.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(A) {
            return this._append(A), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(A) {
            A && this._append(A);
            var D = this._doFinalize();
            return D;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(A) {
            return function(D, E) {
              return new A.init(E).finalize(D);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(A) {
            return function(D, E) {
              return new I.HMAC.init(A, E).finalize(D);
            };
          }
        });
        var I = v.algo = {};
        return v;
      })(Math);
      return s;
    });
  })(ot)), ot.exports;
}
var st = { exports: {} }, Kn = st.exports, f0;
function Kt() {
  return f0 || (f0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(Kn, function(s) {
      return (function(a) {
        var x = s, u = x.lib, g = u.Base, f = u.WordArray, v = x.x64 = {};
        v.Word = g.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(r, i) {
            this.high = r, this.low = i;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), v.WordArray = g.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(r, i) {
            r = this.words = r || [], i != a ? this.sigBytes = i : this.sigBytes = r.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var r = this.words, i = r.length, c = [], l = 0; l < i; l++) {
              var y = r[l];
              c.push(y.high), c.push(y.low);
            }
            return f.create(c, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var r = g.clone.call(this), i = r.words = this.words.slice(0), c = i.length, l = 0; l < c; l++)
              i[l] = i[l].clone();
            return r;
          }
        });
      })(), s;
    });
  })(st)), st.exports;
}
var at = { exports: {} }, $n = at.exports, l0;
function Wn() {
  return l0 || (l0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })($n, function(s) {
      return (function() {
        if (typeof ArrayBuffer == "function") {
          var a = s, x = a.lib, u = x.WordArray, g = u.init, f = u.init = function(v) {
            if (v instanceof ArrayBuffer && (v = new Uint8Array(v)), (v instanceof Int8Array || typeof Uint8ClampedArray < "u" && v instanceof Uint8ClampedArray || v instanceof Int16Array || v instanceof Uint16Array || v instanceof Int32Array || v instanceof Uint32Array || v instanceof Float32Array || v instanceof Float64Array) && (v = new Uint8Array(v.buffer, v.byteOffset, v.byteLength)), v instanceof Uint8Array) {
              for (var r = v.byteLength, i = [], c = 0; c < r; c++)
                i[c >>> 2] |= v[c] << 24 - c % 4 * 8;
              g.call(this, i, r);
            } else
              g.apply(this, arguments);
          };
          f.prototype = u;
        }
      })(), s.lib.WordArray;
    });
  })(at)), at.exports;
}
var ct = { exports: {} }, zn = ct.exports, h0;
function Xn() {
  return h0 || (h0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(zn, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.WordArray, g = a.enc;
        g.Utf16 = g.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(v) {
            for (var r = v.words, i = v.sigBytes, c = [], l = 0; l < i; l += 2) {
              var y = r[l >>> 2] >>> 16 - l % 4 * 8 & 65535;
              c.push(String.fromCharCode(y));
            }
            return c.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(v) {
            for (var r = v.length, i = [], c = 0; c < r; c++)
              i[c >>> 1] |= v.charCodeAt(c) << 16 - c % 2 * 16;
            return u.create(i, r * 2);
          }
        }, g.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(v) {
            for (var r = v.words, i = v.sigBytes, c = [], l = 0; l < i; l += 2) {
              var y = f(r[l >>> 2] >>> 16 - l % 4 * 8 & 65535);
              c.push(String.fromCharCode(y));
            }
            return c.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(v) {
            for (var r = v.length, i = [], c = 0; c < r; c++)
              i[c >>> 1] |= f(v.charCodeAt(c) << 16 - c % 2 * 16);
            return u.create(i, r * 2);
          }
        };
        function f(v) {
          return v << 8 & 4278255360 | v >>> 8 & 16711935;
        }
      })(), s.enc.Utf16;
    });
  })(ct)), ct.exports;
}
var ut = { exports: {} }, Vn = ut.exports, x0;
function Le() {
  return x0 || (x0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(Vn, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.WordArray, g = a.enc;
        g.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(v) {
            var r = v.words, i = v.sigBytes, c = this._map;
            v.clamp();
            for (var l = [], y = 0; y < i; y += 3)
              for (var C = r[y >>> 2] >>> 24 - y % 4 * 8 & 255, B = r[y + 1 >>> 2] >>> 24 - (y + 1) % 4 * 8 & 255, _ = r[y + 2 >>> 2] >>> 24 - (y + 2) % 4 * 8 & 255, I = C << 16 | B << 8 | _, A = 0; A < 4 && y + A * 0.75 < i; A++)
                l.push(c.charAt(I >>> 6 * (3 - A) & 63));
            var D = c.charAt(64);
            if (D)
              for (; l.length % 4; )
                l.push(D);
            return l.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(v) {
            var r = v.length, i = this._map, c = this._reverseMap;
            if (!c) {
              c = this._reverseMap = [];
              for (var l = 0; l < i.length; l++)
                c[i.charCodeAt(l)] = l;
            }
            var y = i.charAt(64);
            if (y) {
              var C = v.indexOf(y);
              C !== -1 && (r = C);
            }
            return f(v, r, c);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function f(v, r, i) {
          for (var c = [], l = 0, y = 0; y < r; y++)
            if (y % 4) {
              var C = i[v.charCodeAt(y - 1)] << y % 4 * 2, B = i[v.charCodeAt(y)] >>> 6 - y % 4 * 2, _ = C | B;
              c[l >>> 2] |= _ << 24 - l % 4 * 8, l++;
            }
          return u.create(c, l);
        }
      })(), s.enc.Base64;
    });
  })(ut)), ut.exports;
}
var ft = { exports: {} }, jn = ft.exports, p0;
function Zn() {
  return p0 || (p0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(jn, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.WordArray, g = a.enc;
        g.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(v, r) {
            r === void 0 && (r = !0);
            var i = v.words, c = v.sigBytes, l = r ? this._safe_map : this._map;
            v.clamp();
            for (var y = [], C = 0; C < c; C += 3)
              for (var B = i[C >>> 2] >>> 24 - C % 4 * 8 & 255, _ = i[C + 1 >>> 2] >>> 24 - (C + 1) % 4 * 8 & 255, I = i[C + 2 >>> 2] >>> 24 - (C + 2) % 4 * 8 & 255, A = B << 16 | _ << 8 | I, D = 0; D < 4 && C + D * 0.75 < c; D++)
                y.push(l.charAt(A >>> 6 * (3 - D) & 63));
            var E = l.charAt(64);
            if (E)
              for (; y.length % 4; )
                y.push(E);
            return y.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(v, r) {
            r === void 0 && (r = !0);
            var i = v.length, c = r ? this._safe_map : this._map, l = this._reverseMap;
            if (!l) {
              l = this._reverseMap = [];
              for (var y = 0; y < c.length; y++)
                l[c.charCodeAt(y)] = y;
            }
            var C = c.charAt(64);
            if (C) {
              var B = v.indexOf(C);
              B !== -1 && (i = B);
            }
            return f(v, i, l);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function f(v, r, i) {
          for (var c = [], l = 0, y = 0; y < r; y++)
            if (y % 4) {
              var C = i[v.charCodeAt(y - 1)] << y % 4 * 2, B = i[v.charCodeAt(y)] >>> 6 - y % 4 * 2, _ = C | B;
              c[l >>> 2] |= _ << 24 - l % 4 * 8, l++;
            }
          return u.create(c, l);
        }
      })(), s.enc.Base64url;
    });
  })(ft)), ft.exports;
}
var lt = { exports: {} }, Jn = lt.exports, d0;
function Ge() {
  return d0 || (d0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(Jn, function(s) {
      return (function(a) {
        var x = s, u = x.lib, g = u.WordArray, f = u.Hasher, v = x.algo, r = [];
        (function() {
          for (var B = 0; B < 64; B++)
            r[B] = a.abs(a.sin(B + 1)) * 4294967296 | 0;
        })();
        var i = v.MD5 = f.extend({
          _doReset: function() {
            this._hash = new g.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(B, _) {
            for (var I = 0; I < 16; I++) {
              var A = _ + I, D = B[A];
              B[A] = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360;
            }
            var E = this._hash.words, w = B[_ + 0], b = B[_ + 1], O = B[_ + 2], M = B[_ + 3], k = B[_ + 4], S = B[_ + 5], T = B[_ + 6], N = B[_ + 7], L = B[_ + 8], K = B[_ + 9], P = B[_ + 10], G = B[_ + 11], V = B[_ + 12], X = B[_ + 13], Z = B[_ + 14], j = B[_ + 15], U = E[0], q = E[1], W = E[2], $ = E[3];
            U = c(U, q, W, $, w, 7, r[0]), $ = c($, U, q, W, b, 12, r[1]), W = c(W, $, U, q, O, 17, r[2]), q = c(q, W, $, U, M, 22, r[3]), U = c(U, q, W, $, k, 7, r[4]), $ = c($, U, q, W, S, 12, r[5]), W = c(W, $, U, q, T, 17, r[6]), q = c(q, W, $, U, N, 22, r[7]), U = c(U, q, W, $, L, 7, r[8]), $ = c($, U, q, W, K, 12, r[9]), W = c(W, $, U, q, P, 17, r[10]), q = c(q, W, $, U, G, 22, r[11]), U = c(U, q, W, $, V, 7, r[12]), $ = c($, U, q, W, X, 12, r[13]), W = c(W, $, U, q, Z, 17, r[14]), q = c(q, W, $, U, j, 22, r[15]), U = l(U, q, W, $, b, 5, r[16]), $ = l($, U, q, W, T, 9, r[17]), W = l(W, $, U, q, G, 14, r[18]), q = l(q, W, $, U, w, 20, r[19]), U = l(U, q, W, $, S, 5, r[20]), $ = l($, U, q, W, P, 9, r[21]), W = l(W, $, U, q, j, 14, r[22]), q = l(q, W, $, U, k, 20, r[23]), U = l(U, q, W, $, K, 5, r[24]), $ = l($, U, q, W, Z, 9, r[25]), W = l(W, $, U, q, M, 14, r[26]), q = l(q, W, $, U, L, 20, r[27]), U = l(U, q, W, $, X, 5, r[28]), $ = l($, U, q, W, O, 9, r[29]), W = l(W, $, U, q, N, 14, r[30]), q = l(q, W, $, U, V, 20, r[31]), U = y(U, q, W, $, S, 4, r[32]), $ = y($, U, q, W, L, 11, r[33]), W = y(W, $, U, q, G, 16, r[34]), q = y(q, W, $, U, Z, 23, r[35]), U = y(U, q, W, $, b, 4, r[36]), $ = y($, U, q, W, k, 11, r[37]), W = y(W, $, U, q, N, 16, r[38]), q = y(q, W, $, U, P, 23, r[39]), U = y(U, q, W, $, X, 4, r[40]), $ = y($, U, q, W, w, 11, r[41]), W = y(W, $, U, q, M, 16, r[42]), q = y(q, W, $, U, T, 23, r[43]), U = y(U, q, W, $, K, 4, r[44]), $ = y($, U, q, W, V, 11, r[45]), W = y(W, $, U, q, j, 16, r[46]), q = y(q, W, $, U, O, 23, r[47]), U = C(U, q, W, $, w, 6, r[48]), $ = C($, U, q, W, N, 10, r[49]), W = C(W, $, U, q, Z, 15, r[50]), q = C(q, W, $, U, S, 21, r[51]), U = C(U, q, W, $, V, 6, r[52]), $ = C($, U, q, W, M, 10, r[53]), W = C(W, $, U, q, P, 15, r[54]), q = C(q, W, $, U, b, 21, r[55]), U = C(U, q, W, $, L, 6, r[56]), $ = C($, U, q, W, j, 10, r[57]), W = C(W, $, U, q, T, 15, r[58]), q = C(q, W, $, U, X, 21, r[59]), U = C(U, q, W, $, k, 6, r[60]), $ = C($, U, q, W, G, 10, r[61]), W = C(W, $, U, q, O, 15, r[62]), q = C(q, W, $, U, K, 21, r[63]), E[0] = E[0] + U | 0, E[1] = E[1] + q | 0, E[2] = E[2] + W | 0, E[3] = E[3] + $ | 0;
          },
          _doFinalize: function() {
            var B = this._data, _ = B.words, I = this._nDataBytes * 8, A = B.sigBytes * 8;
            _[A >>> 5] |= 128 << 24 - A % 32;
            var D = a.floor(I / 4294967296), E = I;
            _[(A + 64 >>> 9 << 4) + 15] = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, _[(A + 64 >>> 9 << 4) + 14] = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360, B.sigBytes = (_.length + 1) * 4, this._process();
            for (var w = this._hash, b = w.words, O = 0; O < 4; O++) {
              var M = b[O];
              b[O] = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360;
            }
            return w;
          },
          clone: function() {
            var B = f.clone.call(this);
            return B._hash = this._hash.clone(), B;
          }
        });
        function c(B, _, I, A, D, E, w) {
          var b = B + (_ & I | ~_ & A) + D + w;
          return (b << E | b >>> 32 - E) + _;
        }
        function l(B, _, I, A, D, E, w) {
          var b = B + (_ & A | I & ~A) + D + w;
          return (b << E | b >>> 32 - E) + _;
        }
        function y(B, _, I, A, D, E, w) {
          var b = B + (_ ^ I ^ A) + D + w;
          return (b << E | b >>> 32 - E) + _;
        }
        function C(B, _, I, A, D, E, w) {
          var b = B + (I ^ (_ | ~A)) + D + w;
          return (b << E | b >>> 32 - E) + _;
        }
        x.MD5 = f._createHelper(i), x.HmacMD5 = f._createHmacHelper(i);
      })(Math), s.MD5;
    });
  })(lt)), lt.exports;
}
var ht = { exports: {} }, Qn = ht.exports, v0;
function Z0() {
  return v0 || (v0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(Qn, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.WordArray, g = x.Hasher, f = a.algo, v = [], r = f.SHA1 = g.extend({
          _doReset: function() {
            this._hash = new u.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(i, c) {
            for (var l = this._hash.words, y = l[0], C = l[1], B = l[2], _ = l[3], I = l[4], A = 0; A < 80; A++) {
              if (A < 16)
                v[A] = i[c + A] | 0;
              else {
                var D = v[A - 3] ^ v[A - 8] ^ v[A - 14] ^ v[A - 16];
                v[A] = D << 1 | D >>> 31;
              }
              var E = (y << 5 | y >>> 27) + I + v[A];
              A < 20 ? E += (C & B | ~C & _) + 1518500249 : A < 40 ? E += (C ^ B ^ _) + 1859775393 : A < 60 ? E += (C & B | C & _ | B & _) - 1894007588 : E += (C ^ B ^ _) - 899497514, I = _, _ = B, B = C << 30 | C >>> 2, C = y, y = E;
            }
            l[0] = l[0] + y | 0, l[1] = l[1] + C | 0, l[2] = l[2] + B | 0, l[3] = l[3] + _ | 0, l[4] = l[4] + I | 0;
          },
          _doFinalize: function() {
            var i = this._data, c = i.words, l = this._nDataBytes * 8, y = i.sigBytes * 8;
            return c[y >>> 5] |= 128 << 24 - y % 32, c[(y + 64 >>> 9 << 4) + 14] = Math.floor(l / 4294967296), c[(y + 64 >>> 9 << 4) + 15] = l, i.sigBytes = c.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var i = g.clone.call(this);
            return i._hash = this._hash.clone(), i;
          }
        });
        a.SHA1 = g._createHelper(r), a.HmacSHA1 = g._createHmacHelper(r);
      })(), s.SHA1;
    });
  })(ht)), ht.exports;
}
var xt = { exports: {} }, Yn = xt.exports, y0;
function Cr() {
  return y0 || (y0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(Yn, function(s) {
      return (function(a) {
        var x = s, u = x.lib, g = u.WordArray, f = u.Hasher, v = x.algo, r = [], i = [];
        (function() {
          function y(I) {
            for (var A = a.sqrt(I), D = 2; D <= A; D++)
              if (!(I % D))
                return !1;
            return !0;
          }
          function C(I) {
            return (I - (I | 0)) * 4294967296 | 0;
          }
          for (var B = 2, _ = 0; _ < 64; )
            y(B) && (_ < 8 && (r[_] = C(a.pow(B, 1 / 2))), i[_] = C(a.pow(B, 1 / 3)), _++), B++;
        })();
        var c = [], l = v.SHA256 = f.extend({
          _doReset: function() {
            this._hash = new g.init(r.slice(0));
          },
          _doProcessBlock: function(y, C) {
            for (var B = this._hash.words, _ = B[0], I = B[1], A = B[2], D = B[3], E = B[4], w = B[5], b = B[6], O = B[7], M = 0; M < 64; M++) {
              if (M < 16)
                c[M] = y[C + M] | 0;
              else {
                var k = c[M - 15], S = (k << 25 | k >>> 7) ^ (k << 14 | k >>> 18) ^ k >>> 3, T = c[M - 2], N = (T << 15 | T >>> 17) ^ (T << 13 | T >>> 19) ^ T >>> 10;
                c[M] = S + c[M - 7] + N + c[M - 16];
              }
              var L = E & w ^ ~E & b, K = _ & I ^ _ & A ^ I & A, P = (_ << 30 | _ >>> 2) ^ (_ << 19 | _ >>> 13) ^ (_ << 10 | _ >>> 22), G = (E << 26 | E >>> 6) ^ (E << 21 | E >>> 11) ^ (E << 7 | E >>> 25), V = O + G + L + i[M] + c[M], X = P + K;
              O = b, b = w, w = E, E = D + V | 0, D = A, A = I, I = _, _ = V + X | 0;
            }
            B[0] = B[0] + _ | 0, B[1] = B[1] + I | 0, B[2] = B[2] + A | 0, B[3] = B[3] + D | 0, B[4] = B[4] + E | 0, B[5] = B[5] + w | 0, B[6] = B[6] + b | 0, B[7] = B[7] + O | 0;
          },
          _doFinalize: function() {
            var y = this._data, C = y.words, B = this._nDataBytes * 8, _ = y.sigBytes * 8;
            return C[_ >>> 5] |= 128 << 24 - _ % 32, C[(_ + 64 >>> 9 << 4) + 14] = a.floor(B / 4294967296), C[(_ + 64 >>> 9 << 4) + 15] = B, y.sigBytes = C.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var y = f.clone.call(this);
            return y._hash = this._hash.clone(), y;
          }
        });
        x.SHA256 = f._createHelper(l), x.HmacSHA256 = f._createHmacHelper(l);
      })(Math), s.SHA256;
    });
  })(xt)), xt.exports;
}
var pt = { exports: {} }, ei = pt.exports, g0;
function ti() {
  return g0 || (g0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Cr());
    })(ei, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.WordArray, g = a.algo, f = g.SHA256, v = g.SHA224 = f.extend({
          _doReset: function() {
            this._hash = new u.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var r = f._doFinalize.call(this);
            return r.sigBytes -= 4, r;
          }
        });
        a.SHA224 = f._createHelper(v), a.HmacSHA224 = f._createHmacHelper(v);
      })(), s.SHA224;
    });
  })(pt)), pt.exports;
}
var dt = { exports: {} }, ri = dt.exports, m0;
function J0() {
  return m0 || (m0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Kt());
    })(ri, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.Hasher, g = a.x64, f = g.Word, v = g.WordArray, r = a.algo;
        function i() {
          return f.create.apply(f, arguments);
        }
        var c = [
          i(1116352408, 3609767458),
          i(1899447441, 602891725),
          i(3049323471, 3964484399),
          i(3921009573, 2173295548),
          i(961987163, 4081628472),
          i(1508970993, 3053834265),
          i(2453635748, 2937671579),
          i(2870763221, 3664609560),
          i(3624381080, 2734883394),
          i(310598401, 1164996542),
          i(607225278, 1323610764),
          i(1426881987, 3590304994),
          i(1925078388, 4068182383),
          i(2162078206, 991336113),
          i(2614888103, 633803317),
          i(3248222580, 3479774868),
          i(3835390401, 2666613458),
          i(4022224774, 944711139),
          i(264347078, 2341262773),
          i(604807628, 2007800933),
          i(770255983, 1495990901),
          i(1249150122, 1856431235),
          i(1555081692, 3175218132),
          i(1996064986, 2198950837),
          i(2554220882, 3999719339),
          i(2821834349, 766784016),
          i(2952996808, 2566594879),
          i(3210313671, 3203337956),
          i(3336571891, 1034457026),
          i(3584528711, 2466948901),
          i(113926993, 3758326383),
          i(338241895, 168717936),
          i(666307205, 1188179964),
          i(773529912, 1546045734),
          i(1294757372, 1522805485),
          i(1396182291, 2643833823),
          i(1695183700, 2343527390),
          i(1986661051, 1014477480),
          i(2177026350, 1206759142),
          i(2456956037, 344077627),
          i(2730485921, 1290863460),
          i(2820302411, 3158454273),
          i(3259730800, 3505952657),
          i(3345764771, 106217008),
          i(3516065817, 3606008344),
          i(3600352804, 1432725776),
          i(4094571909, 1467031594),
          i(275423344, 851169720),
          i(430227734, 3100823752),
          i(506948616, 1363258195),
          i(659060556, 3750685593),
          i(883997877, 3785050280),
          i(958139571, 3318307427),
          i(1322822218, 3812723403),
          i(1537002063, 2003034995),
          i(1747873779, 3602036899),
          i(1955562222, 1575990012),
          i(2024104815, 1125592928),
          i(2227730452, 2716904306),
          i(2361852424, 442776044),
          i(2428436474, 593698344),
          i(2756734187, 3733110249),
          i(3204031479, 2999351573),
          i(3329325298, 3815920427),
          i(3391569614, 3928383900),
          i(3515267271, 566280711),
          i(3940187606, 3454069534),
          i(4118630271, 4000239992),
          i(116418474, 1914138554),
          i(174292421, 2731055270),
          i(289380356, 3203993006),
          i(460393269, 320620315),
          i(685471733, 587496836),
          i(852142971, 1086792851),
          i(1017036298, 365543100),
          i(1126000580, 2618297676),
          i(1288033470, 3409855158),
          i(1501505948, 4234509866),
          i(1607167915, 987167468),
          i(1816402316, 1246189591)
        ], l = [];
        (function() {
          for (var C = 0; C < 80; C++)
            l[C] = i();
        })();
        var y = r.SHA512 = u.extend({
          _doReset: function() {
            this._hash = new v.init([
              new f.init(1779033703, 4089235720),
              new f.init(3144134277, 2227873595),
              new f.init(1013904242, 4271175723),
              new f.init(2773480762, 1595750129),
              new f.init(1359893119, 2917565137),
              new f.init(2600822924, 725511199),
              new f.init(528734635, 4215389547),
              new f.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(C, B) {
            for (var _ = this._hash.words, I = _[0], A = _[1], D = _[2], E = _[3], w = _[4], b = _[5], O = _[6], M = _[7], k = I.high, S = I.low, T = A.high, N = A.low, L = D.high, K = D.low, P = E.high, G = E.low, V = w.high, X = w.low, Z = b.high, j = b.low, U = O.high, q = O.low, W = M.high, $ = M.low, ie = k, oe = S, ae = T, re = N, xe = L, ce = K, ye = P, ge = G, ue = V, he = X, Re = Z, Se = j, we = U, Fe = q, Ne = W, Ae = $, pe = 0; pe < 80; pe++) {
              var fe, Be, ne = l[pe];
              if (pe < 16)
                Be = ne.high = C[B + pe * 2] | 0, fe = ne.low = C[B + pe * 2 + 1] | 0;
              else {
                var de = l[pe - 15], p = de.high, o = de.low, e = (p >>> 1 | o << 31) ^ (p >>> 8 | o << 24) ^ p >>> 7, t = (o >>> 1 | p << 31) ^ (o >>> 8 | p << 24) ^ (o >>> 7 | p << 25), d = l[pe - 2], m = d.high, F = d.low, R = (m >>> 19 | F << 13) ^ (m << 3 | F >>> 29) ^ m >>> 6, H = (F >>> 19 | m << 13) ^ (F << 3 | m >>> 29) ^ (F >>> 6 | m << 26), J = l[pe - 7], Y = J.high, Q = J.low, ee = l[pe - 16], Ee = ee.high, me = ee.low;
                fe = t + Q, Be = e + Y + (fe >>> 0 < t >>> 0 ? 1 : 0), fe = fe + H, Be = Be + R + (fe >>> 0 < H >>> 0 ? 1 : 0), fe = fe + me, Be = Be + Ee + (fe >>> 0 < me >>> 0 ? 1 : 0), ne.high = Be, ne.low = fe;
              }
              var Ke = ue & Re ^ ~ue & we, qe = he & Se ^ ~he & Fe, en = ie & ae ^ ie & xe ^ ae & xe, tn = oe & re ^ oe & ce ^ re & ce, rn = (ie >>> 28 | oe << 4) ^ (ie << 30 | oe >>> 2) ^ (ie << 25 | oe >>> 7), Ar = (oe >>> 28 | ie << 4) ^ (oe << 30 | ie >>> 2) ^ (oe << 25 | ie >>> 7), nn = (ue >>> 14 | he << 18) ^ (ue >>> 18 | he << 14) ^ (ue << 23 | he >>> 9), on = (he >>> 14 | ue << 18) ^ (he >>> 18 | ue << 14) ^ (he << 23 | ue >>> 9), Br = c[pe], sn = Br.high, _r = Br.low, _e = Ae + on, Ie = Ne + nn + (_e >>> 0 < Ae >>> 0 ? 1 : 0), _e = _e + qe, Ie = Ie + Ke + (_e >>> 0 < qe >>> 0 ? 1 : 0), _e = _e + _r, Ie = Ie + sn + (_e >>> 0 < _r >>> 0 ? 1 : 0), _e = _e + fe, Ie = Ie + Be + (_e >>> 0 < fe >>> 0 ? 1 : 0), Dr = Ar + tn, an = rn + en + (Dr >>> 0 < Ar >>> 0 ? 1 : 0);
              Ne = we, Ae = Fe, we = Re, Fe = Se, Re = ue, Se = he, he = ge + _e | 0, ue = ye + Ie + (he >>> 0 < ge >>> 0 ? 1 : 0) | 0, ye = xe, ge = ce, xe = ae, ce = re, ae = ie, re = oe, oe = _e + Dr | 0, ie = Ie + an + (oe >>> 0 < _e >>> 0 ? 1 : 0) | 0;
            }
            S = I.low = S + oe, I.high = k + ie + (S >>> 0 < oe >>> 0 ? 1 : 0), N = A.low = N + re, A.high = T + ae + (N >>> 0 < re >>> 0 ? 1 : 0), K = D.low = K + ce, D.high = L + xe + (K >>> 0 < ce >>> 0 ? 1 : 0), G = E.low = G + ge, E.high = P + ye + (G >>> 0 < ge >>> 0 ? 1 : 0), X = w.low = X + he, w.high = V + ue + (X >>> 0 < he >>> 0 ? 1 : 0), j = b.low = j + Se, b.high = Z + Re + (j >>> 0 < Se >>> 0 ? 1 : 0), q = O.low = q + Fe, O.high = U + we + (q >>> 0 < Fe >>> 0 ? 1 : 0), $ = M.low = $ + Ae, M.high = W + Ne + ($ >>> 0 < Ae >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var C = this._data, B = C.words, _ = this._nDataBytes * 8, I = C.sigBytes * 8;
            B[I >>> 5] |= 128 << 24 - I % 32, B[(I + 128 >>> 10 << 5) + 30] = Math.floor(_ / 4294967296), B[(I + 128 >>> 10 << 5) + 31] = _, C.sigBytes = B.length * 4, this._process();
            var A = this._hash.toX32();
            return A;
          },
          clone: function() {
            var C = u.clone.call(this);
            return C._hash = this._hash.clone(), C;
          },
          blockSize: 1024 / 32
        });
        a.SHA512 = u._createHelper(y), a.HmacSHA512 = u._createHmacHelper(y);
      })(), s.SHA512;
    });
  })(dt)), dt.exports;
}
var vt = { exports: {} }, ni = vt.exports, C0;
function ii() {
  return C0 || (C0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Kt(), J0());
    })(ni, function(s) {
      return (function() {
        var a = s, x = a.x64, u = x.Word, g = x.WordArray, f = a.algo, v = f.SHA512, r = f.SHA384 = v.extend({
          _doReset: function() {
            this._hash = new g.init([
              new u.init(3418070365, 3238371032),
              new u.init(1654270250, 914150663),
              new u.init(2438529370, 812702999),
              new u.init(355462360, 4144912697),
              new u.init(1731405415, 4290775857),
              new u.init(2394180231, 1750603025),
              new u.init(3675008525, 1694076839),
              new u.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var i = v._doFinalize.call(this);
            return i.sigBytes -= 16, i;
          }
        });
        a.SHA384 = v._createHelper(r), a.HmacSHA384 = v._createHmacHelper(r);
      })(), s.SHA384;
    });
  })(vt)), vt.exports;
}
var yt = { exports: {} }, oi = yt.exports, E0;
function si() {
  return E0 || (E0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Kt());
    })(oi, function(s) {
      return (function(a) {
        var x = s, u = x.lib, g = u.WordArray, f = u.Hasher, v = x.x64, r = v.Word, i = x.algo, c = [], l = [], y = [];
        (function() {
          for (var _ = 1, I = 0, A = 0; A < 24; A++) {
            c[_ + 5 * I] = (A + 1) * (A + 2) / 2 % 64;
            var D = I % 5, E = (2 * _ + 3 * I) % 5;
            _ = D, I = E;
          }
          for (var _ = 0; _ < 5; _++)
            for (var I = 0; I < 5; I++)
              l[_ + 5 * I] = I + (2 * _ + 3 * I) % 5 * 5;
          for (var w = 1, b = 0; b < 24; b++) {
            for (var O = 0, M = 0, k = 0; k < 7; k++) {
              if (w & 1) {
                var S = (1 << k) - 1;
                S < 32 ? M ^= 1 << S : O ^= 1 << S - 32;
              }
              w & 128 ? w = w << 1 ^ 113 : w <<= 1;
            }
            y[b] = r.create(O, M);
          }
        })();
        var C = [];
        (function() {
          for (var _ = 0; _ < 25; _++)
            C[_] = r.create();
        })();
        var B = i.SHA3 = f.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: f.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var _ = this._state = [], I = 0; I < 25; I++)
              _[I] = new r.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(_, I) {
            for (var A = this._state, D = this.blockSize / 2, E = 0; E < D; E++) {
              var w = _[I + 2 * E], b = _[I + 2 * E + 1];
              w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, b = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360;
              var O = A[E];
              O.high ^= b, O.low ^= w;
            }
            for (var M = 0; M < 24; M++) {
              for (var k = 0; k < 5; k++) {
                for (var S = 0, T = 0, N = 0; N < 5; N++) {
                  var O = A[k + 5 * N];
                  S ^= O.high, T ^= O.low;
                }
                var L = C[k];
                L.high = S, L.low = T;
              }
              for (var k = 0; k < 5; k++)
                for (var K = C[(k + 4) % 5], P = C[(k + 1) % 5], G = P.high, V = P.low, S = K.high ^ (G << 1 | V >>> 31), T = K.low ^ (V << 1 | G >>> 31), N = 0; N < 5; N++) {
                  var O = A[k + 5 * N];
                  O.high ^= S, O.low ^= T;
                }
              for (var X = 1; X < 25; X++) {
                var S, T, O = A[X], Z = O.high, j = O.low, U = c[X];
                U < 32 ? (S = Z << U | j >>> 32 - U, T = j << U | Z >>> 32 - U) : (S = j << U - 32 | Z >>> 64 - U, T = Z << U - 32 | j >>> 64 - U);
                var q = C[l[X]];
                q.high = S, q.low = T;
              }
              var W = C[0], $ = A[0];
              W.high = $.high, W.low = $.low;
              for (var k = 0; k < 5; k++)
                for (var N = 0; N < 5; N++) {
                  var X = k + 5 * N, O = A[X], ie = C[X], oe = C[(k + 1) % 5 + 5 * N], ae = C[(k + 2) % 5 + 5 * N];
                  O.high = ie.high ^ ~oe.high & ae.high, O.low = ie.low ^ ~oe.low & ae.low;
                }
              var O = A[0], re = y[M];
              O.high ^= re.high, O.low ^= re.low;
            }
          },
          _doFinalize: function() {
            var _ = this._data, I = _.words;
            this._nDataBytes * 8;
            var A = _.sigBytes * 8, D = this.blockSize * 32;
            I[A >>> 5] |= 1 << 24 - A % 32, I[(a.ceil((A + 1) / D) * D >>> 5) - 1] |= 128, _.sigBytes = I.length * 4, this._process();
            for (var E = this._state, w = this.cfg.outputLength / 8, b = w / 8, O = [], M = 0; M < b; M++) {
              var k = E[M], S = k.high, T = k.low;
              S = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, T = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, O.push(T), O.push(S);
            }
            return new g.init(O, w);
          },
          clone: function() {
            for (var _ = f.clone.call(this), I = _._state = this._state.slice(0), A = 0; A < 25; A++)
              I[A] = I[A].clone();
            return _;
          }
        });
        x.SHA3 = f._createHelper(B), x.HmacSHA3 = f._createHmacHelper(B);
      })(Math), s.SHA3;
    });
  })(yt)), yt.exports;
}
var gt = { exports: {} }, ai = gt.exports, A0;
function ci() {
  return A0 || (A0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(ai, function(s) {
      return (function(a) {
        var x = s, u = x.lib, g = u.WordArray, f = u.Hasher, v = x.algo, r = g.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), i = g.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), c = g.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), l = g.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), y = g.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), C = g.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), B = v.RIPEMD160 = f.extend({
          _doReset: function() {
            this._hash = g.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(b, O) {
            for (var M = 0; M < 16; M++) {
              var k = O + M, S = b[k];
              b[k] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360;
            }
            var T = this._hash.words, N = y.words, L = C.words, K = r.words, P = i.words, G = c.words, V = l.words, X, Z, j, U, q, W, $, ie, oe, ae;
            W = X = T[0], $ = Z = T[1], ie = j = T[2], oe = U = T[3], ae = q = T[4];
            for (var re, M = 0; M < 80; M += 1)
              re = X + b[O + K[M]] | 0, M < 16 ? re += _(Z, j, U) + N[0] : M < 32 ? re += I(Z, j, U) + N[1] : M < 48 ? re += A(Z, j, U) + N[2] : M < 64 ? re += D(Z, j, U) + N[3] : re += E(Z, j, U) + N[4], re = re | 0, re = w(re, G[M]), re = re + q | 0, X = q, q = U, U = w(j, 10), j = Z, Z = re, re = W + b[O + P[M]] | 0, M < 16 ? re += E($, ie, oe) + L[0] : M < 32 ? re += D($, ie, oe) + L[1] : M < 48 ? re += A($, ie, oe) + L[2] : M < 64 ? re += I($, ie, oe) + L[3] : re += _($, ie, oe) + L[4], re = re | 0, re = w(re, V[M]), re = re + ae | 0, W = ae, ae = oe, oe = w(ie, 10), ie = $, $ = re;
            re = T[1] + j + oe | 0, T[1] = T[2] + U + ae | 0, T[2] = T[3] + q + W | 0, T[3] = T[4] + X + $ | 0, T[4] = T[0] + Z + ie | 0, T[0] = re;
          },
          _doFinalize: function() {
            var b = this._data, O = b.words, M = this._nDataBytes * 8, k = b.sigBytes * 8;
            O[k >>> 5] |= 128 << 24 - k % 32, O[(k + 64 >>> 9 << 4) + 14] = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360, b.sigBytes = (O.length + 1) * 4, this._process();
            for (var S = this._hash, T = S.words, N = 0; N < 5; N++) {
              var L = T[N];
              T[N] = (L << 8 | L >>> 24) & 16711935 | (L << 24 | L >>> 8) & 4278255360;
            }
            return S;
          },
          clone: function() {
            var b = f.clone.call(this);
            return b._hash = this._hash.clone(), b;
          }
        });
        function _(b, O, M) {
          return b ^ O ^ M;
        }
        function I(b, O, M) {
          return b & O | ~b & M;
        }
        function A(b, O, M) {
          return (b | ~O) ^ M;
        }
        function D(b, O, M) {
          return b & M | O & ~M;
        }
        function E(b, O, M) {
          return b ^ (O | ~M);
        }
        function w(b, O) {
          return b << O | b >>> 32 - O;
        }
        x.RIPEMD160 = f._createHelper(B), x.HmacRIPEMD160 = f._createHmacHelper(B);
      })(), s.RIPEMD160;
    });
  })(gt)), gt.exports;
}
var mt = { exports: {} }, ui = mt.exports, B0;
function Er() {
  return B0 || (B0 = 1, (function(h, n) {
    (function(s, a) {
      h.exports = a(se());
    })(ui, function(s) {
      (function() {
        var a = s, x = a.lib, u = x.Base, g = a.enc, f = g.Utf8, v = a.algo;
        v.HMAC = u.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(r, i) {
            r = this._hasher = new r.init(), typeof i == "string" && (i = f.parse(i));
            var c = r.blockSize, l = c * 4;
            i.sigBytes > l && (i = r.finalize(i)), i.clamp();
            for (var y = this._oKey = i.clone(), C = this._iKey = i.clone(), B = y.words, _ = C.words, I = 0; I < c; I++)
              B[I] ^= 1549556828, _[I] ^= 909522486;
            y.sigBytes = C.sigBytes = l, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var r = this._hasher;
            r.reset(), r.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(r) {
            return this._hasher.update(r), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(r) {
            var i = this._hasher, c = i.finalize(r);
            i.reset();
            var l = i.finalize(this._oKey.clone().concat(c));
            return l;
          }
        });
      })();
    });
  })(mt)), mt.exports;
}
var Ct = { exports: {} }, fi = Ct.exports, _0;
function li() {
  return _0 || (_0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Cr(), Er());
    })(fi, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.Base, g = x.WordArray, f = a.algo, v = f.SHA256, r = f.HMAC, i = f.PBKDF2 = u.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: u.extend({
            keySize: 128 / 32,
            hasher: v,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(c) {
            this.cfg = this.cfg.extend(c);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(c, l) {
            for (var y = this.cfg, C = r.create(y.hasher, c), B = g.create(), _ = g.create([1]), I = B.words, A = _.words, D = y.keySize, E = y.iterations; I.length < D; ) {
              var w = C.update(l).finalize(_);
              C.reset();
              for (var b = w.words, O = b.length, M = w, k = 1; k < E; k++) {
                M = C.finalize(M), C.reset();
                for (var S = M.words, T = 0; T < O; T++)
                  b[T] ^= S[T];
              }
              B.concat(w), A[0]++;
            }
            return B.sigBytes = D * 4, B;
          }
        });
        a.PBKDF2 = function(c, l, y) {
          return i.create(y).compute(c, l);
        };
      })(), s.PBKDF2;
    });
  })(Ct)), Ct.exports;
}
var Et = { exports: {} }, hi = Et.exports, D0;
function Me() {
  return D0 || (D0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Z0(), Er());
    })(hi, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.Base, g = x.WordArray, f = a.algo, v = f.MD5, r = f.EvpKDF = u.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: u.extend({
            keySize: 128 / 32,
            hasher: v,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(i) {
            this.cfg = this.cfg.extend(i);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(i, c) {
            for (var l, y = this.cfg, C = y.hasher.create(), B = g.create(), _ = B.words, I = y.keySize, A = y.iterations; _.length < I; ) {
              l && C.update(l), l = C.update(i).finalize(c), C.reset();
              for (var D = 1; D < A; D++)
                l = C.finalize(l), C.reset();
              B.concat(l);
            }
            return B.sigBytes = I * 4, B;
          }
        });
        a.EvpKDF = function(i, c, l) {
          return r.create(l).compute(i, c);
        };
      })(), s.EvpKDF;
    });
  })(Et)), Et.exports;
}
var At = { exports: {} }, xi = At.exports, w0;
function ve() {
  return w0 || (w0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Me());
    })(xi, function(s) {
      s.lib.Cipher || (function(a) {
        var x = s, u = x.lib, g = u.Base, f = u.WordArray, v = u.BufferedBlockAlgorithm, r = x.enc;
        r.Utf8;
        var i = r.Base64, c = x.algo, l = c.EvpKDF, y = u.Cipher = v.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: g.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(S, T) {
            return this.create(this._ENC_XFORM_MODE, S, T);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(S, T) {
            return this.create(this._DEC_XFORM_MODE, S, T);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(S, T, N) {
            this.cfg = this.cfg.extend(N), this._xformMode = S, this._key = T, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            v.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(S) {
            return this._append(S), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(S) {
            S && this._append(S);
            var T = this._doFinalize();
            return T;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: /* @__PURE__ */ (function() {
            function S(T) {
              return typeof T == "string" ? k : b;
            }
            return function(T) {
              return {
                encrypt: function(N, L, K) {
                  return S(L).encrypt(T, N, L, K);
                },
                decrypt: function(N, L, K) {
                  return S(L).decrypt(T, N, L, K);
                }
              };
            };
          })()
        });
        u.StreamCipher = y.extend({
          _doFinalize: function() {
            var S = this._process(!0);
            return S;
          },
          blockSize: 1
        });
        var C = x.mode = {}, B = u.BlockCipherMode = g.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(S, T) {
            return this.Encryptor.create(S, T);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(S, T) {
            return this.Decryptor.create(S, T);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(S, T) {
            this._cipher = S, this._iv = T;
          }
        }), _ = C.CBC = (function() {
          var S = B.extend();
          S.Encryptor = S.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(N, L) {
              var K = this._cipher, P = K.blockSize;
              T.call(this, N, L, P), K.encryptBlock(N, L), this._prevBlock = N.slice(L, L + P);
            }
          }), S.Decryptor = S.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(N, L) {
              var K = this._cipher, P = K.blockSize, G = N.slice(L, L + P);
              K.decryptBlock(N, L), T.call(this, N, L, P), this._prevBlock = G;
            }
          });
          function T(N, L, K) {
            var P, G = this._iv;
            G ? (P = G, this._iv = a) : P = this._prevBlock;
            for (var V = 0; V < K; V++)
              N[L + V] ^= P[V];
          }
          return S;
        })(), I = x.pad = {}, A = I.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(S, T) {
            for (var N = T * 4, L = N - S.sigBytes % N, K = L << 24 | L << 16 | L << 8 | L, P = [], G = 0; G < L; G += 4)
              P.push(K);
            var V = f.create(P, L);
            S.concat(V);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(S) {
            var T = S.words[S.sigBytes - 1 >>> 2] & 255;
            S.sigBytes -= T;
          }
        };
        u.BlockCipher = y.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: y.cfg.extend({
            mode: _,
            padding: A
          }),
          reset: function() {
            var S;
            y.reset.call(this);
            var T = this.cfg, N = T.iv, L = T.mode;
            this._xformMode == this._ENC_XFORM_MODE ? S = L.createEncryptor : (S = L.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == S ? this._mode.init(this, N && N.words) : (this._mode = S.call(L, this, N && N.words), this._mode.__creator = S);
          },
          _doProcessBlock: function(S, T) {
            this._mode.processBlock(S, T);
          },
          _doFinalize: function() {
            var S, T = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (T.pad(this._data, this.blockSize), S = this._process(!0)) : (S = this._process(!0), T.unpad(S)), S;
          },
          blockSize: 128 / 32
        });
        var D = u.CipherParams = g.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(S) {
            this.mixIn(S);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(S) {
            return (S || this.formatter).stringify(this);
          }
        }), E = x.format = {}, w = E.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(S) {
            var T, N = S.ciphertext, L = S.salt;
            return L ? T = f.create([1398893684, 1701076831]).concat(L).concat(N) : T = N, T.toString(i);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(S) {
            var T, N = i.parse(S), L = N.words;
            return L[0] == 1398893684 && L[1] == 1701076831 && (T = f.create(L.slice(2, 4)), L.splice(0, 4), N.sigBytes -= 16), D.create({ ciphertext: N, salt: T });
          }
        }, b = u.SerializableCipher = g.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: g.extend({
            format: w
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(S, T, N, L) {
            L = this.cfg.extend(L);
            var K = S.createEncryptor(N, L), P = K.finalize(T), G = K.cfg;
            return D.create({
              ciphertext: P,
              key: N,
              iv: G.iv,
              algorithm: S,
              mode: G.mode,
              padding: G.padding,
              blockSize: S.blockSize,
              formatter: L.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(S, T, N, L) {
            L = this.cfg.extend(L), T = this._parse(T, L.format);
            var K = S.createDecryptor(N, L).finalize(T.ciphertext);
            return K;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(S, T) {
            return typeof S == "string" ? T.parse(S, this) : S;
          }
        }), O = x.kdf = {}, M = O.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(S, T, N, L, K) {
            if (L || (L = f.random(64 / 8)), K)
              var P = l.create({ keySize: T + N, hasher: K }).compute(S, L);
            else
              var P = l.create({ keySize: T + N }).compute(S, L);
            var G = f.create(P.words.slice(T), N * 4);
            return P.sigBytes = T * 4, D.create({ key: P, iv: G, salt: L });
          }
        }, k = u.PasswordBasedCipher = b.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: b.cfg.extend({
            kdf: M
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(S, T, N, L) {
            L = this.cfg.extend(L);
            var K = L.kdf.execute(N, S.keySize, S.ivSize, L.salt, L.hasher);
            L.iv = K.iv;
            var P = b.encrypt.call(this, S, T, K.key, L);
            return P.mixIn(K), P;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(S, T, N, L) {
            L = this.cfg.extend(L), T = this._parse(T, L.format);
            var K = L.kdf.execute(N, S.keySize, S.ivSize, T.salt, L.hasher);
            L.iv = K.iv;
            var P = b.decrypt.call(this, S, T, K.key, L);
            return P;
          }
        });
      })();
    });
  })(At)), At.exports;
}
var Bt = { exports: {} }, pi = Bt.exports, F0;
function di() {
  return F0 || (F0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(pi, function(s) {
      return s.mode.CFB = (function() {
        var a = s.lib.BlockCipherMode.extend();
        a.Encryptor = a.extend({
          processBlock: function(u, g) {
            var f = this._cipher, v = f.blockSize;
            x.call(this, u, g, v, f), this._prevBlock = u.slice(g, g + v);
          }
        }), a.Decryptor = a.extend({
          processBlock: function(u, g) {
            var f = this._cipher, v = f.blockSize, r = u.slice(g, g + v);
            x.call(this, u, g, v, f), this._prevBlock = r;
          }
        });
        function x(u, g, f, v) {
          var r, i = this._iv;
          i ? (r = i.slice(0), this._iv = void 0) : r = this._prevBlock, v.encryptBlock(r, 0);
          for (var c = 0; c < f; c++)
            u[g + c] ^= r[c];
        }
        return a;
      })(), s.mode.CFB;
    });
  })(Bt)), Bt.exports;
}
var _t = { exports: {} }, vi = _t.exports, b0;
function yi() {
  return b0 || (b0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(vi, function(s) {
      return s.mode.CTR = (function() {
        var a = s.lib.BlockCipherMode.extend(), x = a.Encryptor = a.extend({
          processBlock: function(u, g) {
            var f = this._cipher, v = f.blockSize, r = this._iv, i = this._counter;
            r && (i = this._counter = r.slice(0), this._iv = void 0);
            var c = i.slice(0);
            f.encryptBlock(c, 0), i[v - 1] = i[v - 1] + 1 | 0;
            for (var l = 0; l < v; l++)
              u[g + l] ^= c[l];
          }
        });
        return a.Decryptor = x, a;
      })(), s.mode.CTR;
    });
  })(_t)), _t.exports;
}
var Dt = { exports: {} }, gi = Dt.exports, S0;
function mi() {
  return S0 || (S0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(gi, function(s) {
      return s.mode.CTRGladman = (function() {
        var a = s.lib.BlockCipherMode.extend();
        function x(f) {
          if ((f >> 24 & 255) === 255) {
            var v = f >> 16 & 255, r = f >> 8 & 255, i = f & 255;
            v === 255 ? (v = 0, r === 255 ? (r = 0, i === 255 ? i = 0 : ++i) : ++r) : ++v, f = 0, f += v << 16, f += r << 8, f += i;
          } else
            f += 1 << 24;
          return f;
        }
        function u(f) {
          return (f[0] = x(f[0])) === 0 && (f[1] = x(f[1])), f;
        }
        var g = a.Encryptor = a.extend({
          processBlock: function(f, v) {
            var r = this._cipher, i = r.blockSize, c = this._iv, l = this._counter;
            c && (l = this._counter = c.slice(0), this._iv = void 0), u(l);
            var y = l.slice(0);
            r.encryptBlock(y, 0);
            for (var C = 0; C < i; C++)
              f[v + C] ^= y[C];
          }
        });
        return a.Decryptor = g, a;
      })(), s.mode.CTRGladman;
    });
  })(Dt)), Dt.exports;
}
var wt = { exports: {} }, Ci = wt.exports, R0;
function Ei() {
  return R0 || (R0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(Ci, function(s) {
      return s.mode.OFB = (function() {
        var a = s.lib.BlockCipherMode.extend(), x = a.Encryptor = a.extend({
          processBlock: function(u, g) {
            var f = this._cipher, v = f.blockSize, r = this._iv, i = this._keystream;
            r && (i = this._keystream = r.slice(0), this._iv = void 0), f.encryptBlock(i, 0);
            for (var c = 0; c < v; c++)
              u[g + c] ^= i[c];
          }
        });
        return a.Decryptor = x, a;
      })(), s.mode.OFB;
    });
  })(wt)), wt.exports;
}
var Ft = { exports: {} }, Ai = Ft.exports, I0;
function Bi() {
  return I0 || (I0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(Ai, function(s) {
      return s.mode.ECB = (function() {
        var a = s.lib.BlockCipherMode.extend();
        return a.Encryptor = a.extend({
          processBlock: function(x, u) {
            this._cipher.encryptBlock(x, u);
          }
        }), a.Decryptor = a.extend({
          processBlock: function(x, u) {
            this._cipher.decryptBlock(x, u);
          }
        }), a;
      })(), s.mode.ECB;
    });
  })(Ft)), Ft.exports;
}
var bt = { exports: {} }, _i = bt.exports, T0;
function Di() {
  return T0 || (T0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(_i, function(s) {
      return s.pad.AnsiX923 = {
        pad: function(a, x) {
          var u = a.sigBytes, g = x * 4, f = g - u % g, v = u + f - 1;
          a.clamp(), a.words[v >>> 2] |= f << 24 - v % 4 * 8, a.sigBytes += f;
        },
        unpad: function(a) {
          var x = a.words[a.sigBytes - 1 >>> 2] & 255;
          a.sigBytes -= x;
        }
      }, s.pad.Ansix923;
    });
  })(bt)), bt.exports;
}
var St = { exports: {} }, wi = St.exports, O0;
function Fi() {
  return O0 || (O0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(wi, function(s) {
      return s.pad.Iso10126 = {
        pad: function(a, x) {
          var u = x * 4, g = u - a.sigBytes % u;
          a.concat(s.lib.WordArray.random(g - 1)).concat(s.lib.WordArray.create([g << 24], 1));
        },
        unpad: function(a) {
          var x = a.words[a.sigBytes - 1 >>> 2] & 255;
          a.sigBytes -= x;
        }
      }, s.pad.Iso10126;
    });
  })(St)), St.exports;
}
var Rt = { exports: {} }, bi = Rt.exports, M0;
function Si() {
  return M0 || (M0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(bi, function(s) {
      return s.pad.Iso97971 = {
        pad: function(a, x) {
          a.concat(s.lib.WordArray.create([2147483648], 1)), s.pad.ZeroPadding.pad(a, x);
        },
        unpad: function(a) {
          s.pad.ZeroPadding.unpad(a), a.sigBytes--;
        }
      }, s.pad.Iso97971;
    });
  })(Rt)), Rt.exports;
}
var It = { exports: {} }, Ri = It.exports, N0;
function Ii() {
  return N0 || (N0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(Ri, function(s) {
      return s.pad.ZeroPadding = {
        pad: function(a, x) {
          var u = x * 4;
          a.clamp(), a.sigBytes += u - (a.sigBytes % u || u);
        },
        unpad: function(a) {
          for (var x = a.words, u = a.sigBytes - 1, u = a.sigBytes - 1; u >= 0; u--)
            if (x[u >>> 2] >>> 24 - u % 4 * 8 & 255) {
              a.sigBytes = u + 1;
              break;
            }
        }
      }, s.pad.ZeroPadding;
    });
  })(It)), It.exports;
}
var Tt = { exports: {} }, Ti = Tt.exports, U0;
function Oi() {
  return U0 || (U0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(Ti, function(s) {
      return s.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, s.pad.NoPadding;
    });
  })(Tt)), Tt.exports;
}
var Ot = { exports: {} }, Mi = Ot.exports, k0;
function Ni() {
  return k0 || (k0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), ve());
    })(Mi, function(s) {
      return (function(a) {
        var x = s, u = x.lib, g = u.CipherParams, f = x.enc, v = f.Hex, r = x.format;
        r.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(i) {
            return i.ciphertext.toString(v);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(i) {
            var c = v.parse(i);
            return g.create({ ciphertext: c });
          }
        };
      })(), s.format.Hex;
    });
  })(Ot)), Ot.exports;
}
var Mt = { exports: {} }, Ui = Mt.exports, P0;
function ki() {
  return P0 || (P0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Le(), Ge(), Me(), ve());
    })(Ui, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.BlockCipher, g = a.algo, f = [], v = [], r = [], i = [], c = [], l = [], y = [], C = [], B = [], _ = [];
        (function() {
          for (var D = [], E = 0; E < 256; E++)
            E < 128 ? D[E] = E << 1 : D[E] = E << 1 ^ 283;
          for (var w = 0, b = 0, E = 0; E < 256; E++) {
            var O = b ^ b << 1 ^ b << 2 ^ b << 3 ^ b << 4;
            O = O >>> 8 ^ O & 255 ^ 99, f[w] = O, v[O] = w;
            var M = D[w], k = D[M], S = D[k], T = D[O] * 257 ^ O * 16843008;
            r[w] = T << 24 | T >>> 8, i[w] = T << 16 | T >>> 16, c[w] = T << 8 | T >>> 24, l[w] = T;
            var T = S * 16843009 ^ k * 65537 ^ M * 257 ^ w * 16843008;
            y[O] = T << 24 | T >>> 8, C[O] = T << 16 | T >>> 16, B[O] = T << 8 | T >>> 24, _[O] = T, w ? (w = M ^ D[D[D[S ^ M]]], b ^= D[D[b]]) : w = b = 1;
          }
        })();
        var I = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], A = g.AES = u.extend({
          _doReset: function() {
            var D;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var E = this._keyPriorReset = this._key, w = E.words, b = E.sigBytes / 4, O = this._nRounds = b + 6, M = (O + 1) * 4, k = this._keySchedule = [], S = 0; S < M; S++)
                S < b ? k[S] = w[S] : (D = k[S - 1], S % b ? b > 6 && S % b == 4 && (D = f[D >>> 24] << 24 | f[D >>> 16 & 255] << 16 | f[D >>> 8 & 255] << 8 | f[D & 255]) : (D = D << 8 | D >>> 24, D = f[D >>> 24] << 24 | f[D >>> 16 & 255] << 16 | f[D >>> 8 & 255] << 8 | f[D & 255], D ^= I[S / b | 0] << 24), k[S] = k[S - b] ^ D);
              for (var T = this._invKeySchedule = [], N = 0; N < M; N++) {
                var S = M - N;
                if (N % 4)
                  var D = k[S];
                else
                  var D = k[S - 4];
                N < 4 || S <= 4 ? T[N] = D : T[N] = y[f[D >>> 24]] ^ C[f[D >>> 16 & 255]] ^ B[f[D >>> 8 & 255]] ^ _[f[D & 255]];
              }
            }
          },
          encryptBlock: function(D, E) {
            this._doCryptBlock(D, E, this._keySchedule, r, i, c, l, f);
          },
          decryptBlock: function(D, E) {
            var w = D[E + 1];
            D[E + 1] = D[E + 3], D[E + 3] = w, this._doCryptBlock(D, E, this._invKeySchedule, y, C, B, _, v);
            var w = D[E + 1];
            D[E + 1] = D[E + 3], D[E + 3] = w;
          },
          _doCryptBlock: function(D, E, w, b, O, M, k, S) {
            for (var T = this._nRounds, N = D[E] ^ w[0], L = D[E + 1] ^ w[1], K = D[E + 2] ^ w[2], P = D[E + 3] ^ w[3], G = 4, V = 1; V < T; V++) {
              var X = b[N >>> 24] ^ O[L >>> 16 & 255] ^ M[K >>> 8 & 255] ^ k[P & 255] ^ w[G++], Z = b[L >>> 24] ^ O[K >>> 16 & 255] ^ M[P >>> 8 & 255] ^ k[N & 255] ^ w[G++], j = b[K >>> 24] ^ O[P >>> 16 & 255] ^ M[N >>> 8 & 255] ^ k[L & 255] ^ w[G++], U = b[P >>> 24] ^ O[N >>> 16 & 255] ^ M[L >>> 8 & 255] ^ k[K & 255] ^ w[G++];
              N = X, L = Z, K = j, P = U;
            }
            var X = (S[N >>> 24] << 24 | S[L >>> 16 & 255] << 16 | S[K >>> 8 & 255] << 8 | S[P & 255]) ^ w[G++], Z = (S[L >>> 24] << 24 | S[K >>> 16 & 255] << 16 | S[P >>> 8 & 255] << 8 | S[N & 255]) ^ w[G++], j = (S[K >>> 24] << 24 | S[P >>> 16 & 255] << 16 | S[N >>> 8 & 255] << 8 | S[L & 255]) ^ w[G++], U = (S[P >>> 24] << 24 | S[N >>> 16 & 255] << 16 | S[L >>> 8 & 255] << 8 | S[K & 255]) ^ w[G++];
            D[E] = X, D[E + 1] = Z, D[E + 2] = j, D[E + 3] = U;
          },
          keySize: 256 / 32
        });
        a.AES = u._createHelper(A);
      })(), s.AES;
    });
  })(Mt)), Mt.exports;
}
var Nt = { exports: {} }, Pi = Nt.exports, L0;
function Li() {
  return L0 || (L0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Le(), Ge(), Me(), ve());
    })(Pi, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.WordArray, g = x.BlockCipher, f = a.algo, v = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], r = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], i = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], c = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], l = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], y = f.DES = g.extend({
          _doReset: function() {
            for (var I = this._key, A = I.words, D = [], E = 0; E < 56; E++) {
              var w = v[E] - 1;
              D[E] = A[w >>> 5] >>> 31 - w % 32 & 1;
            }
            for (var b = this._subKeys = [], O = 0; O < 16; O++) {
              for (var M = b[O] = [], k = i[O], E = 0; E < 24; E++)
                M[E / 6 | 0] |= D[(r[E] - 1 + k) % 28] << 31 - E % 6, M[4 + (E / 6 | 0)] |= D[28 + (r[E + 24] - 1 + k) % 28] << 31 - E % 6;
              M[0] = M[0] << 1 | M[0] >>> 31;
              for (var E = 1; E < 7; E++)
                M[E] = M[E] >>> (E - 1) * 4 + 3;
              M[7] = M[7] << 5 | M[7] >>> 27;
            }
            for (var S = this._invSubKeys = [], E = 0; E < 16; E++)
              S[E] = b[15 - E];
          },
          encryptBlock: function(I, A) {
            this._doCryptBlock(I, A, this._subKeys);
          },
          decryptBlock: function(I, A) {
            this._doCryptBlock(I, A, this._invSubKeys);
          },
          _doCryptBlock: function(I, A, D) {
            this._lBlock = I[A], this._rBlock = I[A + 1], C.call(this, 4, 252645135), C.call(this, 16, 65535), B.call(this, 2, 858993459), B.call(this, 8, 16711935), C.call(this, 1, 1431655765);
            for (var E = 0; E < 16; E++) {
              for (var w = D[E], b = this._lBlock, O = this._rBlock, M = 0, k = 0; k < 8; k++)
                M |= c[k][((O ^ w[k]) & l[k]) >>> 0];
              this._lBlock = O, this._rBlock = b ^ M;
            }
            var S = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = S, C.call(this, 1, 1431655765), B.call(this, 8, 16711935), B.call(this, 2, 858993459), C.call(this, 16, 65535), C.call(this, 4, 252645135), I[A] = this._lBlock, I[A + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function C(I, A) {
          var D = (this._lBlock >>> I ^ this._rBlock) & A;
          this._rBlock ^= D, this._lBlock ^= D << I;
        }
        function B(I, A) {
          var D = (this._rBlock >>> I ^ this._lBlock) & A;
          this._lBlock ^= D, this._rBlock ^= D << I;
        }
        a.DES = g._createHelper(y);
        var _ = f.TripleDES = g.extend({
          _doReset: function() {
            var I = this._key, A = I.words;
            if (A.length !== 2 && A.length !== 4 && A.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var D = A.slice(0, 2), E = A.length < 4 ? A.slice(0, 2) : A.slice(2, 4), w = A.length < 6 ? A.slice(0, 2) : A.slice(4, 6);
            this._des1 = y.createEncryptor(u.create(D)), this._des2 = y.createEncryptor(u.create(E)), this._des3 = y.createEncryptor(u.create(w));
          },
          encryptBlock: function(I, A) {
            this._des1.encryptBlock(I, A), this._des2.decryptBlock(I, A), this._des3.encryptBlock(I, A);
          },
          decryptBlock: function(I, A) {
            this._des3.decryptBlock(I, A), this._des2.encryptBlock(I, A), this._des1.decryptBlock(I, A);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        a.TripleDES = g._createHelper(_);
      })(), s.TripleDES;
    });
  })(Nt)), Nt.exports;
}
var Ut = { exports: {} }, Gi = Ut.exports, G0;
function qi() {
  return G0 || (G0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Le(), Ge(), Me(), ve());
    })(Gi, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.StreamCipher, g = a.algo, f = g.RC4 = u.extend({
          _doReset: function() {
            for (var i = this._key, c = i.words, l = i.sigBytes, y = this._S = [], C = 0; C < 256; C++)
              y[C] = C;
            for (var C = 0, B = 0; C < 256; C++) {
              var _ = C % l, I = c[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              B = (B + y[C] + I) % 256;
              var A = y[C];
              y[C] = y[B], y[B] = A;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(i, c) {
            i[c] ^= v.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function v() {
          for (var i = this._S, c = this._i, l = this._j, y = 0, C = 0; C < 4; C++) {
            c = (c + 1) % 256, l = (l + i[c]) % 256;
            var B = i[c];
            i[c] = i[l], i[l] = B, y |= i[(i[c] + i[l]) % 256] << 24 - C * 8;
          }
          return this._i = c, this._j = l, y;
        }
        a.RC4 = u._createHelper(f);
        var r = g.RC4Drop = f.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: f.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            f._doReset.call(this);
            for (var i = this.cfg.drop; i > 0; i--)
              v.call(this);
          }
        });
        a.RC4Drop = u._createHelper(r);
      })(), s.RC4;
    });
  })(Ut)), Ut.exports;
}
var kt = { exports: {} }, Hi = kt.exports, q0;
function Ki() {
  return q0 || (q0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Le(), Ge(), Me(), ve());
    })(Hi, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.StreamCipher, g = a.algo, f = [], v = [], r = [], i = g.Rabbit = u.extend({
          _doReset: function() {
            for (var l = this._key.words, y = this.cfg.iv, C = 0; C < 4; C++)
              l[C] = (l[C] << 8 | l[C] >>> 24) & 16711935 | (l[C] << 24 | l[C] >>> 8) & 4278255360;
            var B = this._X = [
              l[0],
              l[3] << 16 | l[2] >>> 16,
              l[1],
              l[0] << 16 | l[3] >>> 16,
              l[2],
              l[1] << 16 | l[0] >>> 16,
              l[3],
              l[2] << 16 | l[1] >>> 16
            ], _ = this._C = [
              l[2] << 16 | l[2] >>> 16,
              l[0] & 4294901760 | l[1] & 65535,
              l[3] << 16 | l[3] >>> 16,
              l[1] & 4294901760 | l[2] & 65535,
              l[0] << 16 | l[0] >>> 16,
              l[2] & 4294901760 | l[3] & 65535,
              l[1] << 16 | l[1] >>> 16,
              l[3] & 4294901760 | l[0] & 65535
            ];
            this._b = 0;
            for (var C = 0; C < 4; C++)
              c.call(this);
            for (var C = 0; C < 8; C++)
              _[C] ^= B[C + 4 & 7];
            if (y) {
              var I = y.words, A = I[0], D = I[1], E = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, w = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, b = E >>> 16 | w & 4294901760, O = w << 16 | E & 65535;
              _[0] ^= E, _[1] ^= b, _[2] ^= w, _[3] ^= O, _[4] ^= E, _[5] ^= b, _[6] ^= w, _[7] ^= O;
              for (var C = 0; C < 4; C++)
                c.call(this);
            }
          },
          _doProcessBlock: function(l, y) {
            var C = this._X;
            c.call(this), f[0] = C[0] ^ C[5] >>> 16 ^ C[3] << 16, f[1] = C[2] ^ C[7] >>> 16 ^ C[5] << 16, f[2] = C[4] ^ C[1] >>> 16 ^ C[7] << 16, f[3] = C[6] ^ C[3] >>> 16 ^ C[1] << 16;
            for (var B = 0; B < 4; B++)
              f[B] = (f[B] << 8 | f[B] >>> 24) & 16711935 | (f[B] << 24 | f[B] >>> 8) & 4278255360, l[y + B] ^= f[B];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function c() {
          for (var l = this._X, y = this._C, C = 0; C < 8; C++)
            v[C] = y[C];
          y[0] = y[0] + 1295307597 + this._b | 0, y[1] = y[1] + 3545052371 + (y[0] >>> 0 < v[0] >>> 0 ? 1 : 0) | 0, y[2] = y[2] + 886263092 + (y[1] >>> 0 < v[1] >>> 0 ? 1 : 0) | 0, y[3] = y[3] + 1295307597 + (y[2] >>> 0 < v[2] >>> 0 ? 1 : 0) | 0, y[4] = y[4] + 3545052371 + (y[3] >>> 0 < v[3] >>> 0 ? 1 : 0) | 0, y[5] = y[5] + 886263092 + (y[4] >>> 0 < v[4] >>> 0 ? 1 : 0) | 0, y[6] = y[6] + 1295307597 + (y[5] >>> 0 < v[5] >>> 0 ? 1 : 0) | 0, y[7] = y[7] + 3545052371 + (y[6] >>> 0 < v[6] >>> 0 ? 1 : 0) | 0, this._b = y[7] >>> 0 < v[7] >>> 0 ? 1 : 0;
          for (var C = 0; C < 8; C++) {
            var B = l[C] + y[C], _ = B & 65535, I = B >>> 16, A = ((_ * _ >>> 17) + _ * I >>> 15) + I * I, D = ((B & 4294901760) * B | 0) + ((B & 65535) * B | 0);
            r[C] = A ^ D;
          }
          l[0] = r[0] + (r[7] << 16 | r[7] >>> 16) + (r[6] << 16 | r[6] >>> 16) | 0, l[1] = r[1] + (r[0] << 8 | r[0] >>> 24) + r[7] | 0, l[2] = r[2] + (r[1] << 16 | r[1] >>> 16) + (r[0] << 16 | r[0] >>> 16) | 0, l[3] = r[3] + (r[2] << 8 | r[2] >>> 24) + r[1] | 0, l[4] = r[4] + (r[3] << 16 | r[3] >>> 16) + (r[2] << 16 | r[2] >>> 16) | 0, l[5] = r[5] + (r[4] << 8 | r[4] >>> 24) + r[3] | 0, l[6] = r[6] + (r[5] << 16 | r[5] >>> 16) + (r[4] << 16 | r[4] >>> 16) | 0, l[7] = r[7] + (r[6] << 8 | r[6] >>> 24) + r[5] | 0;
        }
        a.Rabbit = u._createHelper(i);
      })(), s.Rabbit;
    });
  })(kt)), kt.exports;
}
var Pt = { exports: {} }, $i = Pt.exports, H0;
function Wi() {
  return H0 || (H0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Le(), Ge(), Me(), ve());
    })($i, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.StreamCipher, g = a.algo, f = [], v = [], r = [], i = g.RabbitLegacy = u.extend({
          _doReset: function() {
            var l = this._key.words, y = this.cfg.iv, C = this._X = [
              l[0],
              l[3] << 16 | l[2] >>> 16,
              l[1],
              l[0] << 16 | l[3] >>> 16,
              l[2],
              l[1] << 16 | l[0] >>> 16,
              l[3],
              l[2] << 16 | l[1] >>> 16
            ], B = this._C = [
              l[2] << 16 | l[2] >>> 16,
              l[0] & 4294901760 | l[1] & 65535,
              l[3] << 16 | l[3] >>> 16,
              l[1] & 4294901760 | l[2] & 65535,
              l[0] << 16 | l[0] >>> 16,
              l[2] & 4294901760 | l[3] & 65535,
              l[1] << 16 | l[1] >>> 16,
              l[3] & 4294901760 | l[0] & 65535
            ];
            this._b = 0;
            for (var _ = 0; _ < 4; _++)
              c.call(this);
            for (var _ = 0; _ < 8; _++)
              B[_] ^= C[_ + 4 & 7];
            if (y) {
              var I = y.words, A = I[0], D = I[1], E = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360, w = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, b = E >>> 16 | w & 4294901760, O = w << 16 | E & 65535;
              B[0] ^= E, B[1] ^= b, B[2] ^= w, B[3] ^= O, B[4] ^= E, B[5] ^= b, B[6] ^= w, B[7] ^= O;
              for (var _ = 0; _ < 4; _++)
                c.call(this);
            }
          },
          _doProcessBlock: function(l, y) {
            var C = this._X;
            c.call(this), f[0] = C[0] ^ C[5] >>> 16 ^ C[3] << 16, f[1] = C[2] ^ C[7] >>> 16 ^ C[5] << 16, f[2] = C[4] ^ C[1] >>> 16 ^ C[7] << 16, f[3] = C[6] ^ C[3] >>> 16 ^ C[1] << 16;
            for (var B = 0; B < 4; B++)
              f[B] = (f[B] << 8 | f[B] >>> 24) & 16711935 | (f[B] << 24 | f[B] >>> 8) & 4278255360, l[y + B] ^= f[B];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function c() {
          for (var l = this._X, y = this._C, C = 0; C < 8; C++)
            v[C] = y[C];
          y[0] = y[0] + 1295307597 + this._b | 0, y[1] = y[1] + 3545052371 + (y[0] >>> 0 < v[0] >>> 0 ? 1 : 0) | 0, y[2] = y[2] + 886263092 + (y[1] >>> 0 < v[1] >>> 0 ? 1 : 0) | 0, y[3] = y[3] + 1295307597 + (y[2] >>> 0 < v[2] >>> 0 ? 1 : 0) | 0, y[4] = y[4] + 3545052371 + (y[3] >>> 0 < v[3] >>> 0 ? 1 : 0) | 0, y[5] = y[5] + 886263092 + (y[4] >>> 0 < v[4] >>> 0 ? 1 : 0) | 0, y[6] = y[6] + 1295307597 + (y[5] >>> 0 < v[5] >>> 0 ? 1 : 0) | 0, y[7] = y[7] + 3545052371 + (y[6] >>> 0 < v[6] >>> 0 ? 1 : 0) | 0, this._b = y[7] >>> 0 < v[7] >>> 0 ? 1 : 0;
          for (var C = 0; C < 8; C++) {
            var B = l[C] + y[C], _ = B & 65535, I = B >>> 16, A = ((_ * _ >>> 17) + _ * I >>> 15) + I * I, D = ((B & 4294901760) * B | 0) + ((B & 65535) * B | 0);
            r[C] = A ^ D;
          }
          l[0] = r[0] + (r[7] << 16 | r[7] >>> 16) + (r[6] << 16 | r[6] >>> 16) | 0, l[1] = r[1] + (r[0] << 8 | r[0] >>> 24) + r[7] | 0, l[2] = r[2] + (r[1] << 16 | r[1] >>> 16) + (r[0] << 16 | r[0] >>> 16) | 0, l[3] = r[3] + (r[2] << 8 | r[2] >>> 24) + r[1] | 0, l[4] = r[4] + (r[3] << 16 | r[3] >>> 16) + (r[2] << 16 | r[2] >>> 16) | 0, l[5] = r[5] + (r[4] << 8 | r[4] >>> 24) + r[3] | 0, l[6] = r[6] + (r[5] << 16 | r[5] >>> 16) + (r[4] << 16 | r[4] >>> 16) | 0, l[7] = r[7] + (r[6] << 8 | r[6] >>> 24) + r[5] | 0;
        }
        a.RabbitLegacy = u._createHelper(i);
      })(), s.RabbitLegacy;
    });
  })(Pt)), Pt.exports;
}
var Lt = { exports: {} }, zi = Lt.exports, K0;
function Xi() {
  return K0 || (K0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Le(), Ge(), Me(), ve());
    })(zi, function(s) {
      return (function() {
        var a = s, x = a.lib, u = x.BlockCipher, g = a.algo;
        const f = 16, v = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], r = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var i = {
          pbox: [],
          sbox: []
        };
        function c(_, I) {
          let A = I >> 24 & 255, D = I >> 16 & 255, E = I >> 8 & 255, w = I & 255, b = _.sbox[0][A] + _.sbox[1][D];
          return b = b ^ _.sbox[2][E], b = b + _.sbox[3][w], b;
        }
        function l(_, I, A) {
          let D = I, E = A, w;
          for (let b = 0; b < f; ++b)
            D = D ^ _.pbox[b], E = c(_, D) ^ E, w = D, D = E, E = w;
          return w = D, D = E, E = w, E = E ^ _.pbox[f], D = D ^ _.pbox[f + 1], { left: D, right: E };
        }
        function y(_, I, A) {
          let D = I, E = A, w;
          for (let b = f + 1; b > 1; --b)
            D = D ^ _.pbox[b], E = c(_, D) ^ E, w = D, D = E, E = w;
          return w = D, D = E, E = w, E = E ^ _.pbox[1], D = D ^ _.pbox[0], { left: D, right: E };
        }
        function C(_, I, A) {
          for (let O = 0; O < 4; O++) {
            _.sbox[O] = [];
            for (let M = 0; M < 256; M++)
              _.sbox[O][M] = r[O][M];
          }
          let D = 0;
          for (let O = 0; O < f + 2; O++)
            _.pbox[O] = v[O] ^ I[D], D++, D >= A && (D = 0);
          let E = 0, w = 0, b = 0;
          for (let O = 0; O < f + 2; O += 2)
            b = l(_, E, w), E = b.left, w = b.right, _.pbox[O] = E, _.pbox[O + 1] = w;
          for (let O = 0; O < 4; O++)
            for (let M = 0; M < 256; M += 2)
              b = l(_, E, w), E = b.left, w = b.right, _.sbox[O][M] = E, _.sbox[O][M + 1] = w;
          return !0;
        }
        var B = g.Blowfish = u.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var _ = this._keyPriorReset = this._key, I = _.words, A = _.sigBytes / 4;
              C(i, I, A);
            }
          },
          encryptBlock: function(_, I) {
            var A = l(i, _[I], _[I + 1]);
            _[I] = A.left, _[I + 1] = A.right;
          },
          decryptBlock: function(_, I) {
            var A = y(i, _[I], _[I + 1]);
            _[I] = A.left, _[I + 1] = A.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        a.Blowfish = u._createHelper(B);
      })(), s.Blowfish;
    });
  })(Lt)), Lt.exports;
}
var Vi = it.exports, $0;
function ji() {
  return $0 || ($0 = 1, (function(h, n) {
    (function(s, a, x) {
      h.exports = a(se(), Kt(), Wn(), Xn(), Le(), Zn(), Ge(), Z0(), Cr(), ti(), J0(), ii(), si(), ci(), Er(), li(), Me(), ve(), di(), yi(), mi(), Ei(), Bi(), Di(), Fi(), Si(), Ii(), Oi(), Ni(), ki(), Li(), qi(), Ki(), Wi(), Xi());
    })(Vi, function(s) {
      return s;
    });
  })(it)), it.exports;
}
var Zi = ji();
const De = /* @__PURE__ */ Gt(Zi), Q0 = De.enc.Utf8.parse("0123450123450123"), Y0 = De.enc.Utf8.parse("ABABABABABABABAB"), Ji = (h) => {
  let n = De.enc.Base64.parse(h), s = De.enc.Base64.stringify(n);
  return De.AES.decrypt(s, Q0, {
    iv: Y0,
    mode: De.mode.CBC,
    padding: De.pad.Pkcs7
  }).toString(De.enc.Utf8).toString();
}, rt = (h) => {
  let n = De.enc.Utf8.parse(h), s = De.AES.encrypt(n, Q0, {
    iv: Y0,
    mode: De.mode.CBC,
    padding: De.pad.Pkcs7
  });
  return De.enc.Base64.stringify(s.ciphertext);
}, Qi = (h) => {
  let n = 0, s = new Uint8Array(h.length * 4);
  for (let a = 0; a != h.length; a++) {
    let x = h.charCodeAt(a);
    if (x < 128) {
      s[n++] = x;
      continue;
    }
    if (x < 2048)
      s[n++] = x >> 6 | 192;
    else {
      if (x > 55295 && x < 56320) {
        if (++a >= h.length)
          throw new Error("UTF-8 encode: incomplete surrogate pair");
        const u = h.charCodeAt(a);
        if (u < 56320 || u > 57343)
          throw new Error(
            "UTF-8 encode: second surrogate character 0x" + u.toString(16) + " at index " + a + " out of range"
          );
        x = 65536 + ((x & 1023) << 10) + (u & 1023), s[n++] = x >> 18 | 240, s[n++] = x >> 12 & 63 | 128;
      } else s[n++] = x >> 12 | 224;
      s[n++] = x >> 6 & 63 | 128;
    }
    s[n++] = x & 63 | 128;
  }
  return s.subarray(0, n);
}, Oe = (h) => {
  let n = 0, s = "";
  for (; n < h.length; ) {
    let a = h[n++];
    if (a > 127)
      if (a > 191 && a < 224) {
        if (n >= h.length)
          throw new Error("UTF-8 decode: incomplete 2-byte sequence");
        a = (a & 31) << 6 | h[n++] & 63;
      } else if (a > 223 && a < 240) {
        if (n + 1 >= h.length)
          throw new Error("UTF-8 decode: incomplete 3-byte sequence");
        a = (a & 15) << 12 | (h[n++] & 63) << 6 | h[n++] & 63;
      } else if (a > 239 && a < 248) {
        if (n + 2 >= h.length)
          throw new Error("UTF-8 decode: incomplete 4-byte sequence");
        a = (a & 7) << 18 | (h[n++] & 63) << 12 | (h[n++] & 63) << 6 | h[n++] & 63;
      } else
        throw new Error(
          "UTF-8 decode: unknown multibyte start 0x" + a.toString(16) + " at index " + (n - 1)
        );
    if (a <= 65535) s += String.fromCharCode(a);
    else if (a <= 1114111)
      a -= 65536, s += String.fromCharCode(a >> 10 | 55296), s += String.fromCharCode(a & 1023 | 56320);
    else
      throw new Error(
        "UTF-8 decode: code point 0x" + a.toString(16) + " exceeds UTF-16 reach"
      );
  }
  return s;
};
class z {
  static HEADSIZE = 12;
  static VERSION = 1;
  static STATE_UNCONNECTED = 0;
  static STATE_CONNECTING = 1;
  static STATE_CONNECTED = 2;
  static STATE_CONNECTFAIL = 3;
  static STATE_AUTHENTICATION_FAIL = 4;
  /**
   * ack 超时5s,主动断开socket
   */
  static ACK_TIMEOUT = 5;
  static MSG_AUTH_STATUS = 3;
  static MSG_IM = 4;
  static MSG_ACK = 5;
  static MSG_RST = 6;
  static MSG_GROUP_NOTIFICATION = 7;
  static MSG_GROUP_IM = 8;
  static MSG_PEER_ACK = 9;
  static MSG_PING = 13;
  static MSG_PONG = 14;
  static MSG_AUTH_TOKEN = 15;
  static MSG_RT = 17;
  static MSG_ENTER_ROOM = 18;
  static MSG_LEAVE_ROOM = 19;
  static MSG_ROOM_IM = 20;
  static MSG_SYSTEM = 21;
  static MSG_CUSTOMER_ = 24;
  static MSG_CUSTOMER_SUPPORT = 25;
  static MSG_SYNC = 26;
  static MSG_SYNC_BEGIN = 27;
  static MSG_SYNC_END = 28;
  static MSG_SYNC_NOTIFY = 29;
  static MSG_SYNC_GROUP = 30;
  static MSG_SYNC_GROUP_BEGIN = 31;
  static MSG_SYNC_GROUP_END = 32;
  static MSG_SYNC_GROUP_NOTIFY = 33;
  static MSG_SYNC_KEY = 34;
  static MSG_GROUP_SYNC_KEY = 35;
  static MSG_NOTIFICATION = 36;
  static MSG_METADATA = 37;
  static MSG_CUSTOMER = 64;
  //消息标志
  static MESSAGE_FLAG_TEXT = 1;
  static MESSAGE_FLAG_UNPERSISTENT = 2;
  static MESSAGE_FLAG_SELF = 8;
  static MESSAGE_FLAG_PUSH = 16;
  static MESSAGE_FLAG_SUPER_GROUP = 32;
  static PLATFORM_IOS_PHONE = 1;
  static PLATFORM_IOS_PAD = 2;
  static PLATFORM_ANDROID_PHONE = 3;
  static PLATFORM_ANDROID_PAD = 4;
  static PLATFORM_HM_PHONE = 5;
  static PLATFORM_HM_PAD = 6;
  static PLATFORM_HM_PC = 7;
  static PLATFORM_WEB_PHONE = 8;
  static PLATFORM_WEB_PAD = 9;
  static PLATFORM_WEB_PC = 10;
  static PLATFORM_PC_WIN = 11;
  static PLATFORM_PC_MAC = 12;
  static PLATFORM_PC_LINUX = 13;
  static PLATFORM_PC_XINCHUANG = 14;
  // Backward-compatible aliases.
  static PLATFORM_IOS = z.PLATFORM_IOS_PHONE;
  static PLATFORM_ANDROID = z.PLATFORM_ANDROID_PHONE;
  static PLATFORM_WEB = z.PLATFORM_WEB_PHONE;
  static PLATFORM_WIN = z.PLATFORM_PC_WIN;
  static PLATFORM_OSX = z.PLATFORM_PC_MAC;
  static PLATFORM_WEB_MOBILE = z.PLATFORM_WEB_PHONE;
  static PLATFORM_PC_HM = z.PLATFORM_HM_PC;
  static HEARTBEAT = 180;
  level = 0;
  host = null;
  port = 5132;
  protocol = "ws://";
  accessToken = "";
  syncKey = 0;
  groupSyncKeys = {};
  socket = null;
  connectFailCount = 0;
  connectState = z.STATE_UNCONNECTED;
  seq = 0;
  stopped = !0;
  suspended = !0;
  reachable = !0;
  isBackground = !1;
  messageMap = /* @__PURE__ */ new Map();
  messages = {};
  groupMessages = {};
  customerMessages = {};
  isSyncing = !1;
  syncTimestamp = 0;
  pendingSyncKey = 0;
  pingTimer = null;
  pingTimestamp = 0;
  platformID = z.detectPlatformID();
  deviceId = z.guid();
  metaMessage = void 0;
  userID = "";
  msgLocalID = 0;
  proxyServer = null;
  fileUploadProxy = null;
  fileDownloadProxy = null;
  events = /* @__PURE__ */ new Map();
  static detectPlatformID() {
    if (typeof navigator > "u")
      return z.PLATFORM_WEB_PC;
    const s = (navigator.userAgent || "").toLowerCase(), a = /ipad|tablet|pad/.test(s);
    return /harmonyos|hongmeng/.test(s) ? a ? z.PLATFORM_HM_PAD : z.PLATFORM_HM_PHONE : /iphone|ipod/.test(s) ? z.PLATFORM_IOS_PHONE : /ipad/.test(s) ? z.PLATFORM_IOS_PAD : /android/.test(s) ? a ? z.PLATFORM_ANDROID_PAD : z.PLATFORM_ANDROID_PHONE : /macintosh|mac os x/.test(s) || /linux|x11/.test(s) || /windows/.test(s) ? z.PLATFORM_WEB_PC : a ? z.PLATFORM_WEB_PAD : z.PLATFORM_WEB_PHONE;
  }
  constructor(n) {
    this.port = n?.port || 5132, this.protocol = n?.protocol || "ws://", this.host = n?.host || "192.168.31.71", this.proxyServer = n.proxyServer || this.proxyServer, this.fileUploadProxy = n.fileUploadProxy || this.fileUploadProxy, this.fileDownloadProxy = n.fileDownloadProxy || this.fileDownloadProxy, typeof n.platformID == "number" && (this.platformID = n.platformID), n.deviceId && (this.deviceId = n.deviceId);
  }
  /**
   * 登录
   */
  async login(n) {
    console.log("Im login");
    const { username: s, auth: a } = n, x = n.platform ?? this.platformID, u = n.terminal ?? "web", g = n.client_type ?? "web", f = n.device_id ?? this.deviceId;
    console.log({ username: s, auth: a, type: !1 });
    const r = "http://192.168.31.184:5104/v1", i = "webim", c = "webimpkg", l = encodeURIComponent(rt(s)), y = encodeURIComponent(rt(a)), C = encodeURIComponent(rt(i)), B = encodeURIComponent(rt(c)), _ = `${r}/member/login?phone=${l}&password=${y}&devicetoken=${C}&pkgname=${B}&platform=${encodeURIComponent(String(x))}&terminal=${encodeURIComponent(u)}&client_type=${encodeURIComponent(g)}&device_id=${encodeURIComponent(f)}`, A = await (await fetch(_, {})).json();
    let D = btoa(s);
    D = D.replace(/=*$/g, "");
    const E = Ji(A.data), { token: w, uid: b } = JSON.parse(E);
    return this.platformID = x, this.deviceId = f, this.userID = b, kn.set(`webim_${D}`, w), this.accessToken = w, this.#o(), "Login success";
  }
  loginByToken({
    id: n,
    token: s,
    platformID: a,
    deviceId: x
  }) {
    return this.userID = n.toString(), this.accessToken = s, typeof a == "number" && (this.platformID = a), x && (this.deviceId = x), this.#o(), "Login success";
  }
  #e() {
    console.log("Im logout"), this.userID = "";
  }
  destroy() {
    console.log("Im destroy"), this.#e(), this.#f();
  }
  /**
   * 已登录返回登录用户的 userID，未登录返回 `''`
   */
  getLoginUser() {
    return console.log("Im getLoginUser"), this.userID;
  }
  getServerTime() {
    console.log("Im getServerTime");
  }
  isReady() {
    console.log("Im isReady");
  }
  isLogin() {
    return console.log("Im isLogin"), !!this.userID;
  }
  setLogLevel(n) {
    this.level = n;
  }
  handleConnectivityChange(n) {
    console.log("Im handleConnectivityChange"), console.log("connectivity change:", n), this.reachable = !!n && (n.toLowerCase() === "wifi" || n.toLowerCase() === "cell"), console.log("reachable:", n, this.reachable), this.reachable ? !this.stopped && !this.isBackground && (console.log("reconnect im service"), this.#t(), this.#i()) : this.#t();
  }
  #t() {
    this.suspended || (console.log("suspend im service"), this.suspended = !0, console.log("close socket"), this.socket && this.socket.close(), this.pingTimer && clearInterval(this.pingTimer), this.pingTimer = null);
  }
  #i() {
    this.suspended && (console.log("resume im service"), this.suspended = !1, this.#r(), this.pingTimer = setInterval(this.ping, z.HEADSIZE * 1e3));
  }
  #o() {
    if (!this.stopped) return console.warn("im service already be started");
    console.log("start im service"), this.stopped = !1, this.#i();
  }
  #f() {
    if (this.stopped) return console.warn("im service already be stopped");
    console.log("stop im service"), this.stopped = !0, this.#t();
  }
  #r() {
    if (this.stopped || this.suspended)
      return console.warn("im service is stopped or suspended");
    if (this.socket != null) return console.warn("socket is not null");
    console.log("im service connecting..."), this.connectState = z.STATE_CONNECTING;
    const n = globalThis.WebSocket, s = this.proxyServer ?? `${this.protocol}${this.host}:${this.port}`;
    console.log(
      "connect protocol:",
      this.protocol,
      " host:",
      this.host,
      " port:",
      this.port
    ), console.log("connect url:", s), n ? this.socket = a0(s, {
      path: this.proxyServer ? "/imwebsocket/engine.io/" : "/engine.io/",
      transports: ["websocket"]
    }) : this.socket = a0(s, {
      transports: ["polling"]
    }), this.socket?.on("open", () => this.onOpen()), this.socket?.on("error", (a) => this.#l(a));
  }
  ping() {
    if (this.connectState != z.STATE_CONNECTED) return !1;
    console.log("ping..."), this.sendPing(), this.pingTimestamp == 0 && (this.pingTimestamp = Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3)), setTimeout(() => {
      const n = Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3);
      this.pingTimestamp > 0 && n - this.pingTimestamp >= 3 && (console.log("ping timeout"), this.connectState == z.STATE_UNCONNECTED && (this.socket?.close(), this.socket = null));
    }, 3100);
  }
  onOpen() {
    console.log("socket opened"), this.socket?.on("message", (n) => this.onMessage(n)), this.socket?.on("close", (n) => {
      console.log("socket disconnect:", n), this.#n();
    }), this.seq = 0, this.connectState = z.STATE_CONNECTED, this.metaMessage = void 0, this.sendAuth(), this.sendSync(this.syncKey), this.isSyncing = !0, this.syncTimestamp = (/* @__PURE__ */ new Date()).getTime() / 1e3, this.pendingSyncKey = 0;
    for (const n in this.groupSyncKeys) {
      const s = this.groupSyncKeys[n];
      this.sendGroupSync(Number(n), s);
    }
    this.events.get(Ce.SDK_READY) && this.events.get(Ce.SDK_READY)();
  }
  handleACK(n) {
    const s = n.ack;
    if (s in this.messages) {
      const g = this.messages[s];
      delete g.__sendTimestamp__, delete this.messages[s];
    }
    if (s in this.customerMessages) {
      const g = this.customerMessages[s];
      delete g.__sendTimestamp__, delete this.customerMessages[s];
    }
    let a = null;
    if (s in this.groupMessages) {
      const g = this.groupMessages[s];
      delete g.__sendTimestamp__, a = g, delete this.groupMessages[s];
    }
    let x = this.metaMessage, u = null;
    if (this.metaMessage = void 0, x && x.seq + 1 == n.seq) {
      if (u = x, u.prevSyncKey == 0 || u.syncKey == 0)
        return;
      const g = u.syncKey;
      if (n.flag && z.MESSAGE_FLAG_SUPER_GROUP) {
        if (!a) return;
        const f = a.receiver;
        let v = 0;
        f in this.groupSyncKeys && (v = this.groupSyncKeys[f]), u.prevSyncKey == v && g != v && (this.groupSyncKeys[f] = g, this.sendGroupSyncKey(f, g));
      } else
        this.syncKey == u.prevSyncKey && g != this.syncKey && (this.syncKey = g, this.sendSyncKey(this.syncKey));
    }
  }
  handleMessage(n) {
    const { cmd: s, seq: a } = n;
    console.log("handle message:", n);
    let x = null;
    if (n.flag & z.MESSAGE_FLAG_PUSH) {
      let u = this.metaMessage;
      if (this.metaMessage = void 0, u && u.seq + 1 == a)
        x = u;
      else
        return;
      if (x.prevSyncKey == 0 || x.syncKey == 0)
        return;
      if (n.flag & z.MESSAGE_FLAG_SUPER_GROUP) {
        let g;
        if (s == z.MSG_GROUP_IM)
          g = n.receiver;
        else
          return;
        let f = 0;
        if (g in this.groupSyncKeys && (f = this.groupSyncKeys[g]), x.prevSyncKey != f) {
          console.log(
            "sync key is not sequence:",
            x.prevSyncKey,
            "----",
            f
          );
          return;
        }
      } else if (x.prevSyncKey != this.syncKey) {
        console.log(
          "sync key is not sequence:",
          x.prevSyncKey,
          "----",
          this.syncKey
        );
        return;
      }
    }
    if (s == z.MSG_IM) {
      console.log(
        "im message sender:" + n.sender,
        " receiver:" + n.receiver,
        "content:" + n.content
      ), console.log(
        "[Im Message] Receive:" + JSON.stringify({ ...n, content: JSON.parse(n.content) }, null, 2)
      );
      let u = JSON.parse(n.content);
      if (this.isReadReceiptContent(u))
        this.emitReadReceiptEvent(n, u, te.CONV_C2C), this.sendACK(a);
      else {
        const g = Pe({
          to: n.receiver,
          from: n.sender,
          flow: "in",
          payload: u
        });
        g.status = "success";
        const f = this.resolveIncomingAudioPayload(u);
        f ? (g.type = te.MSG_AUDIO, g.payload.audio = f) : u?.text ? (g.type = te.MSG_TEXT, g.payload.text = u.text) : u?.image ? (g.type = te.MSG_IMAGE, g.payload.image = u.image, g.payload.image2.url = u.image2.url) : u?.file ? (g.type = te.MSG_FILE, g.payload.file.name = u.file.name, g.payload.file.url = u.file.url) : u?.video ? (g.type = te.MSG_VIDEO, g.payload.video.name = u.video.name, g.payload.video.url = u.video.url) : u?.roomid ? (g.type = te.MSG_VOIP, g.payload = u) : (g.type = te.MSG_CUSTOM, g.payload.text = JSON.stringify(u)), g.ID = JSON.parse(n.content).uuid, this.events.get(Ce.MESSAGE_RECEIVED) && this.events.get(Ce.MESSAGE_RECEIVED)({
          data: [g]
        }), this.sendACK(a);
      }
    } else if (s == z.MSG_GROUP_IM) {
      console.log(
        "im message sender:" + n.sender + " receiver:" + n.receiver + "content:" + n.content
      ), console.log(
        "[Im Message] Receive:" + JSON.stringify({ ...n, content: JSON.parse(n.content) }, null, 2)
      );
      const u = JSON.parse(n.content);
      if (this.isReadReceiptContent(u))
        this.emitReadReceiptEvent(n, u, te.CONV_GROUP), this.sendACK(a);
      else {
        const g = Pe({
          from: n.sender,
          to: n.receiver,
          flow: "in",
          payload: u,
          conversationType: te.CONV_GROUP
        });
        g.status = "success";
        const f = this.resolveIncomingAudioPayload(u);
        f ? (g.type = te.MSG_AUDIO, g.payload.audio = f) : u?.text ? (g.type = te.MSG_TEXT, g.payload.text = u.text) : u?.image ? (g.type = te.MSG_IMAGE, g.payload = u) : u?.file ? (g.type = te.MSG_FILE, g.payload.file.name = u.file.name, g.payload.file.url = u.file.url) : u?.video ? (g.type = te.MSG_VIDEO, g.payload.video.name = u.video.name, g.payload.video.url = u.video.url) : u?.roomid ? (g.type = te.MSG_VOIP, g.payload = u) : (g.type = te.MSG_CUSTOM, g.payload.text = JSON.stringify(u)), g.ID = JSON.parse(n.content).uuid, this.events.get(Ce.MESSAGE_RECEIVED) && this.events.get(Ce.MESSAGE_RECEIVED)({
          data: [g]
        }), this.sendACK(a);
      }
    } else if (s == z.MSG_AUTH_STATUS) {
      const u = n.status;
      console.log("auth status:" + u), u != 0 ? (alert("状态异常 请切换账号登录：" + u), this.connectState = z.STATE_AUTHENTICATION_FAIL) : this.connectFailCount = 0;
    } else if (s == z.MSG_ACK)
      console.log("receive ack:" + n.ack), this.handleACK(n);
    else if (s == z.MSG_SYNC_NOTIFY) {
      const u = Number(n.syncKey);
      console.log("sync notify:" + u);
      const g = (/* @__PURE__ */ new Date()).getTime() / 1e3;
      !(this.isSyncing && g - this.syncTimestamp < 4) && this.syncKey < u ? (this.sendSync(this.syncKey), this.isSyncing = !0, this.syncTimestamp = g, this.pendingSyncKey = 0) : u > this.pendingSyncKey && (this.pendingSyncKey = u);
    } else if (s == z.MSG_SYNC_BEGIN) {
      const u = n.syncKey;
      console.log("sync begin:" + u);
    } else if (s == z.MSG_SYNC_END) {
      const u = n.syncKey;
      console.log("sync end:" + u), u != this.syncKey && (this.syncKey = Number(u), this.sendSyncKey(this.syncKey));
      const g = (/* @__PURE__ */ new Date()).getTime() / 1e3;
      this.isSyncing = !1, this.pendingSyncKey > this.syncKey && (this.sendSync(this.syncKey), this.isSyncing = !0, this.syncTimestamp = g, this.pendingSyncKey = 0);
    } else if (s == z.MSG_SYNC_GROUP_NOTIFY) {
      const { groupID: u, syncKey: g } = n;
      console.log("sync group notify:" + u + " sync key:" + g);
      let f = 0;
      u in this.groupSyncKeys && (f = this.groupSyncKeys[u]), Number(g) > f && this.sendGroupSync(u, this.groupSyncKeys[u]);
    } else if (s == z.MSG_SYNC_GROUP_BEGIN) {
      const { groupID: u, syncKey: g } = n;
      console.log("sync group begin:" + u + " sync key:" + g);
    } else if (s == z.MSG_SYNC_GROUP_END) {
      const { groupID: u, syncKey: g } = n;
      console.log("sync group end:" + u + " sync key:" + g);
      let f = 0;
      u in this.groupSyncKeys && (f = this.groupSyncKeys[u]), g != f && (this.groupSyncKeys[u] = Number(g), this.sendGroupSyncKey(u, Number(g)));
    } else if (s == z.MSG_METADATA)
      this.metaMessage = n;
    else if (s == z.MSG_PONG)
      console.log("pong"), this.pingTimestamp = 0;
    else if (s == z.MSG_GROUP_NOTIFICATION) {
      const u = JSON.parse(n.content);
      console.log("group notification:", u), this.events.get(Ce.GROUP_LIST_UPDATED) && this.events.get(Ce.GROUP_LIST_UPDATED)({
        data: u
      });
    } else
      console.log("unknown message command:" + s);
    if (n.flag & z.MESSAGE_FLAG_PUSH) {
      const u = x.syncKey;
      if (n.flag & z.MESSAGE_FLAG_SUPER_GROUP) {
        let g;
        if (s == z.MSG_GROUP_IM)
          g = n.receiver;
        else
          return;
        this.groupSyncKeys[g] = u, this.sendGroupSyncKey(g, u);
      } else
        this.syncKey = u, this.sendSyncKey(this.syncKey);
    }
  }
  isAudioLike(n) {
    const s = String(n ?? "").toLowerCase();
    return s ? s.startsWith("audio/") ? !0 : /\.(mp3|wav|m4a|aac|amr|ogg|opus|webm)$/i.test(s) : !1;
  }
  isReadReceiptContent(n) {
    return !!n?.read_receipt?.msgid;
  }
  emitReadReceiptEvent(n, s, a) {
    const x = s?.read_receipt || {}, u = {
      data: [
        {
          ID: String(s?.uuid || ""),
          msgID: String(x.msgid || ""),
          from: n.sender,
          to: n.receiver,
          conversationType: a,
          timestamp: Number(x.timestamp || 0)
        }
      ]
    };
    a === te.CONV_GROUP ? this.events.get(Ce.MESSAGE_READ_RECEIPT_RECEIVED) && this.events.get(Ce.MESSAGE_READ_RECEIPT_RECEIVED)(u) : this.events.get(Ce.MESSAGE_READ_BY_PEER) && this.events.get(Ce.MESSAGE_READ_BY_PEER)(u);
  }
  resolveIncomingAudioPayload(n) {
    const s = n?.audio ?? n?.voice ?? n?.sound ?? n?.record ?? n?.recording, a = typeof s == "string" ? s : "", x = a || (s?.url ?? s?.src_url ?? s?.srcUrl ?? s?.src ?? s?.path ?? s?.file_url ?? s?.fileUrl ?? s?.download_url ?? s?.downloadUrl ?? s?.download?.url ?? s?.file?.url ?? s?.file?.src_url ?? s?.file?.srcUrl ?? s?.file?.path ?? s?.file?.download_url ?? s?.file?.downloadUrl ?? n?.audio_url ?? n?.audioUrl ?? n?.voice_url ?? n?.voiceUrl ?? n?.download_url ?? n?.downloadUrl);
    if (x)
      return {
        ...s,
        url: x,
        name: s?.name ?? s?.filename ?? "voice",
        duration: s?.duration ?? s?.second ?? s?.seconds ?? s?.timeLen
      };
    const u = n?.file, g = u?.url ?? u?.src_url ?? u?.srcUrl ?? u?.path ?? u?.fileUrl ?? u?.download_url ?? u?.downloadUrl, f = u?.name ?? u?.filename ?? "", v = u?.type ?? u?.mime ?? u?.filetype ?? "";
    return g && (this.isAudioLike(f) || this.isAudioLike(v) || this.isAudioLike(g)) ? {
      url: g,
      name: f || "voice",
      duration: u?.duration ?? u?.second ?? u?.seconds
    } : null;
  }
  onMessage(n) {
    let s = null;
    if (globalThis.ArrayBuffer && n instanceof ArrayBuffer)
      s = new Uint8Array(n);
    else if (n && n.base64)
      s = Te.Buffer.alloc(n.data, "base64");
    else {
      console.log("invalid data type:" + typeof n);
      return;
    }
    const a = ke(s, 0), x = ke(s, 4), u = s[8], g = s[10], f = !!(g & z.MESSAGE_FLAG_SELF);
    if (a + z.HEADSIZE < s.length) {
      console.warn(
        "invalid data length:" + s.length + " " + a + z.HEADSIZE
      );
      return;
    }
    let v = z.HEADSIZE;
    const r = { isSelf: f, seq: x, cmd: u, flag: g };
    u == z.MSG_IM || u == z.MSG_GROUP_IM ? (r.isSelf = f, r.sender = le(s, v), v += 8, r.receiver = le(s, v), v += 8, r.timestamp = ke(s, v), v += 4, r.content = Oe(
      s.subarray(z.HEADSIZE + 24, z.HEADSIZE + a)
    )) : u == z.MSG_GROUP_NOTIFICATION ? r.content = Oe(
      s.subarray(z.HEADSIZE, z.HEADSIZE + a)
    ) : u == z.MSG_CUSTOMER ? (r.isSelf = f, r.senderAppID = le(s, v), v += 8, r.sender = le(s, v), v += 8, r.receiverAppID = le(s, v), v += 8, r.receiver = le(s, v), v += 8, r.timestamp = ke(s, v), r.content = Oe(
      s.slice(z.HEADSIZE + 36, z.HEADSIZE + a)
    )) : u == z.MSG_RT || u == z.MSG_ROOM_IM ? (r.sender = le(s, v), v += 8, r.receiver = le(s, v), r.content = Oe(
      s.subarray(z.HEADSIZE + 16, z.HEADSIZE + a)
    )) : u == z.MSG_AUTH_STATUS ? r.status = ke(s, v) : u == z.MSG_ACK ? r.ack = ke(s, v) : u == z.MSG_SYNC_NOTIFY || u == z.MSG_SYNC_BEGIN || u == z.MSG_SYNC_END ? r.syncKey = le(s, v) : u == z.MSG_SYNC_GROUP_NOTIFY || u == z.MSG_SYNC_GROUP_BEGIN || u == z.MSG_SYNC_GROUP_END ? (r.groupID = le(s, v), v += 8, r.syncKey = le(s, v)) : u == z.MSG_SYSTEM || u == z.MSG_NOTIFICATION ? r.content = Oe(
      s.subarray(z.HEADSIZE, z.HEADSIZE + a)
    ) : u == z.MSG_METADATA ? (r.syncKey = le(s, v), v += 8, r.prevSyncKey = le(s, v)) : console.log("message command:" + u), this.handleMessage(r);
  }
  #l(n) {
    console.log("socket err:" + n), this.socket?.close(), this.socket = null, this.connectFailCount++, this.connectState = z.STATE_CONNECTFAIL;
    let s = this.connectFailCount * 1e3;
    this.connectFailCount > 60 && (s = 60 * 1e3), setTimeout(() => {
      this.#r();
    }, s);
  }
  #n() {
    console.log("on socket close"), this.socket?.close(), this.socket = null, this.connectState = z.STATE_UNCONNECTED, this.metaMessage && (console.warn("socket closed, meta message:", this.metaMessage), this.metaMessage = void 0);
    for (const s in this.messages) {
      let a = this.messages[s];
      delete a.__sendTimestamp__;
    }
    this.messages = {};
    for (let s in this.groupMessages) {
      let a = this.groupMessages[s];
      delete a.__sendTimestamp__;
    }
    this.groupMessages = {};
    for (let s in this.customerMessages) {
      let a = this.customerMessages[s];
      delete a.__sendTimestamp__;
    }
    this.customerMessages = {};
    let n = this.connectFailCount * 1e3;
    this.connectFailCount > 60 ? n = 60 * 1e3 : this.connectFailCount == 0 && (n = 400), setTimeout(() => {
      this.#r();
    }, n);
  }
  sendSync(n) {
    const s = new Uint8Array(8);
    be(s, 0, n), this.send(z.MSG_SYNC, s);
  }
  sendSyncKey(n) {
    const s = Te.Buffer.alloc(8);
    be(s, 0, n), this.send(z.MSG_SYNC_KEY, s);
  }
  sendGroupSync(n, s) {
    const a = new Uint8Array(16);
    be(a, 0, Number(n)), be(a, 4, s), this.send(z.MSG_SYNC_GROUP, a);
  }
  sendGroupSyncKey(n, s) {
    const a = new Uint8Array(16);
    be(a, 0, Number(n)), be(a, 8, s), this.send(z.MSG_GROUP_SYNC_KEY, a);
  }
  sendACK(n) {
    const s = new Uint8Array(4);
    Ue(s, 0, n), console.log("send ack:", n), this.send(z.MSG_ACK, s);
  }
  sendAuth() {
    console.log("send auth");
    let n = Te.Buffer.alloc(1024), s = 0, a;
    n[s] = this.platformID, s++, a = Te.Buffer.byteLength(this.accessToken), n[s] = a, s++, n.write(this.accessToken, s), s += a, a = Te.Buffer.byteLength(this.deviceId), n[s] = a, s++, n.write(this.deviceId, s), s += a;
    const x = n.subarray(0, s);
    this.send(z.MSG_AUTH_TOKEN, x);
  }
  sendPing() {
    const n = new Uint8Array(0);
    this.send(z.MSG_PING, n);
  }
  async send(n, s, a = !1) {
    if (!this.host)
      return console.error("socket is null"), !1;
    if (this.connectState != z.STATE_CONNECTED)
      return !1;
    this.seq++;
    let x = Te.Buffer.alloc(z.HEADSIZE + s.length), u = 0;
    return Ue(x, u, s.length), u += 4, Ue(x, u, this.seq), u += 4, x[u] = n, u++, x[u] = z.VERSION, u++, a ? x[u] = z.MESSAGE_FLAG_UNPERSISTENT : x[u] = 0, u++, x.fill(2, u, u + 1), u++, x.set(s, u), await this.socket?.send(x.buffer), !0;
  }
  addSuperGroupSyncKey(n, s) {
    this.groupSyncKeys[n] = s;
  }
  removeSuperGroupSyncKey(n) {
    delete this.groupSyncKeys[n];
  }
  clearSuperGroupSyncKey() {
    this.groupSyncKeys = {};
  }
  async #h(n) {
    if (this.connectState != z.STATE_CONNECTED) return !1;
    const s = Te.Buffer.byteLength(n.content);
    let a = Te.Buffer.alloc(24 + s), x = 0;
    const u = n.timestamp || 0, g = n.msgLocalID || 0;
    if (be(a, x, n.sender), x += 8, be(a, x, n.receiver), x += 8, Ue(a, x, u), x += 4, Ue(a, x, g), x += 4, a.write(n.content, x), !await this.send(z.MSG_IM, a)) return !1;
    n.__sendTimestamp = (/* @__PURE__ */ new Date()).getTime() / 1e3, this.messages[this.seq] = n;
    const v = z.ACK_TIMEOUT * 1e3 + 100;
    return setTimeout(() => {
      this.#s();
    }, v), !0;
  }
  async #x(n) {
    if (this.connectState != z.STATE_CONNECTED) return !1;
    const s = Qi(n.content), a = s.length, x = new Uint8Array(24 + a);
    let u = 0;
    const g = n.timestamp || 0, f = n.msgLocalID || 0;
    if (be(x, u, n.sender), u += 8, be(x, u, n.receiver), u += 8, Ue(x, u, g), u += 4, Ue(x, u, f), u += 4, x.set(s, u), !await this.send(z.MSG_GROUP_IM, x)) return !1;
    n.__sendTimestamp = (/* @__PURE__ */ new Date()).getTime() / 1e3, this.groupMessages[this.seq] = n;
    const r = z.ACK_TIMEOUT * 1e3 + 100;
    return setTimeout(() => {
      this.#s();
    }, r), !0;
  }
  #s() {
    const n = (/* @__PURE__ */ new Date()).getTime() / 1e3;
    let s = !1;
    for (let a in this.messages) {
      const x = this.messages[a];
      n - x.__sendTimestamp__ >= z.ACK_TIMEOUT && (s = !0);
    }
    for (let a in this.groupMessages) {
      const x = this.groupMessages[a];
      n - x.__sendTimestamp__ >= z.ACK_TIMEOUT && (s = !0);
    }
    for (let a in this.customerMessages) {
      const x = this.customerMessages[a];
      n - x.__sendTimestamp__ >= z.ACK_TIMEOUT && (s = !0);
    }
    s && (console.log("ack timeout, close socket"), this.#n());
  }
  static s4() {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  }
  static userId() {
    return this.s4() + this.s4();
  }
  static guid() {
    const n = () => Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
    return n() + n() + "-" + n() + "-" + n() + "-" + n() + "-" + n() + n() + n();
  }
  on(n, s) {
    this.events.set(n, s);
  }
  off(n, s) {
    this.events.get(n) === s && this.events.delete(n);
  }
  createTextMessage(n) {
    return Pe({
      from: this.userID,
      ...n
    });
  }
  createImageMessage(n) {
    if (!n?.payload?.file) throw new Error("Image is required");
    return Pe({
      from: this.userID,
      type: te.MSG_IMAGE,
      ...n
    });
  }
  createVideoMessage(n) {
    if (!n?.payload?.video) throw new Error("Video file is required");
    return Pe({
      from: this.userID,
      type: te.MSG_VIDEO,
      ...n
    });
  }
  createFileMessage(n) {
    if (!n?.payload?.file) throw new Error("File is required");
    return Pe({
      from: this.userID,
      type: te.MSG_FILE,
      ...n
    });
  }
  createVoipMessage(n) {
    return Pe({
      from: this.userID,
      type: te.MSG_VOIP,
      ...n
    });
  }
  async sendMessage(n) {
    const { ID: s, payload: a, type: x, conversationType: u } = n;
    let g = {
      sender: n.from,
      receiver: n.to,
      // receiver: 10001,
      msgLocalID: this.msgLocalID++
    };
    switch (x) {
      case te.MSG_TEXT:
        g.content = JSON.stringify({
          ...a,
          uuid: s
        }), this.messageMap?.set(s, n);
        break;
      case te.MSG_IMAGE:
        g.content = JSON.stringify({
          ...a,
          uuid: s
        });
        break;
      case te.MSG_VIDEO:
        g.content = JSON.stringify({
          ...a,
          uuid: s
        });
        break;
      case te.MSG_FILE:
        g.content = JSON.stringify({
          ...a,
          uuid: s
        });
        break;
      case te.MSG_VOIP:
        g.content = JSON.stringify(a);
        break;
      default:
        throw new Error("Invalid message type");
    }
    console.log(
      "[Im Message] Send:" + JSON.stringify({ ...g, content: JSON.parse(g.content) }, null, 2)
    );
    let f = !1;
    if (u === te.CONV_C2C)
      f = await this.#h(g);
    else if (u === te.CONV_GROUP)
      f = await this.#x(g);
    else
      throw new Error("Invalid conversation type");
    return n.status = f ? "success" : "fail", n;
  }
}
console.log("This is the entry point of the web-im-ui-sdk package.");
let We = "_MESSAGES", W0 = "_CONFIG";
class eo {
  id = "web_im_ui_sdk";
  title = "Web IM Chat";
  imId = 0;
  imToken = "";
  name = "";
  avatar = "";
  peerAvatar = "";
  theme;
  type;
  to = 0;
  showOpen = !1;
  proxyServer = "";
  fileUploadProxy = "";
  fileDownloadProxy = "";
  host = "";
  port = 0;
  protocol = "";
  platformID = void 0;
  deviceId = "";
  service;
  Section = null;
  Dialog = null;
  List = null;
  Input = null;
  messages = [];
  unReadCount = 0;
  scrollToBottomTimeout = null;
  sentReadReceiptUUIDs = /* @__PURE__ */ new Set();
  constructor({
    id: n = "web_im_ui_sdk",
    title: s = "Web IM Chat",
    imId: a,
    imToken: x,
    name: u,
    avatar: g,
    peerAvatar: f = "",
    theme: v,
    type: r = "single",
    to: i,
    proxyServer: c = "",
    showOpen: l = !1,
    fileUploadProxy: y = "",
    fileDownloadProxy: C = "",
    host: B = "",
    port: _ = 0,
    protocol: I = "",
    platformID: A,
    deviceId: D = ""
  }) {
    if (!document) throw new Error("Document is not available.");
    this.id = n, this.title = s, this.imId = a, this.imToken = x, this.name = u, this.avatar = g || "", this.peerAvatar = f || "", this.type = r, this.to = i, this.showOpen = l, this.proxyServer = c, this.fileUploadProxy = y, this.fileDownloadProxy = C, this.host = B, this.port = _, this.protocol = I, this.platformID = A, this.deviceId = D, We = `${this.id.toUpperCase()}_${this.to}_${this.imId}_${We}`, W0 = this.id.toUpperCase() + W0, v ? this.theme = v : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? this.theme = "dark" : this.theme = "light", this.service = new z({
      SDKAppID: 0,
      proxyServer: this.proxyServer,
      fileUploadProxy: this.fileUploadProxy,
      fileDownloadProxy: this.fileDownloadProxy,
      host: this.host,
      port: this.port,
      protocol: this.protocol,
      platformID: this.platformID,
      deviceId: this.deviceId || void 0
    }), this.service.loginByToken({
      id: this.imId,
      token: this.imToken,
      platformID: this.platformID,
      deviceId: this.deviceId || void 0
    }), this.service.on(Ce.MESSAGE_RECEIVED, (w) => {
      w.data[0].flow === "in" && !this.#t(w.data[0]) || (this.#u(w.data[0], "start"), this.#n(w.data[0])), this.#e(w.data[0]);
    }), this.service.on(Ce.MESSAGE_READ_BY_PEER, (w) => {
      const b = String(w?.data?.[0]?.msgID || "");
      b && this.#x(b);
    }), this.service.on(Ce.MESSAGE_READ_RECEIPT_RECEIVED, (w) => {
      const b = String(w?.data?.[0]?.msgID || ""), O = String(w?.data?.[0]?.from || "");
      !b || !O || this.#s(b, O);
    }), this.#F();
    const E = localStorage.getItem(We);
    E && (this.messages = JSON.parse(E)), this.messages.forEach((w) => {
      this.#u(w, w.flow === "in" ? "start" : "end");
    }), this.#h();
  }
  #e(n) {
    if (n.flow === "in" && !this.#t(n)) return;
    const s = this.messages.findIndex((a) => String(a.ID) === String(n.ID));
    s >= 0 ? this.messages[s] = n : this.messages.push(n), localStorage.setItem(We, JSON.stringify(this.messages)), !this.Dialog?.open && n.flow === "in" && this.unReadCount++;
  }
  #t(n) {
    return this.type === "single" ? String(n.from) === String(this.to) : String(n.to) === String(this.to);
  }
  #i(n) {
    const s = n.payload?.avatar || n.avatar || this.peerAvatar || "";
    return String(s || "").trim();
  }
  #o() {
    return Math.floor(Date.now() / 1e3);
  }
  #f(n) {
    const s = Fr(n * 1e3), a = Fr();
    return s.isSame(a, "day") ? s.format("HH:mm") : s.isSame(a.subtract(1, "day"), "day") ? `昨天 ${s.format("HH:mm")}` : s.format("MM-DD HH:mm");
  }
  #r(n) {
    return !(n.flow !== "in" || String(n.from) === String(this.imId) || n.type === te.MSG_VOIP || (n.payload || {})?.read_receipt?.msgid);
  }
  #l(n) {
    return {
      read_receipt: {
        msgid: n,
        timestamp: this.#o()
      },
      name: this.name
    };
  }
  async #n(n) {
    if (!this.#t(n) || !this.#r(n)) return;
    const s = String(n.ID || "");
    if (!s || !this.sentReadReceiptUUIDs.add(s)) return;
    const a = this.service.createTextMessage({
      to: String(this.to),
      conversationType: this.type === "single" ? te.CONV_C2C : te.CONV_GROUP,
      payload: this.#l(s)
    });
    try {
      await this.service.sendMessage(a);
    } catch {
      this.sentReadReceiptUUIDs.delete(s);
    }
  }
  async #h() {
    for (const n of this.messages)
      this.#r(n) && await this.#n(n);
  }
  #x(n) {
    const s = this.messages.find(
      (a) => String(a.ID) === String(n) && a.flow === "out"
    );
    s && (s.isPeerRead = !0, s.readReceiptInfo = {
      ...s.readReceiptInfo || {},
      readByPeer: !0,
      readCount: 1,
      readMembers: [String(this.to)]
    }, this.#e(s), this.#c(s));
  }
  #s(n, s) {
    const a = this.messages.find(
      (g) => String(g.ID) === String(n) && g.flow === "out"
    );
    if (!a) return;
    const x = a.readReceiptInfo || {}, u = Array.isArray(x.readMembers) ? [...x.readMembers.map((g) => String(g))] : [];
    u.includes(s) || u.push(s), a.readReceiptInfo = {
      ...x,
      readMembers: u,
      readCount: u.length
    }, a.isPeerRead = u.length > 0, this.#e(a), this.#c(a);
  }
  #a(n, s = "download") {
    try {
      const a = decodeURIComponent((n || "").split("?")[0]);
      return a.substring(a.lastIndexOf("/") + 1) || s;
    } catch {
      return s;
    }
  }
  #C(n) {
    const s = n.payload || {};
    if (n.type === te.MSG_FILE || s?.file || s?.fileUrl) {
      const a = s?.file || {}, x = a.url || s.fileUrl || "", u = s.fileName || s.filename || s.name || a.name || this.#a(x);
      return { url: String(x || ""), name: String(u || "download") };
    }
    if (n.type === te.MSG_VIDEO || s?.video || s?.remoteVideoUrl) {
      const x = (s?.video || {}).url || s.remoteVideoUrl || "", u = this.#a(x, `video-${Date.now()}.mp4`);
      return { url: String(x || ""), name: u };
    }
    if (n.type === te.MSG_IMAGE || s?.image || s?.imageInfoArray) {
      const a = s?.image || s?.imageInfoArray?.[0]?.url || s?.imageInfoArray?.[1]?.url || "", x = this.#a(a, `image-${Date.now()}.jpg`);
      return { url: String(a || ""), name: x };
    }
    if (n.type === te.MSG_AUDIO) {
      const a = this.#g(s), x = this.#d(a) || "audio", u = this.#a(a, `voice-${n.ID}.${x}`);
      return { url: a, name: u };
    }
    return { url: "", name: "download" };
  }
  async #E(n, s) {
    if (!n) return;
    const a = {
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      })
    };
    if (window?.fetch)
      try {
        const g = await (await fetch(n, a)).blob(), f = window.URL.createObjectURL(g), v = document.createElement("a");
        v.href = f, v.download = s, v.click(), window.URL.revokeObjectURL(f);
        return;
      } catch {
      }
    const x = document.createElement("a");
    x.href = n, x.target = "_blank", x.download = s, x.click();
  }
  #v(n, s) {
    const a = n.querySelector(".message-status");
    if (a && a.remove(), s.flow === "out") {
      if (s.status === "fail" || s.hasRiskContent) {
        const x = document.createElement("button");
        x.type = "button", x.className = "message-status message-status-fail", x.textContent = "!", x.title = "发送失败，点击重发", x.onclick = (u) => {
          u.stopPropagation(), this.#B(String(s.ID));
        }, n.appendChild(x);
        return;
      }
      if (s.status === "unSend" || s.status === "sending") {
        const x = document.createElement("div");
        x.className = "message-status message-status-sending", x.textContent = "发送中", n.appendChild(x);
      }
    }
  }
  #y(n, s) {
    if (s !== "end") return "";
    if (n.status === "fail") return "发送失败";
    if (n.status === "unSend" || n.status === "sending") return "发送中";
    if (this.type === "group") {
      const a = Number(n.readReceiptInfo?.readCount || 0);
      return a > 0 ? `${a}人已阅读` : "已送达";
    }
    return n.isPeerRead ? "已阅读" : "已送达";
  }
  #A(n, s, a) {
    const x = n.querySelector(".chat-footer");
    x && (x.textContent = this.#y(s, a));
  }
  #c(n) {
    const s = String(n.ID).replace(/"/g, '\\"'), a = this.List?.querySelector(
      `[data-message-id="${s}"]`
    );
    if (!a) return;
    const x = n.flow === "in" ? "start" : "end";
    this.#v(a, n), this.#A(a, n, x);
  }
  async #p(n) {
    n.status = "sending", n.flow === "out" && (n.isPeerRead = !1, n.readReceiptInfo = {
      ...n.readReceiptInfo || {},
      readByPeer: !1,
      readCount: 0,
      readMembers: []
    }), this.#e(n), this.#c(n);
    try {
      await this.service.sendMessage(n);
    } catch {
      n.status = "fail";
    }
    this.#e(n), this.#c(n);
  }
  async #B(n) {
    const s = this.messages.find((a) => String(a.ID) === String(n));
    s && await this.#p(s);
  }
  #g(n) {
    const s = n?.audio ?? n?.voice ?? n?.sound ?? n?.record ?? n?.recording, a = typeof s == "string" ? s : "", x = n?.file, u = a || (s?.url ?? s?.src_url ?? s?.srcUrl ?? s?.src ?? s?.path ?? s?.file_url ?? s?.fileUrl ?? s?.download_url ?? s?.downloadUrl ?? s?.download?.url ?? s?.file?.url ?? s?.file?.src_url ?? s?.file?.srcUrl ?? s?.file?.path ?? s?.file?.download_url ?? s?.file?.downloadUrl ?? n?.audio_url ?? n?.audioUrl ?? n?.voice_url ?? n?.voiceUrl ?? n?.download_url ?? n?.downloadUrl ?? x?.url ?? x?.src_url ?? x?.srcUrl ?? x?.path ?? x?.fileUrl ?? x?.download_url ?? x?.downloadUrl);
    return String(u ?? "").trim();
  }
  #_(n) {
    if (this.fileDownloadProxy) {
      const s = this.fileDownloadProxy.includes("?") ? "&" : "?";
      return `${this.fileDownloadProxy}${s}url=${encodeURIComponent(n)}`;
    }
    try {
      const s = new URL(n, globalThis.location?.origin);
      if ((globalThis.location?.hostname === "localhost" || globalThis.location?.hostname === "127.0.0.1") && s.pathname.startsWith("/media/"))
        return `${s.pathname}${s.search}${s.hash}`;
    } catch {
    }
    return n;
  }
  async #m(n, s, a = !0) {
    const x = this.#_(s), u = {
      Accept: "audio/*,*/*;q=0.8"
    };
    !this.fileDownloadProxy && a && this.service.accessToken && (u.Authorization = `Bearer ${this.service.accessToken}`, u["restrict-access"] = "true");
    const g = await fetch(x, {
      method: "GET",
      headers: u,
      credentials: "include"
    });
    if (!g.ok)
      throw new Error(
        `Fetch audio failed: ${g.status} ${g.statusText} (${x})`
      );
    const f = await g.blob();
    if (!f.size)
      throw new Error("Fetch audio failed: empty body");
    const v = URL.createObjectURL(f), r = n.dataset.objectUrl;
    return r && URL.revokeObjectURL(r), n.dataset.objectUrl = v, n.src = v, n.load(), { blobType: f.type, fetchedUrl: x };
  }
  #d(n) {
    const s = n.split("?")[0].toLowerCase();
    return s.endsWith(".amr") ? "amr" : s.endsWith(".silk") ? "silk" : s.endsWith(".aac") ? "aac" : s.endsWith(".m4a") ? "m4a" : s.endsWith(".mp3") ? "mp3" : s.endsWith(".wav") ? "wav" : s.endsWith(".ogg") ? "ogg" : s.endsWith(".opus") ? "opus" : "";
  }
  #D(n, s, a, x) {
    const u = this.#d(s);
    if (u === "amr" || u === "silk")
      return a.textContent = "该语音暂不支持在线播放，可下载收听", a.className = "text-xs opacity-70 mt-1", x && x.classList.remove("hidden"), !0;
    const g = u ? `audio/${u}` : "";
    return g && !n.canPlayType(g) ? (a.textContent = "该语音暂不支持在线播放，可下载收听", a.className = "text-xs opacity-70 mt-1", x && x.classList.remove("hidden"), !0) : !1;
  }
  #w(n, s, a, x) {
    let u = !1;
    const g = async () => {
      if (!u) {
        u = !0;
        try {
          const { blobType: f } = await this.#m(n, s, !0);
          f && !n.canPlayType(f) && (a.textContent = "该语音暂不支持在线播放，可下载收听", a.className = "text-xs opacity-70 mt-1", x && x.classList.remove("hidden"));
        } catch {
          try {
            const { blobType: v } = await this.#m(n, s, !1);
            v && !n.canPlayType(v) ? (a.textContent = "该语音暂不支持在线播放，可下载收听", x && x.classList.remove("hidden")) : a.textContent = "", a.className = "text-xs opacity-70 mt-1";
          } catch {
            a.textContent = "该语音暂不支持在线播放，可下载收听", a.className = "text-xs opacity-70 mt-1", x && x.classList.remove("hidden");
          }
        }
      }
    };
    n.addEventListener("error", () => {
      a.textContent || (a.textContent = "该语音暂不支持在线播放，可下载收听", a.className = "text-xs opacity-70 mt-1"), x && x.classList.remove("hidden"), g();
    }), n.addEventListener("emptied", () => {
      const f = n.dataset.objectUrl;
      f && (URL.revokeObjectURL(f), delete n.dataset.objectUrl);
    }), n.addEventListener("loadedmetadata", () => {
      a.textContent = "";
    }), this.#D(n, s, a, x), n.src = s, n.load();
  }
  #u(n, s = "start") {
    if (s === "start" && this.List) {
      const r = document.createElement("div");
      r.className = "chat-time-row", r.innerHTML = `<div class="chat-time-divider">${this.#f(
        n.time
      )}</div>`, this.List.appendChild(r);
    }
    const a = document.createElement("div");
    if (a.className = `chat chat-${s}`, a.dataset.messageId = String(n.ID), s === "start") {
      const r = this.#i(n), i = document.createElement("div");
      if (i.className = "chat-image avatar", i.innerHTML = r ? `<div class="w-10 rounded-md overflow-hidden bg-base-200"><img src="${r}" alt="avatar" /></div>` : '<div class="w-10 rounded-md overflow-hidden bg-base-200 chat-avatar-default"><span class="iconify mdi-light--account"></span></div>', a.appendChild(i), r) {
        const l = i.querySelector("img");
        l && l.addEventListener("error", () => {
          const y = l.parentElement;
          y && (y.innerHTML = '<span class="iconify mdi-light--account"></span>', y.classList.add("chat-avatar-default"));
        });
      }
      const c = document.createElement("div");
      c.className = "chat-header font-base chat-incoming-meta", c.innerHTML = `<span class="chat-incoming-name">${n.payload?.name || String(n.from || "对方")}</span>`, a.appendChild(c);
    }
    if (s === "end") {
      const r = String(this.avatar || "").trim(), i = document.createElement("div");
      if (i.className = "chat-image avatar", i.innerHTML = r ? `<div class="w-10 rounded-md overflow-hidden bg-base-200"><img src="${r}" alt="my-avatar" /></div>` : '<div class="w-10 rounded-md overflow-hidden bg-base-200 chat-avatar-default"><span class="iconify mdi-light--account"></span></div>', a.appendChild(i), r) {
        const c = i.querySelector("img");
        c && c.addEventListener("error", () => {
          const l = c.parentElement;
          l && (l.innerHTML = '<span class="iconify mdi-light--account"></span>', l.classList.add("chat-avatar-default"));
        });
      }
    }
    const x = document.createElement("div");
    if (x.className = "chat-bubble font-base", n.type === te.MSG_TEXT)
      x.textContent = n.payload.text;
    else if (n.type === te.MSG_AUDIO) {
      const r = document.createElement("audio"), i = this.#g(n.payload);
      if (i) {
        r.className = "w-64 max-w-full", r.controls = !0, r.preload = "metadata", r.setAttribute("playsinline", "true");
        const c = document.createElement("div"), l = document.createElement("a");
        l.className = "link text-xs mt-1 hidden", l.textContent = "下载语音", l.href = i, l.target = "_blank", l.download = `voice-${n.ID}.${this.#d(i) || "audio"}`, this.#w(r, i, c, l), x.appendChild(r), x.appendChild(c), x.appendChild(l);
      } else
        x.textContent = "语音消息（缺少可播放地址）";
    } else if (n.type === te.MSG_IMAGE) {
      const r = document.createElement("img");
      r.className = "max-h-40", r.src = n.payload.image, r.alt = n.payload.image2.name, r.onclick = () => {
        const i = document.getElementById("image-viewer"), c = document.getElementById(
          "image-viewer-img"
        );
        i && c && (c.src = r.src, i.classList.remove("hidden"), setTimeout(() => {
          i.classList.remove("opacity-0"), c.classList.remove("scale-95"), c.classList.add("scale-100");
        }, 10));
      }, x.appendChild(r);
    } else if (n.type === te.MSG_VIDEO) {
      const r = document.createElement("video");
      r.className = "max-h-40", r.controls = !0, r.src = n.payload.video.url, x.appendChild(r);
    } else if (n.type === te.MSG_FILE) {
      const r = document.createElement("a");
      r.className = "link underline", r.href = n.payload.file.url, r.target = "_blank", r.download = n.payload.filename ?? n.payload.file.filename, r.textContent = n.payload.filename ?? n.payload.file.filename, x.appendChild(r);
    } else n.type === te.MSG_CUSTOM ? x.textContent = n.payload?.text ?? "收到一条自定义消息（当前版本未识别类型）" : x.textContent = "暂不支持的消息类型";
    const u = document.createElement("div");
    u.className = "chat-bubble-wrap", u.appendChild(x);
    const g = this.#C(n);
    if (!!g.url && [te.MSG_AUDIO, te.MSG_IMAGE, te.MSG_VIDEO, te.MSG_FILE].includes(
      n.type
    )) {
      const r = document.createElement("button");
      r.type = "button", r.className = `download-bubble ${s === "end" ? "download-bubble-out" : "download-bubble-in"}`, r.title = "下载", r.innerHTML = "<span class='iconify mdi-light--download text-[13px]'></span>", r.onclick = (i) => {
        i.stopPropagation(), this.#E(g.url, g.name);
      }, u.appendChild(r);
    }
    a.appendChild(u), this.#v(a, n);
    const v = document.createElement("div");
    return v.className = "chat-footer opacity-50", v.textContent = this.#y(n, s), a.appendChild(v), this.List?.appendChild(a), this.scrollToBottomTimeout && clearTimeout(this.scrollToBottomTimeout), this.scrollToBottomTimeout = setTimeout(() => {
      this.List && this.List.scrollTo({
        behavior: "smooth",
        top: this.List.scrollHeight - this.List.clientHeight
      });
    }, 50), a;
  }
  #F() {
    const n = document.createElement("section");
    n.id = "web-im-ui", n.className = "web-im-ui font-base", n.setAttribute("data-theme", this.theme), this.Section = n;
    const s = document.createElement("button");
    s.className = "btn", s.textContent = "Open Modal", s.onclick = this.showModal.bind(this), this.showOpen && n.appendChild(s);
    const a = document.createElement("dialog");
    a.id = this.id, a.className = "modal border-none", n.appendChild(a), this.Dialog = a;
    const x = document.createElement("div");
    x.className = "modal-box overflow-hidden flex flex-col h-2/3 max-h-3/4 max-w-1/2 min-w-md", a.appendChild(x);
    const u = document.createElement("form");
    u.method = "dialog", u.innerHTML = '<button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 font-base">✕</button>', x.appendChild(u);
    const g = document.createElement("h3");
    g.className = "font-base text-lg font-bold", g.textContent = this.title, x.appendChild(g);
    const f = document.createElement("div");
    f.className = "overflow-y-auto flex-1", f.innerHTML = '<div class="chat-start chat-end hidden"></div>', x.appendChild(f), this.List = f;
    const v = document.createElement("div");
    v.className = "text-lg font-bold pt-4 flex flex-col justify-between items-center gap-2";
    const r = document.createElement("div");
    r.className = "flex  w-full gap-2 font-base", this.fileUploadProxy && v.appendChild(r);
    const i = (k = "image") => {
      const S = document.createElement("input");
      S.type = "file", S.accept = k + "/*", S.onchange = async (T) => {
        const N = T.target.files?.[0];
        if (!N || !this.to) return;
        let L = null;
        const K = new FormData();
        let P, G, V;
        K.append("file", N), P = await fetch(this.fileUploadProxy ?? "/upload/images", {
          method: "POST",
          headers: {
            "restrict-access": "true",
            Accept: "*/*"
          },
          body: K
        }), V = await P.json(), V?.data ? G = V.data : G = V, k === "image" ? L = this.service.createImageMessage({
          to: String(this.to),
          conversationType: this.type === "single" ? te.CONV_C2C : te.CONV_GROUP,
          payload: {
            name: this.name,
            image: G.src_url,
            file: "<file>",
            image2: {
              url: G.src_url,
              width: G.width,
              height: G.height,
              size: G.filesize,
              name: G.filename
            }
          }
        }) : k === "video" ? L = this.service.createVideoMessage({
          to: String(this.to),
          conversationType: this.type === "single" ? te.CONV_C2C : te.CONV_GROUP,
          payload: {
            name: this.name,
            filename: N.name,
            video: {
              size: G.filesize,
              name: N.name,
              url: G.src_url
            }
          }
        }) : k === "file" && (L = this.service.createFileMessage({
          to: String(this.to),
          conversationType: this.type === "single" ? te.CONV_C2C : te.CONV_GROUP,
          payload: {
            name: this.name,
            filename: N.name,
            file: {
              size: G.filesize,
              name: N.name,
              url: G.src_url
            }
          }
        })), L && (this.#u(L, "end"), await this.#p(L), S.remove());
      }, S.click();
    }, c = document.createElement("button");
    c.className = "btn btn-ghost btn-sm btn-circle", c.innerHTML = "<span class='iconify mynaui--image'></span>", r.appendChild(c), c.onclick = () => i("image");
    const l = document.createElement("button");
    l.className = "btn btn-ghost btn-sm btn-circle", l.innerHTML = "<span class='iconify mynaui--video'></span>", r.appendChild(l), l.onclick = () => i("video");
    const y = document.createElement("button");
    y.className = "btn btn-ghost btn-sm btn-circle", y.innerHTML = "<span class='iconify mynaui--file-text'></span>", r.appendChild(y), y.onclick = () => i("file");
    const C = document.createElement("div");
    C.className = "w-full flex gap-2", v.appendChild(C);
    const B = document.createElement("label");
    B.htmlFor = "chat-input", B.className = "m-0 p-0 sr-only", B.textContent = "Chat Input", C.appendChild(B);
    const _ = document.createElement("input");
    _.id = "chat-input", _.name = "chat-input", _.type = "text", _.placeholder = "请输入内容...", _.className = "input font-base flex-1 font-normal", C.appendChild(_), this.Input = _;
    const I = async () => {
      if (!_.value || !this.to) return;
      let k = this.service.createTextMessage({
        to: String(this.to),
        conversationType: this.type === "single" ? te.CONV_C2C : te.CONV_GROUP,
        payload: { text: _.value, name: this.name }
      });
      this.#u(k, "end"), await this.#p(k), _.value = "", _.focus();
    };
    _.onkeydown = (k) => {
      k.key === "Enter" && (k.preventDefault(), I());
    };
    const A = document.createElement("button");
    A.className = "btn p-2", A.innerHTML = "<span class='iconify mynaui--send-solid'></span>", C.appendChild(A), A.onclick = I, x.appendChild(v);
    const D = document.createElement("form");
    D.method = "dialog", D.className = "modal-backdrop", D.innerHTML = "<button>Close!</button>", a.appendChild(D), document.body.appendChild(n);
    const E = (k) => {
      k.stopPropagation(), w.classList.add("opacity-0"), M.classList.remove("scale-100"), M.classList.add("scale-95"), setTimeout(() => {
        w.classList.add("hidden"), M.src = "";
      }, 300);
    }, w = document.createElement("div");
    w.id = "image-viewer", w.className = "image-viewer fixed inset-0 z-[9999] hidden bg-black/20 backdrop-blur-sm transition-opacity duration-300 opacity-0", w.onclick = E;
    const b = document.createElement("button");
    b.className = "btn btn-sm btn-circle btn-ghost absolute right-2 top-2 font-base", b.innerHTML = "<span>✕</span>", b.onclick = E;
    const O = document.createElement("div");
    O.className = "flex items-center justify-center w-full h-full p-4";
    const M = document.createElement("img");
    M.id = "image-viewer-img", M.className = "max-w-full max-h-full object-contain shadow-2xl scale-95 transition-transform duration-300", M.alt = "Image Viewer", M.onclick = (k) => {
      k.stopPropagation();
    }, O.appendChild(M), w.appendChild(b), w.appendChild(O), a.appendChild(w), a.addEventListener("cancel", (k) => {
      w.classList.contains("hidden") || (k.preventDefault(), E(k), requestAnimationFrame(() => {
        a.showModal();
      }));
    });
  }
  showModal() {
    this.Dialog?.showModal(), this.unReadCount = 0;
  }
  closeModal() {
    this.Dialog?.close();
  }
  addUnReadListener(n) {
    setInterval(() => {
      n(this.unReadCount);
    }, 500);
  }
  toggleTheme(n) {
    n ? this.theme = n : this.theme === "light" ? this.theme = "dark" : this.theme = "light", this.Section?.setAttribute("data-theme", this.theme);
  }
  setOptions(n) {
    n.imId && n.imToken && (this.imId = n.imId, this.imToken = n.imToken, this.service.destroy(), setTimeout(() => {
      this.service.loginByToken({
        id: this.imId,
        token: this.imToken
      });
    }, 500)), n.theme && this.toggleTheme(n.theme), n.type && (this.type = n.type), n.to && (this.to = n.to), typeof n.peerAvatar == "string" && (this.peerAvatar = n.peerAvatar);
  }
  setPeerAvatar(n) {
    this.peerAvatar = n || "";
  }
  clear() {
    this.messages = [], localStorage.removeItem(We), this.List?.replaceChildren();
  }
  destroy() {
    this.Section?.remove(), this.service.destroy();
  }
}
export {
  eo as WebImUi
};
